import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
class ValidatorExpressions_RangeInt {
  get descriptor() {
    return ValidatorExpressions_RangeInt.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMin = false;
    this._min = null;
    this._hasMax = false;
    this._max = null;
  }
  isEmpty() {
    if (this._hasMin) return false;
    if (this._hasMax) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_RangeInt) {
      return value;
    }
    return ValidatorExpressions_RangeInt.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_RangeInt();
    if (json.min != null) {
      result._hasMin = true;
      result._min = JsonToInt32.fromJson(json.min);
    }
    if (json.max != null) {
      result._hasMax = true;
      result._max = JsonToInt32.fromJson(json.max);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMin) {
      result.min = JsonToInt32.toJson(this._min);
    }
    if (this._hasMax) {
      result.max = JsonToInt32.toJson(this._max);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get min() {
    return this._hasMin ? this._min : JsonToInt32.default;
  }
  get hasMin() {
    return this._hasMin;
  }
  setMin(path, value) {
    return {type: 'SET', path: path.concat(['min']), value};
  }
  deleteMin(path) {
    return {type: 'DELETE', path: path.concat(['min'])};
  }
  /**
   * @returns {number}
   */
  get max() {
    return this._hasMax ? this._max : JsonToInt32.default;
  }
  get hasMax() {
    return this._hasMax;
  }
  setMax(path, value) {
    return {type: 'SET', path: path.concat(['max']), value};
  }
  deleteMax(path) {
    return {type: 'DELETE', path: path.concat(['max'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "min": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_RangeInt(this);
              copy._hasMin = true;
              copy._min = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMin) {
                return this;
              }
              const copy = new ValidatorExpressions_RangeInt(this);
              copy._hasMin = false;
              copy._min = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "max": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_RangeInt(this);
              copy._hasMax = true;
              copy._max = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMax) {
                return this;
              }
              const copy = new ValidatorExpressions_RangeInt(this);
              copy._hasMax = false;
              copy._max = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_RangeInt} other
   * @returns {ValidatorExpressions_RangeInt}
   */
  merge(other) {
    const copy = new ValidatorExpressions_RangeInt(this);
    if (other._hasMin) {
      copy._hasMin = true;
      copy._min = other._min;
    }
    if (other._hasMax) {
      copy._hasMax = true;
      copy._max = other._max;
    }
    return copy;
  }
}
ValidatorExpressions_RangeInt.default = new ValidatorExpressions_RangeInt();
class ValidatorExpressions_RangeInt_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_RangeInt(value);
  }
  build() {
    return new ValidatorExpressions_RangeInt(this._value);
  }
  setMin(value) {
    this._value._hasMin = true;
    this._value._min = value;
    return this;
  }
  deleteMin() {
    this._value._hasMin = false;
    this._value._min = null;
    return this;
  }
  setMax(value) {
    this._value._hasMax = true;
    this._value._max = value;
    return this;
  }
  deleteMax() {
    this._value._hasMax = false;
    this._value._max = null;
    return this;
  }
}
ValidatorExpressions_RangeInt.Builder = ValidatorExpressions_RangeInt_Builder;
class ValidatorExpressions_RangeInt_WithParent {
  /**
   * @param {ValidatorExpressions_RangeInt} value
   * @param {ValidatorExpressions_RangeInt_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_RangeInt.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMin() {
    if (this._cachedHasMin === undefined) {
      if (this._value.hasMin) {
        this._cachedHasMin = true;
      } else {
        this._cachedHasMin = this._parent ? this._parent.hasMin : false;
      }
    }
    return this._cachedHasMin;
  }
  get min() {
    if (this._cachedMin === undefined) {
      if (this._value.hasMin) {
        this._cachedMin = this._value.min;
      } else {
        this._cachedMin = this._parent ? this._parent.min : this._value.min;
      }
    }
    return this._cachedMin;
  }
  get hasMax() {
    if (this._cachedHasMax === undefined) {
      if (this._value.hasMax) {
        this._cachedHasMax = true;
      } else {
        this._cachedHasMax = this._parent ? this._parent.hasMax : false;
      }
    }
    return this._cachedHasMax;
  }
  get max() {
    if (this._cachedMax === undefined) {
      if (this._value.hasMax) {
        this._cachedMax = this._value.max;
      } else {
        this._cachedMax = this._parent ? this._parent.max : this._value.max;
      }
    }
    return this._cachedMax;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_RangeInt_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_RangeInt_WithParent.default = new ValidatorExpressions_RangeInt_WithParent(ValidatorExpressions_RangeInt.default, null);
ValidatorExpressions_RangeInt.WithParent = ValidatorExpressions_RangeInt_WithParent;
class ValidatorExpressions_RangeInt_Descriptor {
  get min() {
    if (!this._min) {
      this._min = {
        name: "min",
        Name: "Min",
        number: 1,
        protoType: 5,
        protoName: "min",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._min;
  }
  get max() {
    if (!this._max) {
      this._max = {
        name: "max",
        Name: "Max",
        number: 2,
        protoType: 5,
        protoName: "max",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._max;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.min,
        this.max,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMin",
        Name: "DummyOneofForMin",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMax",
        Name: "DummyOneofForMax",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_RangeInt.descriptor = new ValidatorExpressions_RangeInt_Descriptor();
class ValidatorExpressions_RangeDouble {
  get descriptor() {
    return ValidatorExpressions_RangeDouble.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMin = false;
    this._min = null;
    this._hasMax = false;
    this._max = null;
  }
  isEmpty() {
    if (this._hasMin) return false;
    if (this._hasMax) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_RangeDouble) {
      return value;
    }
    return ValidatorExpressions_RangeDouble.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_RangeDouble();
    if (json.min != null) {
      result._hasMin = true;
      result._min = JsonToDouble.fromJson(json.min);
    }
    if (json.max != null) {
      result._hasMax = true;
      result._max = JsonToDouble.fromJson(json.max);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMin) {
      result.min = JsonToDouble.toJson(this._min);
    }
    if (this._hasMax) {
      result.max = JsonToDouble.toJson(this._max);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get min() {
    return this._hasMin ? this._min : JsonToDouble.default;
  }
  get hasMin() {
    return this._hasMin;
  }
  setMin(path, value) {
    return {type: 'SET', path: path.concat(['min']), value};
  }
  deleteMin(path) {
    return {type: 'DELETE', path: path.concat(['min'])};
  }
  /**
   * @returns {number}
   */
  get max() {
    return this._hasMax ? this._max : JsonToDouble.default;
  }
  get hasMax() {
    return this._hasMax;
  }
  setMax(path, value) {
    return {type: 'SET', path: path.concat(['max']), value};
  }
  deleteMax(path) {
    return {type: 'DELETE', path: path.concat(['max'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "min": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_RangeDouble(this);
              copy._hasMin = true;
              copy._min = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMin) {
                return this;
              }
              const copy = new ValidatorExpressions_RangeDouble(this);
              copy._hasMin = false;
              copy._min = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "max": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_RangeDouble(this);
              copy._hasMax = true;
              copy._max = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMax) {
                return this;
              }
              const copy = new ValidatorExpressions_RangeDouble(this);
              copy._hasMax = false;
              copy._max = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_RangeDouble} other
   * @returns {ValidatorExpressions_RangeDouble}
   */
  merge(other) {
    const copy = new ValidatorExpressions_RangeDouble(this);
    if (other._hasMin) {
      copy._hasMin = true;
      copy._min = other._min;
    }
    if (other._hasMax) {
      copy._hasMax = true;
      copy._max = other._max;
    }
    return copy;
  }
}
ValidatorExpressions_RangeDouble.default = new ValidatorExpressions_RangeDouble();
class ValidatorExpressions_RangeDouble_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_RangeDouble(value);
  }
  build() {
    return new ValidatorExpressions_RangeDouble(this._value);
  }
  setMin(value) {
    this._value._hasMin = true;
    this._value._min = value;
    return this;
  }
  deleteMin() {
    this._value._hasMin = false;
    this._value._min = null;
    return this;
  }
  setMax(value) {
    this._value._hasMax = true;
    this._value._max = value;
    return this;
  }
  deleteMax() {
    this._value._hasMax = false;
    this._value._max = null;
    return this;
  }
}
ValidatorExpressions_RangeDouble.Builder = ValidatorExpressions_RangeDouble_Builder;
class ValidatorExpressions_RangeDouble_WithParent {
  /**
   * @param {ValidatorExpressions_RangeDouble} value
   * @param {ValidatorExpressions_RangeDouble_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_RangeDouble.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMin() {
    if (this._cachedHasMin === undefined) {
      if (this._value.hasMin) {
        this._cachedHasMin = true;
      } else {
        this._cachedHasMin = this._parent ? this._parent.hasMin : false;
      }
    }
    return this._cachedHasMin;
  }
  get min() {
    if (this._cachedMin === undefined) {
      if (this._value.hasMin) {
        this._cachedMin = this._value.min;
      } else {
        this._cachedMin = this._parent ? this._parent.min : this._value.min;
      }
    }
    return this._cachedMin;
  }
  get hasMax() {
    if (this._cachedHasMax === undefined) {
      if (this._value.hasMax) {
        this._cachedHasMax = true;
      } else {
        this._cachedHasMax = this._parent ? this._parent.hasMax : false;
      }
    }
    return this._cachedHasMax;
  }
  get max() {
    if (this._cachedMax === undefined) {
      if (this._value.hasMax) {
        this._cachedMax = this._value.max;
      } else {
        this._cachedMax = this._parent ? this._parent.max : this._value.max;
      }
    }
    return this._cachedMax;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_RangeDouble_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_RangeDouble_WithParent.default = new ValidatorExpressions_RangeDouble_WithParent(ValidatorExpressions_RangeDouble.default, null);
ValidatorExpressions_RangeDouble.WithParent = ValidatorExpressions_RangeDouble_WithParent;
class ValidatorExpressions_RangeDouble_Descriptor {
  get min() {
    if (!this._min) {
      this._min = {
        name: "min",
        Name: "Min",
        number: 1,
        protoType: 1,
        protoName: "min",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._min;
  }
  get max() {
    if (!this._max) {
      this._max = {
        name: "max",
        Name: "Max",
        number: 2,
        protoType: 1,
        protoName: "max",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._max;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.min,
        this.max,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMin",
        Name: "DummyOneofForMin",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMax",
        Name: "DummyOneofForMax",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_RangeDouble.descriptor = new ValidatorExpressions_RangeDouble_Descriptor();
class ValidatorExpressions_BehaviorStackCountValue {
  get descriptor() {
    return ValidatorExpressions_BehaviorStackCountValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
    this._hasBehavior = false;
    this._behavior = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    if (this._hasBehavior) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_BehaviorStackCountValue) {
      return value;
    }
    return ValidatorExpressions_BehaviorStackCountValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_BehaviorStackCountValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    if (json.behavior != null) {
      result._hasBehavior = true;
      result._behavior = JsonToString.fromJson(json.behavior);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    if (this._hasBehavior) {
      result.behavior = JsonToString.toJson(this._behavior);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {string}
   */
  get behavior() {
    return this._hasBehavior ? this._behavior : JsonToString.default;
  }
  get hasBehavior() {
    return this._hasBehavior;
  }
  setBehavior(path, value) {
    return {type: 'SET', path: path.concat(['behavior']), value};
  }
  deleteBehavior(path) {
    return {type: 'DELETE', path: path.concat(['behavior'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_BehaviorStackCountValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_BehaviorStackCountValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "behavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_BehaviorStackCountValue(this);
              copy._hasBehavior = true;
              copy._behavior = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehavior) {
                return this;
              }
              const copy = new ValidatorExpressions_BehaviorStackCountValue(this);
              copy._hasBehavior = false;
              copy._behavior = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_BehaviorStackCountValue} other
   * @returns {ValidatorExpressions_BehaviorStackCountValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_BehaviorStackCountValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasBehavior) {
      copy._hasBehavior = true;
      copy._behavior = other._behavior;
    }
    return copy;
  }
}
ValidatorExpressions_BehaviorStackCountValue.default = new ValidatorExpressions_BehaviorStackCountValue();
class ValidatorExpressions_BehaviorStackCountValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_BehaviorStackCountValue(value);
  }
  build() {
    return new ValidatorExpressions_BehaviorStackCountValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setBehavior(value) {
    this._value._hasBehavior = true;
    this._value._behavior = value;
    return this;
  }
  deleteBehavior() {
    this._value._hasBehavior = false;
    this._value._behavior = null;
    return this;
  }
}
ValidatorExpressions_BehaviorStackCountValue.Builder = ValidatorExpressions_BehaviorStackCountValue_Builder;
class ValidatorExpressions_BehaviorStackCountValue_WithParent {
  /**
   * @param {ValidatorExpressions_BehaviorStackCountValue} value
   * @param {ValidatorExpressions_BehaviorStackCountValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_BehaviorStackCountValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasBehavior() {
    if (this._cachedHasBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedHasBehavior = true;
      } else {
        this._cachedHasBehavior = this._parent ? this._parent.hasBehavior : false;
      }
    }
    return this._cachedHasBehavior;
  }
  get behavior() {
    if (this._cachedBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedBehavior = this._value.behavior;
      } else {
        this._cachedBehavior = this._parent ? this._parent.behavior : this._value.behavior;
      }
    }
    return this._cachedBehavior;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_BehaviorStackCountValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_BehaviorStackCountValue_WithParent.default = new ValidatorExpressions_BehaviorStackCountValue_WithParent(ValidatorExpressions_BehaviorStackCountValue.default, null);
ValidatorExpressions_BehaviorStackCountValue.WithParent = ValidatorExpressions_BehaviorStackCountValue_WithParent;
class ValidatorExpressions_BehaviorStackCountValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get behavior() {
    if (!this._behavior) {
      this._behavior = {
        name: "behavior",
        Name: "Behavior",
        number: 2,
        protoType: 9,
        protoName: "behavior",
        type: JsonToString,
        options: {
          comments: "Which behavior is evaluated.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behavior;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.behavior,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBehavior",
        Name: "DummyOneofForBehavior",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_BehaviorStackCountValue.descriptor = new ValidatorExpressions_BehaviorStackCountValue_Descriptor();
class ValidatorExpressions_BehaviorElapsedTimeValue {
  get descriptor() {
    return ValidatorExpressions_BehaviorElapsedTimeValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
    this._hasBehavior = false;
    this._behavior = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    if (this._hasBehavior) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_BehaviorElapsedTimeValue) {
      return value;
    }
    return ValidatorExpressions_BehaviorElapsedTimeValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_BehaviorElapsedTimeValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    if (json.behavior != null) {
      result._hasBehavior = true;
      result._behavior = JsonToString.fromJson(json.behavior);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    if (this._hasBehavior) {
      result.behavior = JsonToString.toJson(this._behavior);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {string}
   */
  get behavior() {
    return this._hasBehavior ? this._behavior : JsonToString.default;
  }
  get hasBehavior() {
    return this._hasBehavior;
  }
  setBehavior(path, value) {
    return {type: 'SET', path: path.concat(['behavior']), value};
  }
  deleteBehavior(path) {
    return {type: 'DELETE', path: path.concat(['behavior'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_BehaviorElapsedTimeValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_BehaviorElapsedTimeValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "behavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_BehaviorElapsedTimeValue(this);
              copy._hasBehavior = true;
              copy._behavior = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehavior) {
                return this;
              }
              const copy = new ValidatorExpressions_BehaviorElapsedTimeValue(this);
              copy._hasBehavior = false;
              copy._behavior = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_BehaviorElapsedTimeValue} other
   * @returns {ValidatorExpressions_BehaviorElapsedTimeValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_BehaviorElapsedTimeValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasBehavior) {
      copy._hasBehavior = true;
      copy._behavior = other._behavior;
    }
    return copy;
  }
}
ValidatorExpressions_BehaviorElapsedTimeValue.default = new ValidatorExpressions_BehaviorElapsedTimeValue();
class ValidatorExpressions_BehaviorElapsedTimeValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_BehaviorElapsedTimeValue(value);
  }
  build() {
    return new ValidatorExpressions_BehaviorElapsedTimeValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setBehavior(value) {
    this._value._hasBehavior = true;
    this._value._behavior = value;
    return this;
  }
  deleteBehavior() {
    this._value._hasBehavior = false;
    this._value._behavior = null;
    return this;
  }
}
ValidatorExpressions_BehaviorElapsedTimeValue.Builder = ValidatorExpressions_BehaviorElapsedTimeValue_Builder;
class ValidatorExpressions_BehaviorElapsedTimeValue_WithParent {
  /**
   * @param {ValidatorExpressions_BehaviorElapsedTimeValue} value
   * @param {ValidatorExpressions_BehaviorElapsedTimeValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_BehaviorElapsedTimeValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasBehavior() {
    if (this._cachedHasBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedHasBehavior = true;
      } else {
        this._cachedHasBehavior = this._parent ? this._parent.hasBehavior : false;
      }
    }
    return this._cachedHasBehavior;
  }
  get behavior() {
    if (this._cachedBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedBehavior = this._value.behavior;
      } else {
        this._cachedBehavior = this._parent ? this._parent.behavior : this._value.behavior;
      }
    }
    return this._cachedBehavior;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_BehaviorElapsedTimeValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_BehaviorElapsedTimeValue_WithParent.default = new ValidatorExpressions_BehaviorElapsedTimeValue_WithParent(ValidatorExpressions_BehaviorElapsedTimeValue.default, null);
ValidatorExpressions_BehaviorElapsedTimeValue.WithParent = ValidatorExpressions_BehaviorElapsedTimeValue_WithParent;
class ValidatorExpressions_BehaviorElapsedTimeValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get behavior() {
    if (!this._behavior) {
      this._behavior = {
        name: "behavior",
        Name: "Behavior",
        number: 2,
        protoType: 9,
        protoName: "behavior",
        type: JsonToString,
        options: {
          comments: "Which behavior is evaluated.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behavior;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.behavior,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBehavior",
        Name: "DummyOneofForBehavior",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_BehaviorElapsedTimeValue.descriptor = new ValidatorExpressions_BehaviorElapsedTimeValue_Descriptor();
class ValidatorExpressions_BehaviorDurationValue {
  get descriptor() {
    return ValidatorExpressions_BehaviorDurationValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
    this._hasBehavior = false;
    this._behavior = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    if (this._hasBehavior) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_BehaviorDurationValue) {
      return value;
    }
    return ValidatorExpressions_BehaviorDurationValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_BehaviorDurationValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    if (json.behavior != null) {
      result._hasBehavior = true;
      result._behavior = JsonToString.fromJson(json.behavior);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    if (this._hasBehavior) {
      result.behavior = JsonToString.toJson(this._behavior);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {string}
   */
  get behavior() {
    return this._hasBehavior ? this._behavior : JsonToString.default;
  }
  get hasBehavior() {
    return this._hasBehavior;
  }
  setBehavior(path, value) {
    return {type: 'SET', path: path.concat(['behavior']), value};
  }
  deleteBehavior(path) {
    return {type: 'DELETE', path: path.concat(['behavior'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_BehaviorDurationValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_BehaviorDurationValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "behavior": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_BehaviorDurationValue(this);
              copy._hasBehavior = true;
              copy._behavior = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBehavior) {
                return this;
              }
              const copy = new ValidatorExpressions_BehaviorDurationValue(this);
              copy._hasBehavior = false;
              copy._behavior = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_BehaviorDurationValue} other
   * @returns {ValidatorExpressions_BehaviorDurationValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_BehaviorDurationValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasBehavior) {
      copy._hasBehavior = true;
      copy._behavior = other._behavior;
    }
    return copy;
  }
}
ValidatorExpressions_BehaviorDurationValue.default = new ValidatorExpressions_BehaviorDurationValue();
class ValidatorExpressions_BehaviorDurationValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_BehaviorDurationValue(value);
  }
  build() {
    return new ValidatorExpressions_BehaviorDurationValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setBehavior(value) {
    this._value._hasBehavior = true;
    this._value._behavior = value;
    return this;
  }
  deleteBehavior() {
    this._value._hasBehavior = false;
    this._value._behavior = null;
    return this;
  }
}
ValidatorExpressions_BehaviorDurationValue.Builder = ValidatorExpressions_BehaviorDurationValue_Builder;
class ValidatorExpressions_BehaviorDurationValue_WithParent {
  /**
   * @param {ValidatorExpressions_BehaviorDurationValue} value
   * @param {ValidatorExpressions_BehaviorDurationValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_BehaviorDurationValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasBehavior() {
    if (this._cachedHasBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedHasBehavior = true;
      } else {
        this._cachedHasBehavior = this._parent ? this._parent.hasBehavior : false;
      }
    }
    return this._cachedHasBehavior;
  }
  get behavior() {
    if (this._cachedBehavior === undefined) {
      if (this._value.hasBehavior) {
        this._cachedBehavior = this._value.behavior;
      } else {
        this._cachedBehavior = this._parent ? this._parent.behavior : this._value.behavior;
      }
    }
    return this._cachedBehavior;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_BehaviorDurationValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_BehaviorDurationValue_WithParent.default = new ValidatorExpressions_BehaviorDurationValue_WithParent(ValidatorExpressions_BehaviorDurationValue.default, null);
ValidatorExpressions_BehaviorDurationValue.WithParent = ValidatorExpressions_BehaviorDurationValue_WithParent;
class ValidatorExpressions_BehaviorDurationValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get behavior() {
    if (!this._behavior) {
      this._behavior = {
        name: "behavior",
        Name: "Behavior",
        number: 2,
        protoType: 9,
        protoName: "behavior",
        type: JsonToString,
        options: {
          comments: "Which behavior is evaluated.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behavior;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.behavior,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBehavior",
        Name: "DummyOneofForBehavior",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_BehaviorDurationValue.descriptor = new ValidatorExpressions_BehaviorDurationValue_Descriptor();
class ValidatorExpressions_TagCount {
  get descriptor() {
    return ValidatorExpressions_TagCount.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
    this._hasTagName = false;
    this._tagName = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    if (this._hasTagName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_TagCount) {
      return value;
    }
    return ValidatorExpressions_TagCount.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_TagCount();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    if (json.tagName != null) {
      result._hasTagName = true;
      result._tagName = JsonToString.fromJson(json.tagName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    if (this._hasTagName) {
      result.tagName = JsonToString.toJson(this._tagName);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {string}
   */
  get tagName() {
    return this._hasTagName ? this._tagName : JsonToString.default;
  }
  get hasTagName() {
    return this._hasTagName;
  }
  setTagName(path, value) {
    return {type: 'SET', path: path.concat(['tagName']), value};
  }
  deleteTagName(path) {
    return {type: 'DELETE', path: path.concat(['tagName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_TagCount(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_TagCount(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tagName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_TagCount(this);
              copy._hasTagName = true;
              copy._tagName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTagName) {
                return this;
              }
              const copy = new ValidatorExpressions_TagCount(this);
              copy._hasTagName = false;
              copy._tagName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_TagCount} other
   * @returns {ValidatorExpressions_TagCount}
   */
  merge(other) {
    const copy = new ValidatorExpressions_TagCount(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasTagName) {
      copy._hasTagName = true;
      copy._tagName = other._tagName;
    }
    return copy;
  }
}
ValidatorExpressions_TagCount.default = new ValidatorExpressions_TagCount();
class ValidatorExpressions_TagCount_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_TagCount(value);
  }
  build() {
    return new ValidatorExpressions_TagCount(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setTagName(value) {
    this._value._hasTagName = true;
    this._value._tagName = value;
    return this;
  }
  deleteTagName() {
    this._value._hasTagName = false;
    this._value._tagName = null;
    return this;
  }
}
ValidatorExpressions_TagCount.Builder = ValidatorExpressions_TagCount_Builder;
class ValidatorExpressions_TagCount_WithParent {
  /**
   * @param {ValidatorExpressions_TagCount} value
   * @param {ValidatorExpressions_TagCount_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_TagCount.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasTagName() {
    if (this._cachedHasTagName === undefined) {
      if (this._value.hasTagName) {
        this._cachedHasTagName = true;
      } else {
        this._cachedHasTagName = this._parent ? this._parent.hasTagName : false;
      }
    }
    return this._cachedHasTagName;
  }
  get tagName() {
    if (this._cachedTagName === undefined) {
      if (this._value.hasTagName) {
        this._cachedTagName = this._value.tagName;
      } else {
        this._cachedTagName = this._parent ? this._parent.tagName : this._value.tagName;
      }
    }
    return this._cachedTagName;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_TagCount_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_TagCount_WithParent.default = new ValidatorExpressions_TagCount_WithParent(ValidatorExpressions_TagCount.default, null);
ValidatorExpressions_TagCount.WithParent = ValidatorExpressions_TagCount_WithParent;
class ValidatorExpressions_TagCount_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get tagName() {
    if (!this._tagName) {
      this._tagName = {
        name: "tagName",
        Name: "TagName",
        number: 2,
        protoType: 9,
        protoName: "tag_name",
        type: JsonToString,
        options: {
          comments: "Which tag is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.tagName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTagName",
        Name: "DummyOneofForTagName",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_TagCount.descriptor = new ValidatorExpressions_TagCount_Descriptor();
class ValidatorExpressions_HealthValue {
  get descriptor() {
    return ValidatorExpressions_HealthValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_HealthValue) {
      return value;
    }
    return ValidatorExpressions_HealthValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_HealthValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_HealthValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_HealthValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_HealthValue} other
   * @returns {ValidatorExpressions_HealthValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_HealthValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_HealthValue.default = new ValidatorExpressions_HealthValue();
class ValidatorExpressions_HealthValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_HealthValue(value);
  }
  build() {
    return new ValidatorExpressions_HealthValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_HealthValue.Builder = ValidatorExpressions_HealthValue_Builder;
class ValidatorExpressions_HealthValue_WithParent {
  /**
   * @param {ValidatorExpressions_HealthValue} value
   * @param {ValidatorExpressions_HealthValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_HealthValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_HealthValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_HealthValue_WithParent.default = new ValidatorExpressions_HealthValue_WithParent(ValidatorExpressions_HealthValue.default, null);
ValidatorExpressions_HealthValue.WithParent = ValidatorExpressions_HealthValue_WithParent;
class ValidatorExpressions_HealthValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_HealthValue.descriptor = new ValidatorExpressions_HealthValue_Descriptor();
class ValidatorExpressions_MaxHealthValue {
  get descriptor() {
    return ValidatorExpressions_MaxHealthValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_MaxHealthValue) {
      return value;
    }
    return ValidatorExpressions_MaxHealthValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_MaxHealthValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_MaxHealthValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_MaxHealthValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_MaxHealthValue} other
   * @returns {ValidatorExpressions_MaxHealthValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_MaxHealthValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_MaxHealthValue.default = new ValidatorExpressions_MaxHealthValue();
class ValidatorExpressions_MaxHealthValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_MaxHealthValue(value);
  }
  build() {
    return new ValidatorExpressions_MaxHealthValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_MaxHealthValue.Builder = ValidatorExpressions_MaxHealthValue_Builder;
class ValidatorExpressions_MaxHealthValue_WithParent {
  /**
   * @param {ValidatorExpressions_MaxHealthValue} value
   * @param {ValidatorExpressions_MaxHealthValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_MaxHealthValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_MaxHealthValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_MaxHealthValue_WithParent.default = new ValidatorExpressions_MaxHealthValue_WithParent(ValidatorExpressions_MaxHealthValue.default, null);
ValidatorExpressions_MaxHealthValue.WithParent = ValidatorExpressions_MaxHealthValue_WithParent;
class ValidatorExpressions_MaxHealthValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_MaxHealthValue.descriptor = new ValidatorExpressions_MaxHealthValue_Descriptor();
class ValidatorExpressions_HealthFraction {
  get descriptor() {
    return ValidatorExpressions_HealthFraction.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_HealthFraction) {
      return value;
    }
    return ValidatorExpressions_HealthFraction.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_HealthFraction();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_HealthFraction(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_HealthFraction(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_HealthFraction} other
   * @returns {ValidatorExpressions_HealthFraction}
   */
  merge(other) {
    const copy = new ValidatorExpressions_HealthFraction(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_HealthFraction.default = new ValidatorExpressions_HealthFraction();
class ValidatorExpressions_HealthFraction_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_HealthFraction(value);
  }
  build() {
    return new ValidatorExpressions_HealthFraction(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_HealthFraction.Builder = ValidatorExpressions_HealthFraction_Builder;
class ValidatorExpressions_HealthFraction_WithParent {
  /**
   * @param {ValidatorExpressions_HealthFraction} value
   * @param {ValidatorExpressions_HealthFraction_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_HealthFraction.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_HealthFraction_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_HealthFraction_WithParent.default = new ValidatorExpressions_HealthFraction_WithParent(ValidatorExpressions_HealthFraction.default, null);
ValidatorExpressions_HealthFraction.WithParent = ValidatorExpressions_HealthFraction_WithParent;
class ValidatorExpressions_HealthFraction_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_HealthFraction.descriptor = new ValidatorExpressions_HealthFraction_Descriptor();
class ValidatorExpressions_ManaValue {
  get descriptor() {
    return ValidatorExpressions_ManaValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_ManaValue) {
      return value;
    }
    return ValidatorExpressions_ManaValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_ManaValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ManaValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_ManaValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_ManaValue} other
   * @returns {ValidatorExpressions_ManaValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_ManaValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_ManaValue.default = new ValidatorExpressions_ManaValue();
class ValidatorExpressions_ManaValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_ManaValue(value);
  }
  build() {
    return new ValidatorExpressions_ManaValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_ManaValue.Builder = ValidatorExpressions_ManaValue_Builder;
class ValidatorExpressions_ManaValue_WithParent {
  /**
   * @param {ValidatorExpressions_ManaValue} value
   * @param {ValidatorExpressions_ManaValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_ManaValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_ManaValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_ManaValue_WithParent.default = new ValidatorExpressions_ManaValue_WithParent(ValidatorExpressions_ManaValue.default, null);
ValidatorExpressions_ManaValue.WithParent = ValidatorExpressions_ManaValue_WithParent;
class ValidatorExpressions_ManaValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_ManaValue.descriptor = new ValidatorExpressions_ManaValue_Descriptor();
class ValidatorExpressions_MaxManaValue {
  get descriptor() {
    return ValidatorExpressions_MaxManaValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_MaxManaValue) {
      return value;
    }
    return ValidatorExpressions_MaxManaValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_MaxManaValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_MaxManaValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_MaxManaValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_MaxManaValue} other
   * @returns {ValidatorExpressions_MaxManaValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_MaxManaValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_MaxManaValue.default = new ValidatorExpressions_MaxManaValue();
class ValidatorExpressions_MaxManaValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_MaxManaValue(value);
  }
  build() {
    return new ValidatorExpressions_MaxManaValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_MaxManaValue.Builder = ValidatorExpressions_MaxManaValue_Builder;
class ValidatorExpressions_MaxManaValue_WithParent {
  /**
   * @param {ValidatorExpressions_MaxManaValue} value
   * @param {ValidatorExpressions_MaxManaValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_MaxManaValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_MaxManaValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_MaxManaValue_WithParent.default = new ValidatorExpressions_MaxManaValue_WithParent(ValidatorExpressions_MaxManaValue.default, null);
ValidatorExpressions_MaxManaValue.WithParent = ValidatorExpressions_MaxManaValue_WithParent;
class ValidatorExpressions_MaxManaValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_MaxManaValue.descriptor = new ValidatorExpressions_MaxManaValue_Descriptor();
class ValidatorExpressions_ManaFraction {
  get descriptor() {
    return ValidatorExpressions_ManaFraction.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_ManaFraction) {
      return value;
    }
    return ValidatorExpressions_ManaFraction.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_ManaFraction();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ManaFraction(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_ManaFraction(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_ManaFraction} other
   * @returns {ValidatorExpressions_ManaFraction}
   */
  merge(other) {
    const copy = new ValidatorExpressions_ManaFraction(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_ManaFraction.default = new ValidatorExpressions_ManaFraction();
class ValidatorExpressions_ManaFraction_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_ManaFraction(value);
  }
  build() {
    return new ValidatorExpressions_ManaFraction(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_ManaFraction.Builder = ValidatorExpressions_ManaFraction_Builder;
class ValidatorExpressions_ManaFraction_WithParent {
  /**
   * @param {ValidatorExpressions_ManaFraction} value
   * @param {ValidatorExpressions_ManaFraction_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_ManaFraction.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_ManaFraction_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_ManaFraction_WithParent.default = new ValidatorExpressions_ManaFraction_WithParent(ValidatorExpressions_ManaFraction.default, null);
ValidatorExpressions_ManaFraction.WithParent = ValidatorExpressions_ManaFraction_WithParent;
class ValidatorExpressions_ManaFraction_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_ManaFraction.descriptor = new ValidatorExpressions_ManaFraction_Descriptor();
class ValidatorExpressions_ShieldValue {
  get descriptor() {
    return ValidatorExpressions_ShieldValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_ShieldValue) {
      return value;
    }
    return ValidatorExpressions_ShieldValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_ShieldValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ShieldValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_ShieldValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_ShieldValue} other
   * @returns {ValidatorExpressions_ShieldValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_ShieldValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_ShieldValue.default = new ValidatorExpressions_ShieldValue();
class ValidatorExpressions_ShieldValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_ShieldValue(value);
  }
  build() {
    return new ValidatorExpressions_ShieldValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_ShieldValue.Builder = ValidatorExpressions_ShieldValue_Builder;
class ValidatorExpressions_ShieldValue_WithParent {
  /**
   * @param {ValidatorExpressions_ShieldValue} value
   * @param {ValidatorExpressions_ShieldValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_ShieldValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_ShieldValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_ShieldValue_WithParent.default = new ValidatorExpressions_ShieldValue_WithParent(ValidatorExpressions_ShieldValue.default, null);
ValidatorExpressions_ShieldValue.WithParent = ValidatorExpressions_ShieldValue_WithParent;
class ValidatorExpressions_ShieldValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_ShieldValue.descriptor = new ValidatorExpressions_ShieldValue_Descriptor();
class ValidatorExpressions_MaxShieldValue {
  get descriptor() {
    return ValidatorExpressions_MaxShieldValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_MaxShieldValue) {
      return value;
    }
    return ValidatorExpressions_MaxShieldValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_MaxShieldValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_MaxShieldValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_MaxShieldValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_MaxShieldValue} other
   * @returns {ValidatorExpressions_MaxShieldValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_MaxShieldValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_MaxShieldValue.default = new ValidatorExpressions_MaxShieldValue();
class ValidatorExpressions_MaxShieldValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_MaxShieldValue(value);
  }
  build() {
    return new ValidatorExpressions_MaxShieldValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_MaxShieldValue.Builder = ValidatorExpressions_MaxShieldValue_Builder;
class ValidatorExpressions_MaxShieldValue_WithParent {
  /**
   * @param {ValidatorExpressions_MaxShieldValue} value
   * @param {ValidatorExpressions_MaxShieldValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_MaxShieldValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_MaxShieldValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_MaxShieldValue_WithParent.default = new ValidatorExpressions_MaxShieldValue_WithParent(ValidatorExpressions_MaxShieldValue.default, null);
ValidatorExpressions_MaxShieldValue.WithParent = ValidatorExpressions_MaxShieldValue_WithParent;
class ValidatorExpressions_MaxShieldValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_MaxShieldValue.descriptor = new ValidatorExpressions_MaxShieldValue_Descriptor();
class ValidatorExpressions_ShieldFraction {
  get descriptor() {
    return ValidatorExpressions_ShieldFraction.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_ShieldFraction) {
      return value;
    }
    return ValidatorExpressions_ShieldFraction.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_ShieldFraction();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ShieldFraction(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_ShieldFraction(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_ShieldFraction} other
   * @returns {ValidatorExpressions_ShieldFraction}
   */
  merge(other) {
    const copy = new ValidatorExpressions_ShieldFraction(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_ShieldFraction.default = new ValidatorExpressions_ShieldFraction();
class ValidatorExpressions_ShieldFraction_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_ShieldFraction(value);
  }
  build() {
    return new ValidatorExpressions_ShieldFraction(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_ShieldFraction.Builder = ValidatorExpressions_ShieldFraction_Builder;
class ValidatorExpressions_ShieldFraction_WithParent {
  /**
   * @param {ValidatorExpressions_ShieldFraction} value
   * @param {ValidatorExpressions_ShieldFraction_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_ShieldFraction.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_ShieldFraction_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_ShieldFraction_WithParent.default = new ValidatorExpressions_ShieldFraction_WithParent(ValidatorExpressions_ShieldFraction.default, null);
ValidatorExpressions_ShieldFraction.WithParent = ValidatorExpressions_ShieldFraction_WithParent;
class ValidatorExpressions_ShieldFraction_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_ShieldFraction.descriptor = new ValidatorExpressions_ShieldFraction_Descriptor();
class ValidatorExpressions_UnitLevel {
  get descriptor() {
    return ValidatorExpressions_UnitLevel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_UnitLevel) {
      return value;
    }
    return ValidatorExpressions_UnitLevel.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_UnitLevel();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_UnitLevel(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_UnitLevel(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_UnitLevel} other
   * @returns {ValidatorExpressions_UnitLevel}
   */
  merge(other) {
    const copy = new ValidatorExpressions_UnitLevel(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_UnitLevel.default = new ValidatorExpressions_UnitLevel();
class ValidatorExpressions_UnitLevel_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_UnitLevel(value);
  }
  build() {
    return new ValidatorExpressions_UnitLevel(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_UnitLevel.Builder = ValidatorExpressions_UnitLevel_Builder;
class ValidatorExpressions_UnitLevel_WithParent {
  /**
   * @param {ValidatorExpressions_UnitLevel} value
   * @param {ValidatorExpressions_UnitLevel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_UnitLevel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_UnitLevel_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_UnitLevel_WithParent.default = new ValidatorExpressions_UnitLevel_WithParent(ValidatorExpressions_UnitLevel.default, null);
ValidatorExpressions_UnitLevel.WithParent = ValidatorExpressions_UnitLevel_WithParent;
class ValidatorExpressions_UnitLevel_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_UnitLevel.descriptor = new ValidatorExpressions_UnitLevel_Descriptor();
class ValidatorExpressions_UnitAbilityCooldown {
  get descriptor() {
    return ValidatorExpressions_UnitAbilityCooldown.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
    this._hasAbility = false;
    this._ability = null;
    this._hasUseCooldownPeriod = false;
    this._useCooldownPeriod = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    if (this._hasAbility) return false;
    if (this._hasUseCooldownPeriod) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_UnitAbilityCooldown) {
      return value;
    }
    return ValidatorExpressions_UnitAbilityCooldown.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_UnitAbilityCooldown();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    if (json.ability != null) {
      result._hasAbility = true;
      result._ability = JsonToString.fromJson(json.ability);
    }
    if (json.useCooldownPeriod != null) {
      result._hasUseCooldownPeriod = true;
      result._useCooldownPeriod = JsonToBoolean.fromJson(json.useCooldownPeriod);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    if (this._hasAbility) {
      result.ability = JsonToString.toJson(this._ability);
    }
    if (this._hasUseCooldownPeriod) {
      result.useCooldownPeriod = JsonToBoolean.toJson(this._useCooldownPeriod);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  /**
   * @returns {string}
   */
  get ability() {
    return this._hasAbility ? this._ability : JsonToString.default;
  }
  get hasAbility() {
    return this._hasAbility;
  }
  setAbility(path, value) {
    return {type: 'SET', path: path.concat(['ability']), value};
  }
  deleteAbility(path) {
    return {type: 'DELETE', path: path.concat(['ability'])};
  }
  /**
   * @returns {boolean}
   */
  get useCooldownPeriod() {
    return this._hasUseCooldownPeriod ? this._useCooldownPeriod : JsonToBoolean.default;
  }
  get hasUseCooldownPeriod() {
    return this._hasUseCooldownPeriod;
  }
  setUseCooldownPeriod(path, value) {
    return {type: 'SET', path: path.concat(['useCooldownPeriod']), value};
  }
  deleteUseCooldownPeriod(path) {
    return {type: 'DELETE', path: path.concat(['useCooldownPeriod'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_UnitAbilityCooldown(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_UnitAbilityCooldown(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ability": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_UnitAbilityCooldown(this);
              copy._hasAbility = true;
              copy._ability = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbility) {
                return this;
              }
              const copy = new ValidatorExpressions_UnitAbilityCooldown(this);
              copy._hasAbility = false;
              copy._ability = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useCooldownPeriod": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_UnitAbilityCooldown(this);
              copy._hasUseCooldownPeriod = true;
              copy._useCooldownPeriod = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseCooldownPeriod) {
                return this;
              }
              const copy = new ValidatorExpressions_UnitAbilityCooldown(this);
              copy._hasUseCooldownPeriod = false;
              copy._useCooldownPeriod = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_UnitAbilityCooldown} other
   * @returns {ValidatorExpressions_UnitAbilityCooldown}
   */
  merge(other) {
    const copy = new ValidatorExpressions_UnitAbilityCooldown(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    if (other._hasAbility) {
      copy._hasAbility = true;
      copy._ability = other._ability;
    }
    if (other._hasUseCooldownPeriod) {
      copy._hasUseCooldownPeriod = true;
      copy._useCooldownPeriod = other._useCooldownPeriod;
    }
    return copy;
  }
}
ValidatorExpressions_UnitAbilityCooldown.default = new ValidatorExpressions_UnitAbilityCooldown();
class ValidatorExpressions_UnitAbilityCooldown_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_UnitAbilityCooldown(value);
  }
  build() {
    return new ValidatorExpressions_UnitAbilityCooldown(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
  setAbility(value) {
    this._value._hasAbility = true;
    this._value._ability = value;
    return this;
  }
  deleteAbility() {
    this._value._hasAbility = false;
    this._value._ability = null;
    return this;
  }
  setUseCooldownPeriod(value) {
    this._value._hasUseCooldownPeriod = true;
    this._value._useCooldownPeriod = value;
    return this;
  }
  deleteUseCooldownPeriod() {
    this._value._hasUseCooldownPeriod = false;
    this._value._useCooldownPeriod = null;
    return this;
  }
}
ValidatorExpressions_UnitAbilityCooldown.Builder = ValidatorExpressions_UnitAbilityCooldown_Builder;
class ValidatorExpressions_UnitAbilityCooldown_WithParent {
  /**
   * @param {ValidatorExpressions_UnitAbilityCooldown} value
   * @param {ValidatorExpressions_UnitAbilityCooldown_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_UnitAbilityCooldown.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  get hasAbility() {
    if (this._cachedHasAbility === undefined) {
      if (this._value.hasAbility) {
        this._cachedHasAbility = true;
      } else {
        this._cachedHasAbility = this._parent ? this._parent.hasAbility : false;
      }
    }
    return this._cachedHasAbility;
  }
  get ability() {
    if (this._cachedAbility === undefined) {
      if (this._value.hasAbility) {
        this._cachedAbility = this._value.ability;
      } else {
        this._cachedAbility = this._parent ? this._parent.ability : this._value.ability;
      }
    }
    return this._cachedAbility;
  }
  get hasUseCooldownPeriod() {
    if (this._cachedHasUseCooldownPeriod === undefined) {
      if (this._value.hasUseCooldownPeriod) {
        this._cachedHasUseCooldownPeriod = true;
      } else {
        this._cachedHasUseCooldownPeriod = this._parent ? this._parent.hasUseCooldownPeriod : false;
      }
    }
    return this._cachedHasUseCooldownPeriod;
  }
  get useCooldownPeriod() {
    if (this._cachedUseCooldownPeriod === undefined) {
      if (this._value.hasUseCooldownPeriod) {
        this._cachedUseCooldownPeriod = this._value.useCooldownPeriod;
      } else {
        this._cachedUseCooldownPeriod = this._parent ? this._parent.useCooldownPeriod : this._value.useCooldownPeriod;
      }
    }
    return this._cachedUseCooldownPeriod;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_UnitAbilityCooldown_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_UnitAbilityCooldown_WithParent.default = new ValidatorExpressions_UnitAbilityCooldown_WithParent(ValidatorExpressions_UnitAbilityCooldown.default, null);
ValidatorExpressions_UnitAbilityCooldown.WithParent = ValidatorExpressions_UnitAbilityCooldown_WithParent;
class ValidatorExpressions_UnitAbilityCooldown_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get ability() {
    if (!this._ability) {
      this._ability = {
        name: "ability",
        Name: "Ability",
        number: 2,
        protoType: 9,
        protoName: "ability",
        type: JsonToString,
        options: {
          comments: "Which ablity is evaluated.",
          valueDropdown: "SupportedAbilityListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ability;
  }
  get useCooldownPeriod() {
    if (!this._useCooldownPeriod) {
      this._useCooldownPeriod = {
        name: "useCooldownPeriod",
        Name: "UseCooldownPeriod",
        number: 3,
        protoType: 8,
        protoName: "use_cooldown_period",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the expression returns the total cooldown duration, rather than time remaining.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useCooldownPeriod;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
        this.ability,
        this.useCooldownPeriod,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbility",
        Name: "DummyOneofForAbility",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseCooldownPeriod",
        Name: "DummyOneofForUseCooldownPeriod",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_UnitAbilityCooldown.descriptor = new ValidatorExpressions_UnitAbilityCooldown_Descriptor();
class ValidatorExpressions_AbilityLevel {
  get descriptor() {
    return ValidatorExpressions_AbilityLevel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAbility = false;
    this._ability = null;
  }
  isEmpty() {
    if (this._hasAbility) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_AbilityLevel) {
      return value;
    }
    return ValidatorExpressions_AbilityLevel.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_AbilityLevel();
    if (json.ability != null) {
      result._hasAbility = true;
      result._ability = JsonToString.fromJson(json.ability);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAbility) {
      result.ability = JsonToString.toJson(this._ability);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get ability() {
    return this._hasAbility ? this._ability : JsonToString.default;
  }
  get hasAbility() {
    return this._hasAbility;
  }
  setAbility(path, value) {
    return {type: 'SET', path: path.concat(['ability']), value};
  }
  deleteAbility(path) {
    return {type: 'DELETE', path: path.concat(['ability'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "ability": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_AbilityLevel(this);
              copy._hasAbility = true;
              copy._ability = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbility) {
                return this;
              }
              const copy = new ValidatorExpressions_AbilityLevel(this);
              copy._hasAbility = false;
              copy._ability = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_AbilityLevel} other
   * @returns {ValidatorExpressions_AbilityLevel}
   */
  merge(other) {
    const copy = new ValidatorExpressions_AbilityLevel(this);
    if (other._hasAbility) {
      copy._hasAbility = true;
      copy._ability = other._ability;
    }
    return copy;
  }
}
ValidatorExpressions_AbilityLevel.default = new ValidatorExpressions_AbilityLevel();
class ValidatorExpressions_AbilityLevel_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_AbilityLevel(value);
  }
  build() {
    return new ValidatorExpressions_AbilityLevel(this._value);
  }
  setAbility(value) {
    this._value._hasAbility = true;
    this._value._ability = value;
    return this;
  }
  deleteAbility() {
    this._value._hasAbility = false;
    this._value._ability = null;
    return this;
  }
}
ValidatorExpressions_AbilityLevel.Builder = ValidatorExpressions_AbilityLevel_Builder;
class ValidatorExpressions_AbilityLevel_WithParent {
  /**
   * @param {ValidatorExpressions_AbilityLevel} value
   * @param {ValidatorExpressions_AbilityLevel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_AbilityLevel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAbility() {
    if (this._cachedHasAbility === undefined) {
      if (this._value.hasAbility) {
        this._cachedHasAbility = true;
      } else {
        this._cachedHasAbility = this._parent ? this._parent.hasAbility : false;
      }
    }
    return this._cachedHasAbility;
  }
  get ability() {
    if (this._cachedAbility === undefined) {
      if (this._value.hasAbility) {
        this._cachedAbility = this._value.ability;
      } else {
        this._cachedAbility = this._parent ? this._parent.ability : this._value.ability;
      }
    }
    return this._cachedAbility;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_AbilityLevel_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_AbilityLevel_WithParent.default = new ValidatorExpressions_AbilityLevel_WithParent(ValidatorExpressions_AbilityLevel.default, null);
ValidatorExpressions_AbilityLevel.WithParent = ValidatorExpressions_AbilityLevel_WithParent;
class ValidatorExpressions_AbilityLevel_Descriptor {
  get ability() {
    if (!this._ability) {
      this._ability = {
        name: "ability",
        Name: "Ability",
        number: 1,
        protoType: 9,
        protoName: "ability",
        type: JsonToString,
        options: {
          comments: "Which ablity is evaluated.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ability;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.ability,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAbility",
        Name: "DummyOneofForAbility",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_AbilityLevel.descriptor = new ValidatorExpressions_AbilityLevel_Descriptor();
class ValidatorExpressions_DataUpgradeLevel {
  get descriptor() {
    return ValidatorExpressions_DataUpgradeLevel.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDataUpgrade = false;
    this._dataUpgrade = null;
  }
  isEmpty() {
    if (this._hasDataUpgrade) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_DataUpgradeLevel) {
      return value;
    }
    return ValidatorExpressions_DataUpgradeLevel.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_DataUpgradeLevel();
    if (json.dataUpgrade != null) {
      result._hasDataUpgrade = true;
      result._dataUpgrade = JsonToString.fromJson(json.dataUpgrade);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDataUpgrade) {
      result.dataUpgrade = JsonToString.toJson(this._dataUpgrade);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get dataUpgrade() {
    return this._hasDataUpgrade ? this._dataUpgrade : JsonToString.default;
  }
  get hasDataUpgrade() {
    return this._hasDataUpgrade;
  }
  setDataUpgrade(path, value) {
    return {type: 'SET', path: path.concat(['dataUpgrade']), value};
  }
  deleteDataUpgrade(path) {
    return {type: 'DELETE', path: path.concat(['dataUpgrade'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dataUpgrade": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_DataUpgradeLevel(this);
              copy._hasDataUpgrade = true;
              copy._dataUpgrade = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDataUpgrade) {
                return this;
              }
              const copy = new ValidatorExpressions_DataUpgradeLevel(this);
              copy._hasDataUpgrade = false;
              copy._dataUpgrade = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_DataUpgradeLevel} other
   * @returns {ValidatorExpressions_DataUpgradeLevel}
   */
  merge(other) {
    const copy = new ValidatorExpressions_DataUpgradeLevel(this);
    if (other._hasDataUpgrade) {
      copy._hasDataUpgrade = true;
      copy._dataUpgrade = other._dataUpgrade;
    }
    return copy;
  }
}
ValidatorExpressions_DataUpgradeLevel.default = new ValidatorExpressions_DataUpgradeLevel();
class ValidatorExpressions_DataUpgradeLevel_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_DataUpgradeLevel(value);
  }
  build() {
    return new ValidatorExpressions_DataUpgradeLevel(this._value);
  }
  setDataUpgrade(value) {
    this._value._hasDataUpgrade = true;
    this._value._dataUpgrade = value;
    return this;
  }
  deleteDataUpgrade() {
    this._value._hasDataUpgrade = false;
    this._value._dataUpgrade = null;
    return this;
  }
}
ValidatorExpressions_DataUpgradeLevel.Builder = ValidatorExpressions_DataUpgradeLevel_Builder;
class ValidatorExpressions_DataUpgradeLevel_WithParent {
  /**
   * @param {ValidatorExpressions_DataUpgradeLevel} value
   * @param {ValidatorExpressions_DataUpgradeLevel_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_DataUpgradeLevel.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDataUpgrade() {
    if (this._cachedHasDataUpgrade === undefined) {
      if (this._value.hasDataUpgrade) {
        this._cachedHasDataUpgrade = true;
      } else {
        this._cachedHasDataUpgrade = this._parent ? this._parent.hasDataUpgrade : false;
      }
    }
    return this._cachedHasDataUpgrade;
  }
  get dataUpgrade() {
    if (this._cachedDataUpgrade === undefined) {
      if (this._value.hasDataUpgrade) {
        this._cachedDataUpgrade = this._value.dataUpgrade;
      } else {
        this._cachedDataUpgrade = this._parent ? this._parent.dataUpgrade : this._value.dataUpgrade;
      }
    }
    return this._cachedDataUpgrade;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_DataUpgradeLevel_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_DataUpgradeLevel_WithParent.default = new ValidatorExpressions_DataUpgradeLevel_WithParent(ValidatorExpressions_DataUpgradeLevel.default, null);
ValidatorExpressions_DataUpgradeLevel.WithParent = ValidatorExpressions_DataUpgradeLevel_WithParent;
class ValidatorExpressions_DataUpgradeLevel_Descriptor {
  get dataUpgrade() {
    if (!this._dataUpgrade) {
      this._dataUpgrade = {
        name: "dataUpgrade",
        Name: "DataUpgrade",
        number: 1,
        protoType: 9,
        protoName: "data_upgrade",
        type: JsonToString,
        options: {
          comments: "Which upgrade is evaluated.",
          valueDropdown: "SupportedDataUpgrades",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dataUpgrade;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dataUpgrade,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDataUpgrade",
        Name: "DummyOneofForDataUpgrade",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_DataUpgradeLevel.descriptor = new ValidatorExpressions_DataUpgradeLevel_Descriptor();
class ValidatorExpressions_ConstantValue {
  get descriptor() {
    return ValidatorExpressions_ConstantValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofValueTypeCase = 0;
    this._oneofValueTypeValue = null;
  }
  isEmpty() {
    if (this._oneofValueTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_ConstantValue) {
      return value;
    }
    return ValidatorExpressions_ConstantValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_ConstantValue();
    if (json.boolValue != null) {
      result._oneofValueTypeCase = 1;
      result._oneofValueTypeValue = JsonToBoolean.fromJson(json.boolValue);
    }
    if (json.int32Value != null) {
      result._oneofValueTypeCase = 2;
      result._oneofValueTypeValue = JsonToInt32.fromJson(json.int32Value);
    }
    if (json.doubleValue != null) {
      result._oneofValueTypeCase = 3;
      result._oneofValueTypeValue = JsonToDouble.fromJson(json.doubleValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofValueTypeCase) {
      case 1:
        result.boolValue = JsonToBoolean.toJson(this._oneofValueTypeValue);
        break;
      case 2:
        result.int32Value = JsonToInt32.toJson(this._oneofValueTypeValue);
        break;
      case 3:
        result.doubleValue = JsonToDouble.toJson(this._oneofValueTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofValueTypeCase() {
    return this._oneofValueTypeCase;
  }
  deleteOneofValueType(path) {
    switch (this._oneofValueTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['boolValue'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['int32Value'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['doubleValue'])};
      }
    }
  }
  /**
   * @returns {boolean}
   */
  get boolValue() {
    return this._oneofValueTypeCase === 1 ? this._oneofValueTypeValue : JsonToBoolean.default;
  }
  setBoolValue(path, value) {
    return {type: 'SET', path: path.concat(['boolValue']), value};
  }
  deleteBoolValue(path) {
    return {type: 'DELETE', path: path.concat(['boolValue'])};
  }
  /**
   * @returns {number}
   */
  get int32Value() {
    return this._oneofValueTypeCase === 2 ? this._oneofValueTypeValue : JsonToInt32.default;
  }
  setInt32Value(path, value) {
    return {type: 'SET', path: path.concat(['int32Value']), value};
  }
  deleteInt32Value(path) {
    return {type: 'DELETE', path: path.concat(['int32Value'])};
  }
  /**
   * @returns {number}
   */
  get doubleValue() {
    return this._oneofValueTypeCase === 3 ? this._oneofValueTypeValue : JsonToDouble.default;
  }
  setDoubleValue(path, value) {
    return {type: 'SET', path: path.concat(['doubleValue']), value};
  }
  deleteDoubleValue(path) {
    return {type: 'DELETE', path: path.concat(['doubleValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "boolValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ConstantValue(this);
              copy._oneofValueTypeCase = 1;
              copy._oneofValueTypeValue = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 1) {
                return this;
              }
              const copy = new ValidatorExpressions_ConstantValue(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "int32Value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ConstantValue(this);
              copy._oneofValueTypeCase = 2;
              copy._oneofValueTypeValue = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 2) {
                return this;
              }
              const copy = new ValidatorExpressions_ConstantValue(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "doubleValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ConstantValue(this);
              copy._oneofValueTypeCase = 3;
              copy._oneofValueTypeValue = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 3) {
                return this;
              }
              const copy = new ValidatorExpressions_ConstantValue(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_ConstantValue} other
   * @returns {ValidatorExpressions_ConstantValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_ConstantValue(this);
    if (other._oneofValueTypeCase === 1) {
      copy._oneofValueTypeCase = 1;
      copy._oneofValueTypeValue = other._oneofValueTypeValue;
    }
    if (other._oneofValueTypeCase === 1) {
      copy._oneofValueTypeCase = 1;
      copy._oneofValueTypeValue = other._oneofValueTypeValue;
    }
    if (other._oneofValueTypeCase === 1) {
      copy._oneofValueTypeCase = 1;
      copy._oneofValueTypeValue = other._oneofValueTypeValue;
    }
    return copy;
  }
}
ValidatorExpressions_ConstantValue.default = new ValidatorExpressions_ConstantValue();
class ValidatorExpressions_ConstantValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_ConstantValue(value);
  }
  build() {
    return new ValidatorExpressions_ConstantValue(this._value);
  }
  clearoneofValueType() {
    this._value._oneofValueTypeCase = 0;
    this._value._oneofValueTypeValue = null;
    return this;
  }
  setBoolValue(value) {
    this._value._oneofValueTypeCase = 1;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setInt32Value(value) {
    this._value._oneofValueTypeCase = 2;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setDoubleValue(value) {
    this._value._oneofValueTypeCase = 3;
    this._value._oneofValueTypeValue = value;
    return this;
  }
}
ValidatorExpressions_ConstantValue.Builder = ValidatorExpressions_ConstantValue_Builder;
class ValidatorExpressions_ConstantValue_WithParent {
  /**
   * @param {ValidatorExpressions_ConstantValue} value
   * @param {ValidatorExpressions_ConstantValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_ConstantValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofValueTypeCase() {
    if (this._cachedoneofValueTypeCase === undefined) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedoneofValueTypeCase = this._parent ? this._parent.oneofValueTypeCase : 0;
      } else {
        this._cachedoneofValueTypeCase = this._value._oneofValueTypeCase;
      }
    }
    return this._cachedoneofValueTypeCase;
  }
  get boolValue() {
    if (!this._cachedBoolValue) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedBoolValue = this._parent ? this._parent.boolValue : this._value.boolValue;
      } else {
        this._cachedBoolValue = this._value.boolValue;
      }
    }
    return this._cachedBoolValue;
  }
  get int32Value() {
    if (!this._cachedInt32Value) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedInt32Value = this._parent ? this._parent.int32Value : this._value.int32Value;
      } else {
        this._cachedInt32Value = this._value.int32Value;
      }
    }
    return this._cachedInt32Value;
  }
  get doubleValue() {
    if (!this._cachedDoubleValue) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedDoubleValue = this._parent ? this._parent.doubleValue : this._value.doubleValue;
      } else {
        this._cachedDoubleValue = this._value.doubleValue;
      }
    }
    return this._cachedDoubleValue;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_ConstantValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_ConstantValue_WithParent.default = new ValidatorExpressions_ConstantValue_WithParent(ValidatorExpressions_ConstantValue.default, null);
ValidatorExpressions_ConstantValue.WithParent = ValidatorExpressions_ConstantValue_WithParent;
class ValidatorExpressions_ConstantValue_Descriptor {
  get boolValue() {
    if (!this._boolValue) {
      this._boolValue = {
        name: "boolValue",
        Name: "BoolValue",
        number: 1,
        protoType: 8,
        protoName: "bool_value",
        oneofIndex: 0,
        type: JsonToBoolean,
        options: {
          comments: "Returns true or false.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boolValue;
  }
  get int32Value() {
    if (!this._int32Value) {
      this._int32Value = {
        name: "int32Value",
        Name: "Int32Value",
        number: 2,
        protoType: 5,
        protoName: "int32_value",
        oneofIndex: 0,
        type: JsonToInt32,
        options: {
          comments: "Returns an integer value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._int32Value;
  }
  get doubleValue() {
    if (!this._doubleValue) {
      this._doubleValue = {
        name: "doubleValue",
        Name: "DoubleValue",
        number: 3,
        protoType: 1,
        protoName: "double_value",
        oneofIndex: 0,
        type: JsonToDouble,
        options: {
          comments: "Returns a floating point number (with decimal).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._doubleValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.boolValue,
        this.int32Value,
        this.doubleValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofValueType",
        Name: "OneofValueType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_ConstantValue.descriptor = new ValidatorExpressions_ConstantValue_Descriptor();
class ValidatorExpressions_DamageAmountValue {
  get descriptor() {
    return ValidatorExpressions_DamageAmountValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMultiplier = false;
    this._multiplier = null;
  }
  isEmpty() {
    if (this._hasMultiplier) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_DamageAmountValue) {
      return value;
    }
    return ValidatorExpressions_DamageAmountValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_DamageAmountValue();
    if (json.multiplier != null) {
      result._hasMultiplier = true;
      result._multiplier = JsonToDouble.fromJson(json.multiplier);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMultiplier) {
      result.multiplier = JsonToDouble.toJson(this._multiplier);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get multiplier() {
    return this._hasMultiplier ? this._multiplier : JsonToDouble.default;
  }
  get hasMultiplier() {
    return this._hasMultiplier;
  }
  setMultiplier(path, value) {
    return {type: 'SET', path: path.concat(['multiplier']), value};
  }
  deleteMultiplier(path) {
    return {type: 'DELETE', path: path.concat(['multiplier'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "multiplier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_DamageAmountValue(this);
              copy._hasMultiplier = true;
              copy._multiplier = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMultiplier) {
                return this;
              }
              const copy = new ValidatorExpressions_DamageAmountValue(this);
              copy._hasMultiplier = false;
              copy._multiplier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_DamageAmountValue} other
   * @returns {ValidatorExpressions_DamageAmountValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_DamageAmountValue(this);
    if (other._hasMultiplier) {
      copy._hasMultiplier = true;
      copy._multiplier = other._multiplier;
    }
    return copy;
  }
}
ValidatorExpressions_DamageAmountValue.default = new ValidatorExpressions_DamageAmountValue();
class ValidatorExpressions_DamageAmountValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_DamageAmountValue(value);
  }
  build() {
    return new ValidatorExpressions_DamageAmountValue(this._value);
  }
  setMultiplier(value) {
    this._value._hasMultiplier = true;
    this._value._multiplier = value;
    return this;
  }
  deleteMultiplier() {
    this._value._hasMultiplier = false;
    this._value._multiplier = null;
    return this;
  }
}
ValidatorExpressions_DamageAmountValue.Builder = ValidatorExpressions_DamageAmountValue_Builder;
class ValidatorExpressions_DamageAmountValue_WithParent {
  /**
   * @param {ValidatorExpressions_DamageAmountValue} value
   * @param {ValidatorExpressions_DamageAmountValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_DamageAmountValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMultiplier() {
    if (this._cachedHasMultiplier === undefined) {
      if (this._value.hasMultiplier) {
        this._cachedHasMultiplier = true;
      } else {
        this._cachedHasMultiplier = this._parent ? this._parent.hasMultiplier : false;
      }
    }
    return this._cachedHasMultiplier;
  }
  get multiplier() {
    if (this._cachedMultiplier === undefined) {
      if (this._value.hasMultiplier) {
        this._cachedMultiplier = this._value.multiplier;
      } else {
        this._cachedMultiplier = this._parent ? this._parent.multiplier : this._value.multiplier;
      }
    }
    return this._cachedMultiplier;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_DamageAmountValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_DamageAmountValue_WithParent.default = new ValidatorExpressions_DamageAmountValue_WithParent(ValidatorExpressions_DamageAmountValue.default, null);
ValidatorExpressions_DamageAmountValue.WithParent = ValidatorExpressions_DamageAmountValue_WithParent;
class ValidatorExpressions_DamageAmountValue_Descriptor {
  get multiplier() {
    if (!this._multiplier) {
      this._multiplier = {
        name: "multiplier",
        Name: "Multiplier",
        number: 1,
        protoType: 1,
        protoName: "multiplier",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiplier;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.multiplier,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMultiplier",
        Name: "DummyOneofForMultiplier",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_DamageAmountValue.descriptor = new ValidatorExpressions_DamageAmountValue_Descriptor();
class ValidatorExpressions_HealAmountValue {
  get descriptor() {
    return ValidatorExpressions_HealAmountValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMultiplier = false;
    this._multiplier = null;
  }
  isEmpty() {
    if (this._hasMultiplier) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_HealAmountValue) {
      return value;
    }
    return ValidatorExpressions_HealAmountValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_HealAmountValue();
    if (json.multiplier != null) {
      result._hasMultiplier = true;
      result._multiplier = JsonToDouble.fromJson(json.multiplier);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMultiplier) {
      result.multiplier = JsonToDouble.toJson(this._multiplier);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get multiplier() {
    return this._hasMultiplier ? this._multiplier : JsonToDouble.default;
  }
  get hasMultiplier() {
    return this._hasMultiplier;
  }
  setMultiplier(path, value) {
    return {type: 'SET', path: path.concat(['multiplier']), value};
  }
  deleteMultiplier(path) {
    return {type: 'DELETE', path: path.concat(['multiplier'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "multiplier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_HealAmountValue(this);
              copy._hasMultiplier = true;
              copy._multiplier = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMultiplier) {
                return this;
              }
              const copy = new ValidatorExpressions_HealAmountValue(this);
              copy._hasMultiplier = false;
              copy._multiplier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_HealAmountValue} other
   * @returns {ValidatorExpressions_HealAmountValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_HealAmountValue(this);
    if (other._hasMultiplier) {
      copy._hasMultiplier = true;
      copy._multiplier = other._multiplier;
    }
    return copy;
  }
}
ValidatorExpressions_HealAmountValue.default = new ValidatorExpressions_HealAmountValue();
class ValidatorExpressions_HealAmountValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_HealAmountValue(value);
  }
  build() {
    return new ValidatorExpressions_HealAmountValue(this._value);
  }
  setMultiplier(value) {
    this._value._hasMultiplier = true;
    this._value._multiplier = value;
    return this;
  }
  deleteMultiplier() {
    this._value._hasMultiplier = false;
    this._value._multiplier = null;
    return this;
  }
}
ValidatorExpressions_HealAmountValue.Builder = ValidatorExpressions_HealAmountValue_Builder;
class ValidatorExpressions_HealAmountValue_WithParent {
  /**
   * @param {ValidatorExpressions_HealAmountValue} value
   * @param {ValidatorExpressions_HealAmountValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_HealAmountValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMultiplier() {
    if (this._cachedHasMultiplier === undefined) {
      if (this._value.hasMultiplier) {
        this._cachedHasMultiplier = true;
      } else {
        this._cachedHasMultiplier = this._parent ? this._parent.hasMultiplier : false;
      }
    }
    return this._cachedHasMultiplier;
  }
  get multiplier() {
    if (this._cachedMultiplier === undefined) {
      if (this._value.hasMultiplier) {
        this._cachedMultiplier = this._value.multiplier;
      } else {
        this._cachedMultiplier = this._parent ? this._parent.multiplier : this._value.multiplier;
      }
    }
    return this._cachedMultiplier;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_HealAmountValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_HealAmountValue_WithParent.default = new ValidatorExpressions_HealAmountValue_WithParent(ValidatorExpressions_HealAmountValue.default, null);
ValidatorExpressions_HealAmountValue.WithParent = ValidatorExpressions_HealAmountValue_WithParent;
class ValidatorExpressions_HealAmountValue_Descriptor {
  get multiplier() {
    if (!this._multiplier) {
      this._multiplier = {
        name: "multiplier",
        Name: "Multiplier",
        number: 1,
        protoType: 1,
        protoName: "multiplier",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiplier;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.multiplier,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMultiplier",
        Name: "DummyOneofForMultiplier",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_HealAmountValue.descriptor = new ValidatorExpressions_HealAmountValue_Descriptor();
class ValidatorExpressions_RemainingPathDistanceValue {
  get descriptor() {
    return ValidatorExpressions_RemainingPathDistanceValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnit = false;
    this._unit = null;
  }
  isEmpty() {
    if (this._hasUnit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_RemainingPathDistanceValue) {
      return value;
    }
    return ValidatorExpressions_RemainingPathDistanceValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_RemainingPathDistanceValue();
    if (json.unit != null) {
      result._hasUnit = true;
      result._unit = ValidatorExpressions_UnitLocation.fromJson(json.unit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnit) {
      result.unit = ValidatorExpressions_UnitLocation.toJson(this._unit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get unit() {
    return this._hasUnit ? this._unit : ValidatorExpressions_UnitLocation.default;
  }
  get hasUnit() {
    return this._hasUnit;
  }
  setUnit(path, value) {
    return {type: 'SET', path: path.concat(['unit']), value};
  }
  deleteUnit(path) {
    return {type: 'DELETE', path: path.concat(['unit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_RemainingPathDistanceValue(this);
              copy._hasUnit = true;
              copy._unit = ValidatorExpressions_UnitLocation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnit) {
                return this;
              }
              const copy = new ValidatorExpressions_RemainingPathDistanceValue(this);
              copy._hasUnit = false;
              copy._unit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_RemainingPathDistanceValue} other
   * @returns {ValidatorExpressions_RemainingPathDistanceValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_RemainingPathDistanceValue(this);
    if (other._hasUnit) {
      copy._hasUnit = true;
      copy._unit = other._unit;
    }
    return copy;
  }
}
ValidatorExpressions_RemainingPathDistanceValue.default = new ValidatorExpressions_RemainingPathDistanceValue();
class ValidatorExpressions_RemainingPathDistanceValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_RemainingPathDistanceValue(value);
  }
  build() {
    return new ValidatorExpressions_RemainingPathDistanceValue(this._value);
  }
  setUnit(value) {
    this._value._hasUnit = true;
    this._value._unit = value;
    return this;
  }
  deleteUnit() {
    this._value._hasUnit = false;
    this._value._unit = null;
    return this;
  }
}
ValidatorExpressions_RemainingPathDistanceValue.Builder = ValidatorExpressions_RemainingPathDistanceValue_Builder;
class ValidatorExpressions_RemainingPathDistanceValue_WithParent {
  /**
   * @param {ValidatorExpressions_RemainingPathDistanceValue} value
   * @param {ValidatorExpressions_RemainingPathDistanceValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_RemainingPathDistanceValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnit() {
    if (this._cachedHasUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedHasUnit = true;
      } else {
        this._cachedHasUnit = this._parent ? this._parent.hasUnit : false;
      }
    }
    return this._cachedHasUnit;
  }
  get unit() {
    if (this._cachedUnit === undefined) {
      if (this._value.hasUnit) {
        this._cachedUnit = this._value.unit;
      } else {
        this._cachedUnit = this._parent ? this._parent.unit : this._value.unit;
      }
    }
    return this._cachedUnit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_RemainingPathDistanceValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_RemainingPathDistanceValue_WithParent.default = new ValidatorExpressions_RemainingPathDistanceValue_WithParent(ValidatorExpressions_RemainingPathDistanceValue.default, null);
ValidatorExpressions_RemainingPathDistanceValue.WithParent = ValidatorExpressions_RemainingPathDistanceValue_WithParent;
class ValidatorExpressions_RemainingPathDistanceValue_Descriptor {
  get unit() {
    if (!this._unit) {
      this._unit = {
        name: "unit",
        Name: "Unit",
        number: 1,
        protoType: 14,
        protoName: "unit",
        type: ValidatorExpressions_UnitLocation,
        options: {
          comments: "Which unit is evaluated.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnit",
        Name: "DummyOneofForUnit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_RemainingPathDistanceValue.descriptor = new ValidatorExpressions_RemainingPathDistanceValue_Descriptor();
class ValidatorExpressions_RandomValue {
  get descriptor() {
    return ValidatorExpressions_RandomValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofValueTypeCase = 0;
    this._oneofValueTypeValue = null;
  }
  isEmpty() {
    if (this._oneofValueTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_RandomValue) {
      return value;
    }
    return ValidatorExpressions_RandomValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_RandomValue();
    if (json.int32Value != null) {
      result._oneofValueTypeCase = 1;
      result._oneofValueTypeValue = ValidatorExpressions_RangeInt.fromJson(json.int32Value);
    }
    if (json.doubleValue != null) {
      result._oneofValueTypeCase = 2;
      result._oneofValueTypeValue = ValidatorExpressions_RangeDouble.fromJson(json.doubleValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofValueTypeCase) {
      case 1:
        result.int32Value = ValidatorExpressions_RangeInt.toJson(this._oneofValueTypeValue);
        break;
      case 2:
        result.doubleValue = ValidatorExpressions_RangeDouble.toJson(this._oneofValueTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofValueTypeCase() {
    return this._oneofValueTypeCase;
  }
  deleteOneofValueType(path) {
    switch (this._oneofValueTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['int32Value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['doubleValue'])};
      }
    }
  }
  /**
   * @returns {ValidatorExpressions_RangeInt}
   */
  get int32Value() {
    return this._oneofValueTypeCase === 1 ? this._oneofValueTypeValue : ValidatorExpressions_RangeInt.default;
  }
  setInt32Value(path, value) {
    return {type: 'SET', path: path.concat(['int32Value']), value: value.toJson()};
  }
  deleteInt32Value(path) {
    return {type: 'DELETE', path: path.concat(['int32Value'])};
  }
  /**
   * @returns {ValidatorExpressions_RangeDouble}
   */
  get doubleValue() {
    return this._oneofValueTypeCase === 2 ? this._oneofValueTypeValue : ValidatorExpressions_RangeDouble.default;
  }
  setDoubleValue(path, value) {
    return {type: 'SET', path: path.concat(['doubleValue']), value: value.toJson()};
  }
  deleteDoubleValue(path) {
    return {type: 'DELETE', path: path.concat(['doubleValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "int32Value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_RandomValue(this);
              copy._oneofValueTypeCase = 1;
              copy._oneofValueTypeValue = ValidatorExpressions_RangeInt.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 1) {
                return this;
              }
              const copy = new ValidatorExpressions_RandomValue(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 1) {
            const copy = new ValidatorExpressions_RandomValue(this);
            copy._oneofValueTypeCase = 1;
            copy._oneofValueTypeValue = ValidatorExpressions_RangeInt.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.int32Value.apply(type, path.slice(1), value);
          if (newValue === this.int32Value) {
            return this;
          }
          const copy = new ValidatorExpressions_RandomValue(this);
          copy._oneofValueTypeCase = 1;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "doubleValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_RandomValue(this);
              copy._oneofValueTypeCase = 2;
              copy._oneofValueTypeValue = ValidatorExpressions_RangeDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 2) {
                return this;
              }
              const copy = new ValidatorExpressions_RandomValue(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 2) {
            const copy = new ValidatorExpressions_RandomValue(this);
            copy._oneofValueTypeCase = 2;
            copy._oneofValueTypeValue = ValidatorExpressions_RangeDouble.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.doubleValue.apply(type, path.slice(1), value);
          if (newValue === this.doubleValue) {
            return this;
          }
          const copy = new ValidatorExpressions_RandomValue(this);
          copy._oneofValueTypeCase = 2;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_RandomValue} other
   * @returns {ValidatorExpressions_RandomValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_RandomValue(this);
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    return copy;
  }
}
ValidatorExpressions_RandomValue.default = new ValidatorExpressions_RandomValue();
class ValidatorExpressions_RandomValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_RandomValue(value);
  }
  build() {
    return new ValidatorExpressions_RandomValue(this._value);
  }
  clearoneofValueType() {
    this._value._oneofValueTypeCase = 0;
    this._value._oneofValueTypeValue = null;
    return this;
  }
  setInt32Value(value) {
    this._value._oneofValueTypeCase = 1;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setDoubleValue(value) {
    this._value._oneofValueTypeCase = 2;
    this._value._oneofValueTypeValue = value;
    return this;
  }
}
ValidatorExpressions_RandomValue.Builder = ValidatorExpressions_RandomValue_Builder;
class ValidatorExpressions_RandomValue_WithParent {
  /**
   * @param {ValidatorExpressions_RandomValue} value
   * @param {ValidatorExpressions_RandomValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_RandomValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofValueTypeCase() {
    if (this._cachedoneofValueTypeCase === undefined) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedoneofValueTypeCase = this._parent ? this._parent.oneofValueTypeCase : 0;
      } else {
        this._cachedoneofValueTypeCase = this._value._oneofValueTypeCase;
      }
    }
    return this._cachedoneofValueTypeCase;
  }
  get int32Value() {
    if (!this._cachedInt32Value) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedInt32Value = this._parent ? new ValidatorExpressions_RangeInt.WithParent(ValidatorExpressions_RangeInt.default, this._parent.int32Value) : this._value.int32Value;
      } else if (this._value._oneofValueTypeCase === 1) {
        this._cachedInt32Value = new ValidatorExpressions_RangeInt.WithParent(this._value.int32Value, this._parent && this._parent.oneofValueTypeCase === 1 ? this._parent.int32Value : null);
      } else {
        this._cachedInt32Value = ValidatorExpressions_RangeInt.WithParent.default;
      }
    }
    return this._cachedInt32Value;
  }
  get doubleValue() {
    if (!this._cachedDoubleValue) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedDoubleValue = this._parent ? new ValidatorExpressions_RangeDouble.WithParent(ValidatorExpressions_RangeDouble.default, this._parent.doubleValue) : this._value.doubleValue;
      } else if (this._value._oneofValueTypeCase === 2) {
        this._cachedDoubleValue = new ValidatorExpressions_RangeDouble.WithParent(this._value.doubleValue, this._parent && this._parent.oneofValueTypeCase === 2 ? this._parent.doubleValue : null);
      } else {
        this._cachedDoubleValue = ValidatorExpressions_RangeDouble.WithParent.default;
      }
    }
    return this._cachedDoubleValue;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_RandomValue_WithParent(current, parent);
    if (this._cachedInt32Value && this._value._oneofValueTypeCase === 1 && current._oneofValueTypeCase === 1) {
      if (this._value.int32Value === current.int32Value && this._parent === parent) {
        result._cachedInt32Value = this._cachedInt32Value;
      } else {
        result._cachedInt32Value = this._cachedInt32Value.update(current.int32Value, parent && parent.oneofValueTypeCase === 1 ? parent.int32Value : null);
      }
    }
    if (this._cachedDoubleValue && this._value._oneofValueTypeCase === 2 && current._oneofValueTypeCase === 2) {
      if (this._value.doubleValue === current.doubleValue && this._parent === parent) {
        result._cachedDoubleValue = this._cachedDoubleValue;
      } else {
        result._cachedDoubleValue = this._cachedDoubleValue.update(current.doubleValue, parent && parent.oneofValueTypeCase === 2 ? parent.doubleValue : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_RandomValue_WithParent.default = new ValidatorExpressions_RandomValue_WithParent(ValidatorExpressions_RandomValue.default, null);
ValidatorExpressions_RandomValue.WithParent = ValidatorExpressions_RandomValue_WithParent;
class ValidatorExpressions_RandomValue_Descriptor {
  get int32Value() {
    if (!this._int32Value) {
      this._int32Value = {
        name: "int32Value",
        Name: "Int32Value",
        number: 1,
        protoType: 11,
        protoName: "int32_value",
        oneofIndex: 0,
        type: ValidatorExpressions_RangeInt,
        options: {
          comments: "Returns an integer value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._int32Value;
  }
  get doubleValue() {
    if (!this._doubleValue) {
      this._doubleValue = {
        name: "doubleValue",
        Name: "DoubleValue",
        number: 2,
        protoType: 11,
        protoName: "double_value",
        oneofIndex: 0,
        type: ValidatorExpressions_RangeDouble,
        options: {
          comments: "Returns a floating point number (with decimal).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._doubleValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.int32Value,
        this.doubleValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofValueType",
        Name: "OneofValueType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_RandomValue.descriptor = new ValidatorExpressions_RandomValue_Descriptor();
class ValidatorExpressions_EffectCriticalHitValue {
  get descriptor() {
    return ValidatorExpressions_EffectCriticalHitValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_EffectCriticalHitValue) {
      return value;
    }
    return ValidatorExpressions_EffectCriticalHitValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_EffectCriticalHitValue();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_EffectCriticalHitValue} other
   * @returns {ValidatorExpressions_EffectCriticalHitValue}
   */
  merge(other) {
    const copy = new ValidatorExpressions_EffectCriticalHitValue(this);
    return copy;
  }
}
ValidatorExpressions_EffectCriticalHitValue.default = new ValidatorExpressions_EffectCriticalHitValue();
class ValidatorExpressions_EffectCriticalHitValue_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_EffectCriticalHitValue(value);
  }
  build() {
    return new ValidatorExpressions_EffectCriticalHitValue(this._value);
  }
}
ValidatorExpressions_EffectCriticalHitValue.Builder = ValidatorExpressions_EffectCriticalHitValue_Builder;
class ValidatorExpressions_EffectCriticalHitValue_WithParent {
  /**
   * @param {ValidatorExpressions_EffectCriticalHitValue} value
   * @param {ValidatorExpressions_EffectCriticalHitValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_EffectCriticalHitValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_EffectCriticalHitValue_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_EffectCriticalHitValue_WithParent.default = new ValidatorExpressions_EffectCriticalHitValue_WithParent(ValidatorExpressions_EffectCriticalHitValue.default, null);
ValidatorExpressions_EffectCriticalHitValue.WithParent = ValidatorExpressions_EffectCriticalHitValue_WithParent;
class ValidatorExpressions_EffectCriticalHitValue_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ValidatorExpressions_EffectCriticalHitValue.descriptor = new ValidatorExpressions_EffectCriticalHitValue_Descriptor();
class ValidatorExpressions_Value {
  get descriptor() {
    return ValidatorExpressions_Value.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofValueTypeCase = 0;
    this._oneofValueTypeValue = null;
  }
  isEmpty() {
    if (this._oneofValueTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_Value) {
      return value;
    }
    return ValidatorExpressions_Value.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_Value();
    if (json.constant != null) {
      result._oneofValueTypeCase = 1;
      result._oneofValueTypeValue = ValidatorExpressions_ConstantValue.fromJson(json.constant);
    }
    if (json.random != null) {
      result._oneofValueTypeCase = 2;
      result._oneofValueTypeValue = ValidatorExpressions_RandomValue.fromJson(json.random);
    }
    if (json.damageAmount != null) {
      result._oneofValueTypeCase = 3;
      result._oneofValueTypeValue = ValidatorExpressions_DamageAmountValue.fromJson(json.damageAmount);
    }
    if (json.healAmount != null) {
      result._oneofValueTypeCase = 4;
      result._oneofValueTypeValue = ValidatorExpressions_HealAmountValue.fromJson(json.healAmount);
    }
    if (json.tagCount != null) {
      result._oneofValueTypeCase = 5;
      result._oneofValueTypeValue = ValidatorExpressions_TagCount.fromJson(json.tagCount);
    }
    if (json.unitLevel != null) {
      result._oneofValueTypeCase = 6;
      result._oneofValueTypeValue = ValidatorExpressions_UnitLevel.fromJson(json.unitLevel);
    }
    if (json.abilityLevel != null) {
      result._oneofValueTypeCase = 7;
      result._oneofValueTypeValue = ValidatorExpressions_AbilityLevel.fromJson(json.abilityLevel);
    }
    if (json.upgradeLevel != null) {
      result._oneofValueTypeCase = 8;
      result._oneofValueTypeValue = ValidatorExpressions_DataUpgradeLevel.fromJson(json.upgradeLevel);
    }
    if (json.remainingPathDistance != null) {
      result._oneofValueTypeCase = 9;
      result._oneofValueTypeValue = ValidatorExpressions_RemainingPathDistanceValue.fromJson(json.remainingPathDistance);
    }
    if (json.unitAbilityCooldown != null) {
      result._oneofValueTypeCase = 10;
      result._oneofValueTypeValue = ValidatorExpressions_UnitAbilityCooldown.fromJson(json.unitAbilityCooldown);
    }
    if (json.health != null) {
      result._oneofValueTypeCase = 11;
      result._oneofValueTypeValue = ValidatorExpressions_HealthValue.fromJson(json.health);
    }
    if (json.maxHealth != null) {
      result._oneofValueTypeCase = 12;
      result._oneofValueTypeValue = ValidatorExpressions_MaxHealthValue.fromJson(json.maxHealth);
    }
    if (json.healthFraction != null) {
      result._oneofValueTypeCase = 13;
      result._oneofValueTypeValue = ValidatorExpressions_HealthFraction.fromJson(json.healthFraction);
    }
    if (json.mana != null) {
      result._oneofValueTypeCase = 14;
      result._oneofValueTypeValue = ValidatorExpressions_ManaValue.fromJson(json.mana);
    }
    if (json.maxMana != null) {
      result._oneofValueTypeCase = 15;
      result._oneofValueTypeValue = ValidatorExpressions_MaxManaValue.fromJson(json.maxMana);
    }
    if (json.manaFraction != null) {
      result._oneofValueTypeCase = 16;
      result._oneofValueTypeValue = ValidatorExpressions_ManaFraction.fromJson(json.manaFraction);
    }
    if (json.shield != null) {
      result._oneofValueTypeCase = 17;
      result._oneofValueTypeValue = ValidatorExpressions_ShieldValue.fromJson(json.shield);
    }
    if (json.maxShield != null) {
      result._oneofValueTypeCase = 18;
      result._oneofValueTypeValue = ValidatorExpressions_MaxShieldValue.fromJson(json.maxShield);
    }
    if (json.shieldFraction != null) {
      result._oneofValueTypeCase = 19;
      result._oneofValueTypeValue = ValidatorExpressions_ShieldFraction.fromJson(json.shieldFraction);
    }
    if (json.behaviorStackCount != null) {
      result._oneofValueTypeCase = 21;
      result._oneofValueTypeValue = ValidatorExpressions_BehaviorStackCountValue.fromJson(json.behaviorStackCount);
    }
    if (json.behaviorElapsedTime != null) {
      result._oneofValueTypeCase = 22;
      result._oneofValueTypeValue = ValidatorExpressions_BehaviorElapsedTimeValue.fromJson(json.behaviorElapsedTime);
    }
    if (json.behaviorDuration != null) {
      result._oneofValueTypeCase = 23;
      result._oneofValueTypeValue = ValidatorExpressions_BehaviorDurationValue.fromJson(json.behaviorDuration);
    }
    if (json.addExpressions != null) {
      result._oneofValueTypeCase = 31;
      result._oneofValueTypeValue = ValidatorExpressions_AddExpression.fromJson(json.addExpressions);
    }
    if (json.effectCriticalHit != null) {
      result._oneofValueTypeCase = 32;
      result._oneofValueTypeValue = ValidatorExpressions_EffectCriticalHitValue.fromJson(json.effectCriticalHit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofValueTypeCase) {
      case 1:
        result.constant = ValidatorExpressions_ConstantValue.toJson(this._oneofValueTypeValue);
        break;
      case 2:
        result.random = ValidatorExpressions_RandomValue.toJson(this._oneofValueTypeValue);
        break;
      case 3:
        result.damageAmount = ValidatorExpressions_DamageAmountValue.toJson(this._oneofValueTypeValue);
        break;
      case 4:
        result.healAmount = ValidatorExpressions_HealAmountValue.toJson(this._oneofValueTypeValue);
        break;
      case 5:
        result.tagCount = ValidatorExpressions_TagCount.toJson(this._oneofValueTypeValue);
        break;
      case 6:
        result.unitLevel = ValidatorExpressions_UnitLevel.toJson(this._oneofValueTypeValue);
        break;
      case 7:
        result.abilityLevel = ValidatorExpressions_AbilityLevel.toJson(this._oneofValueTypeValue);
        break;
      case 8:
        result.upgradeLevel = ValidatorExpressions_DataUpgradeLevel.toJson(this._oneofValueTypeValue);
        break;
      case 9:
        result.remainingPathDistance = ValidatorExpressions_RemainingPathDistanceValue.toJson(this._oneofValueTypeValue);
        break;
      case 10:
        result.unitAbilityCooldown = ValidatorExpressions_UnitAbilityCooldown.toJson(this._oneofValueTypeValue);
        break;
      case 11:
        result.health = ValidatorExpressions_HealthValue.toJson(this._oneofValueTypeValue);
        break;
      case 12:
        result.maxHealth = ValidatorExpressions_MaxHealthValue.toJson(this._oneofValueTypeValue);
        break;
      case 13:
        result.healthFraction = ValidatorExpressions_HealthFraction.toJson(this._oneofValueTypeValue);
        break;
      case 14:
        result.mana = ValidatorExpressions_ManaValue.toJson(this._oneofValueTypeValue);
        break;
      case 15:
        result.maxMana = ValidatorExpressions_MaxManaValue.toJson(this._oneofValueTypeValue);
        break;
      case 16:
        result.manaFraction = ValidatorExpressions_ManaFraction.toJson(this._oneofValueTypeValue);
        break;
      case 17:
        result.shield = ValidatorExpressions_ShieldValue.toJson(this._oneofValueTypeValue);
        break;
      case 18:
        result.maxShield = ValidatorExpressions_MaxShieldValue.toJson(this._oneofValueTypeValue);
        break;
      case 19:
        result.shieldFraction = ValidatorExpressions_ShieldFraction.toJson(this._oneofValueTypeValue);
        break;
      case 21:
        result.behaviorStackCount = ValidatorExpressions_BehaviorStackCountValue.toJson(this._oneofValueTypeValue);
        break;
      case 22:
        result.behaviorElapsedTime = ValidatorExpressions_BehaviorElapsedTimeValue.toJson(this._oneofValueTypeValue);
        break;
      case 23:
        result.behaviorDuration = ValidatorExpressions_BehaviorDurationValue.toJson(this._oneofValueTypeValue);
        break;
      case 31:
        result.addExpressions = ValidatorExpressions_AddExpression.toJson(this._oneofValueTypeValue);
        break;
      case 32:
        result.effectCriticalHit = ValidatorExpressions_EffectCriticalHitValue.toJson(this._oneofValueTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofValueTypeCase() {
    return this._oneofValueTypeCase;
  }
  deleteOneofValueType(path) {
    switch (this._oneofValueTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['constant'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['random'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['damageAmount'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['healAmount'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['tagCount'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['unitLevel'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['abilityLevel'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['upgradeLevel'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['remainingPathDistance'])};
      }
      case 10: {
        return {type: 'DELETE', path: path.concat(['unitAbilityCooldown'])};
      }
      case 11: {
        return {type: 'DELETE', path: path.concat(['health'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['maxHealth'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['healthFraction'])};
      }
      case 14: {
        return {type: 'DELETE', path: path.concat(['mana'])};
      }
      case 15: {
        return {type: 'DELETE', path: path.concat(['maxMana'])};
      }
      case 16: {
        return {type: 'DELETE', path: path.concat(['manaFraction'])};
      }
      case 17: {
        return {type: 'DELETE', path: path.concat(['shield'])};
      }
      case 18: {
        return {type: 'DELETE', path: path.concat(['maxShield'])};
      }
      case 19: {
        return {type: 'DELETE', path: path.concat(['shieldFraction'])};
      }
      case 21: {
        return {type: 'DELETE', path: path.concat(['behaviorStackCount'])};
      }
      case 22: {
        return {type: 'DELETE', path: path.concat(['behaviorElapsedTime'])};
      }
      case 23: {
        return {type: 'DELETE', path: path.concat(['behaviorDuration'])};
      }
      case 31: {
        return {type: 'DELETE', path: path.concat(['addExpressions'])};
      }
      case 32: {
        return {type: 'DELETE', path: path.concat(['effectCriticalHit'])};
      }
    }
  }
  /**
   * @returns {ValidatorExpressions_ConstantValue}
   */
  get constant() {
    return this._oneofValueTypeCase === 1 ? this._oneofValueTypeValue : ValidatorExpressions_ConstantValue.default;
  }
  setConstant(path, value) {
    return {type: 'SET', path: path.concat(['constant']), value: value.toJson()};
  }
  deleteConstant(path) {
    return {type: 'DELETE', path: path.concat(['constant'])};
  }
  /**
   * @returns {ValidatorExpressions_RandomValue}
   */
  get random() {
    return this._oneofValueTypeCase === 2 ? this._oneofValueTypeValue : ValidatorExpressions_RandomValue.default;
  }
  setRandom(path, value) {
    return {type: 'SET', path: path.concat(['random']), value: value.toJson()};
  }
  deleteRandom(path) {
    return {type: 'DELETE', path: path.concat(['random'])};
  }
  /**
   * @returns {ValidatorExpressions_DamageAmountValue}
   */
  get damageAmount() {
    return this._oneofValueTypeCase === 3 ? this._oneofValueTypeValue : ValidatorExpressions_DamageAmountValue.default;
  }
  setDamageAmount(path, value) {
    return {type: 'SET', path: path.concat(['damageAmount']), value: value.toJson()};
  }
  deleteDamageAmount(path) {
    return {type: 'DELETE', path: path.concat(['damageAmount'])};
  }
  /**
   * @returns {ValidatorExpressions_HealAmountValue}
   */
  get healAmount() {
    return this._oneofValueTypeCase === 4 ? this._oneofValueTypeValue : ValidatorExpressions_HealAmountValue.default;
  }
  setHealAmount(path, value) {
    return {type: 'SET', path: path.concat(['healAmount']), value: value.toJson()};
  }
  deleteHealAmount(path) {
    return {type: 'DELETE', path: path.concat(['healAmount'])};
  }
  /**
   * @returns {ValidatorExpressions_TagCount}
   */
  get tagCount() {
    return this._oneofValueTypeCase === 5 ? this._oneofValueTypeValue : ValidatorExpressions_TagCount.default;
  }
  setTagCount(path, value) {
    return {type: 'SET', path: path.concat(['tagCount']), value: value.toJson()};
  }
  deleteTagCount(path) {
    return {type: 'DELETE', path: path.concat(['tagCount'])};
  }
  /**
   * @returns {ValidatorExpressions_UnitLevel}
   */
  get unitLevel() {
    return this._oneofValueTypeCase === 6 ? this._oneofValueTypeValue : ValidatorExpressions_UnitLevel.default;
  }
  setUnitLevel(path, value) {
    return {type: 'SET', path: path.concat(['unitLevel']), value: value.toJson()};
  }
  deleteUnitLevel(path) {
    return {type: 'DELETE', path: path.concat(['unitLevel'])};
  }
  /**
   * @returns {ValidatorExpressions_AbilityLevel}
   */
  get abilityLevel() {
    return this._oneofValueTypeCase === 7 ? this._oneofValueTypeValue : ValidatorExpressions_AbilityLevel.default;
  }
  setAbilityLevel(path, value) {
    return {type: 'SET', path: path.concat(['abilityLevel']), value: value.toJson()};
  }
  deleteAbilityLevel(path) {
    return {type: 'DELETE', path: path.concat(['abilityLevel'])};
  }
  /**
   * @returns {ValidatorExpressions_DataUpgradeLevel}
   */
  get upgradeLevel() {
    return this._oneofValueTypeCase === 8 ? this._oneofValueTypeValue : ValidatorExpressions_DataUpgradeLevel.default;
  }
  setUpgradeLevel(path, value) {
    return {type: 'SET', path: path.concat(['upgradeLevel']), value: value.toJson()};
  }
  deleteUpgradeLevel(path) {
    return {type: 'DELETE', path: path.concat(['upgradeLevel'])};
  }
  /**
   * @returns {ValidatorExpressions_RemainingPathDistanceValue}
   */
  get remainingPathDistance() {
    return this._oneofValueTypeCase === 9 ? this._oneofValueTypeValue : ValidatorExpressions_RemainingPathDistanceValue.default;
  }
  setRemainingPathDistance(path, value) {
    return {type: 'SET', path: path.concat(['remainingPathDistance']), value: value.toJson()};
  }
  deleteRemainingPathDistance(path) {
    return {type: 'DELETE', path: path.concat(['remainingPathDistance'])};
  }
  /**
   * @returns {ValidatorExpressions_UnitAbilityCooldown}
   */
  get unitAbilityCooldown() {
    return this._oneofValueTypeCase === 10 ? this._oneofValueTypeValue : ValidatorExpressions_UnitAbilityCooldown.default;
  }
  setUnitAbilityCooldown(path, value) {
    return {type: 'SET', path: path.concat(['unitAbilityCooldown']), value: value.toJson()};
  }
  deleteUnitAbilityCooldown(path) {
    return {type: 'DELETE', path: path.concat(['unitAbilityCooldown'])};
  }
  /**
   * @returns {ValidatorExpressions_HealthValue}
   */
  get health() {
    return this._oneofValueTypeCase === 11 ? this._oneofValueTypeValue : ValidatorExpressions_HealthValue.default;
  }
  setHealth(path, value) {
    return {type: 'SET', path: path.concat(['health']), value: value.toJson()};
  }
  deleteHealth(path) {
    return {type: 'DELETE', path: path.concat(['health'])};
  }
  /**
   * @returns {ValidatorExpressions_MaxHealthValue}
   */
  get maxHealth() {
    return this._oneofValueTypeCase === 12 ? this._oneofValueTypeValue : ValidatorExpressions_MaxHealthValue.default;
  }
  setMaxHealth(path, value) {
    return {type: 'SET', path: path.concat(['maxHealth']), value: value.toJson()};
  }
  deleteMaxHealth(path) {
    return {type: 'DELETE', path: path.concat(['maxHealth'])};
  }
  /**
   * @returns {ValidatorExpressions_HealthFraction}
   */
  get healthFraction() {
    return this._oneofValueTypeCase === 13 ? this._oneofValueTypeValue : ValidatorExpressions_HealthFraction.default;
  }
  setHealthFraction(path, value) {
    return {type: 'SET', path: path.concat(['healthFraction']), value: value.toJson()};
  }
  deleteHealthFraction(path) {
    return {type: 'DELETE', path: path.concat(['healthFraction'])};
  }
  /**
   * @returns {ValidatorExpressions_ManaValue}
   */
  get mana() {
    return this._oneofValueTypeCase === 14 ? this._oneofValueTypeValue : ValidatorExpressions_ManaValue.default;
  }
  setMana(path, value) {
    return {type: 'SET', path: path.concat(['mana']), value: value.toJson()};
  }
  deleteMana(path) {
    return {type: 'DELETE', path: path.concat(['mana'])};
  }
  /**
   * @returns {ValidatorExpressions_MaxManaValue}
   */
  get maxMana() {
    return this._oneofValueTypeCase === 15 ? this._oneofValueTypeValue : ValidatorExpressions_MaxManaValue.default;
  }
  setMaxMana(path, value) {
    return {type: 'SET', path: path.concat(['maxMana']), value: value.toJson()};
  }
  deleteMaxMana(path) {
    return {type: 'DELETE', path: path.concat(['maxMana'])};
  }
  /**
   * @returns {ValidatorExpressions_ManaFraction}
   */
  get manaFraction() {
    return this._oneofValueTypeCase === 16 ? this._oneofValueTypeValue : ValidatorExpressions_ManaFraction.default;
  }
  setManaFraction(path, value) {
    return {type: 'SET', path: path.concat(['manaFraction']), value: value.toJson()};
  }
  deleteManaFraction(path) {
    return {type: 'DELETE', path: path.concat(['manaFraction'])};
  }
  /**
   * @returns {ValidatorExpressions_ShieldValue}
   */
  get shield() {
    return this._oneofValueTypeCase === 17 ? this._oneofValueTypeValue : ValidatorExpressions_ShieldValue.default;
  }
  setShield(path, value) {
    return {type: 'SET', path: path.concat(['shield']), value: value.toJson()};
  }
  deleteShield(path) {
    return {type: 'DELETE', path: path.concat(['shield'])};
  }
  /**
   * @returns {ValidatorExpressions_MaxShieldValue}
   */
  get maxShield() {
    return this._oneofValueTypeCase === 18 ? this._oneofValueTypeValue : ValidatorExpressions_MaxShieldValue.default;
  }
  setMaxShield(path, value) {
    return {type: 'SET', path: path.concat(['maxShield']), value: value.toJson()};
  }
  deleteMaxShield(path) {
    return {type: 'DELETE', path: path.concat(['maxShield'])};
  }
  /**
   * @returns {ValidatorExpressions_ShieldFraction}
   */
  get shieldFraction() {
    return this._oneofValueTypeCase === 19 ? this._oneofValueTypeValue : ValidatorExpressions_ShieldFraction.default;
  }
  setShieldFraction(path, value) {
    return {type: 'SET', path: path.concat(['shieldFraction']), value: value.toJson()};
  }
  deleteShieldFraction(path) {
    return {type: 'DELETE', path: path.concat(['shieldFraction'])};
  }
  /**
   * @returns {ValidatorExpressions_BehaviorStackCountValue}
   */
  get behaviorStackCount() {
    return this._oneofValueTypeCase === 21 ? this._oneofValueTypeValue : ValidatorExpressions_BehaviorStackCountValue.default;
  }
  setBehaviorStackCount(path, value) {
    return {type: 'SET', path: path.concat(['behaviorStackCount']), value: value.toJson()};
  }
  deleteBehaviorStackCount(path) {
    return {type: 'DELETE', path: path.concat(['behaviorStackCount'])};
  }
  /**
   * @returns {ValidatorExpressions_BehaviorElapsedTimeValue}
   */
  get behaviorElapsedTime() {
    return this._oneofValueTypeCase === 22 ? this._oneofValueTypeValue : ValidatorExpressions_BehaviorElapsedTimeValue.default;
  }
  setBehaviorElapsedTime(path, value) {
    return {type: 'SET', path: path.concat(['behaviorElapsedTime']), value: value.toJson()};
  }
  deleteBehaviorElapsedTime(path) {
    return {type: 'DELETE', path: path.concat(['behaviorElapsedTime'])};
  }
  /**
   * @returns {ValidatorExpressions_BehaviorDurationValue}
   */
  get behaviorDuration() {
    return this._oneofValueTypeCase === 23 ? this._oneofValueTypeValue : ValidatorExpressions_BehaviorDurationValue.default;
  }
  setBehaviorDuration(path, value) {
    return {type: 'SET', path: path.concat(['behaviorDuration']), value: value.toJson()};
  }
  deleteBehaviorDuration(path) {
    return {type: 'DELETE', path: path.concat(['behaviorDuration'])};
  }
  /**
   * @returns {ValidatorExpressions_AddExpression}
   */
  get addExpressions() {
    return this._oneofValueTypeCase === 31 ? this._oneofValueTypeValue : ValidatorExpressions_AddExpression.default;
  }
  setAddExpressions(path, value) {
    return {type: 'SET', path: path.concat(['addExpressions']), value: value.toJson()};
  }
  deleteAddExpressions(path) {
    return {type: 'DELETE', path: path.concat(['addExpressions'])};
  }
  /**
   * @returns {ValidatorExpressions_EffectCriticalHitValue}
   */
  get effectCriticalHit() {
    return this._oneofValueTypeCase === 32 ? this._oneofValueTypeValue : ValidatorExpressions_EffectCriticalHitValue.default;
  }
  setEffectCriticalHit(path, value) {
    return {type: 'SET', path: path.concat(['effectCriticalHit']), value: value.toJson()};
  }
  deleteEffectCriticalHit(path) {
    return {type: 'DELETE', path: path.concat(['effectCriticalHit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "constant": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 1;
              copy._oneofValueTypeValue = ValidatorExpressions_ConstantValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 1) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 1) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 1;
            copy._oneofValueTypeValue = ValidatorExpressions_ConstantValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.constant.apply(type, path.slice(1), value);
          if (newValue === this.constant) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 1;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "random": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 2;
              copy._oneofValueTypeValue = ValidatorExpressions_RandomValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 2) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 2) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 2;
            copy._oneofValueTypeValue = ValidatorExpressions_RandomValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.random.apply(type, path.slice(1), value);
          if (newValue === this.random) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 2;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "damageAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 3;
              copy._oneofValueTypeValue = ValidatorExpressions_DamageAmountValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 3) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 3) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 3;
            copy._oneofValueTypeValue = ValidatorExpressions_DamageAmountValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.damageAmount.apply(type, path.slice(1), value);
          if (newValue === this.damageAmount) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 3;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "healAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 4;
              copy._oneofValueTypeValue = ValidatorExpressions_HealAmountValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 4) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 4) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 4;
            copy._oneofValueTypeValue = ValidatorExpressions_HealAmountValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.healAmount.apply(type, path.slice(1), value);
          if (newValue === this.healAmount) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 4;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "tagCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 5;
              copy._oneofValueTypeValue = ValidatorExpressions_TagCount.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 5) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 5) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 5;
            copy._oneofValueTypeValue = ValidatorExpressions_TagCount.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.tagCount.apply(type, path.slice(1), value);
          if (newValue === this.tagCount) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 5;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "unitLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 6;
              copy._oneofValueTypeValue = ValidatorExpressions_UnitLevel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 6) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 6) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 6;
            copy._oneofValueTypeValue = ValidatorExpressions_UnitLevel.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitLevel.apply(type, path.slice(1), value);
          if (newValue === this.unitLevel) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 6;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "abilityLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 7;
              copy._oneofValueTypeValue = ValidatorExpressions_AbilityLevel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 7) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 7) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 7;
            copy._oneofValueTypeValue = ValidatorExpressions_AbilityLevel.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.abilityLevel.apply(type, path.slice(1), value);
          if (newValue === this.abilityLevel) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 7;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "upgradeLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 8;
              copy._oneofValueTypeValue = ValidatorExpressions_DataUpgradeLevel.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 8) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 8) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 8;
            copy._oneofValueTypeValue = ValidatorExpressions_DataUpgradeLevel.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.upgradeLevel.apply(type, path.slice(1), value);
          if (newValue === this.upgradeLevel) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 8;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "remainingPathDistance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 9;
              copy._oneofValueTypeValue = ValidatorExpressions_RemainingPathDistanceValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 9) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 9) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 9;
            copy._oneofValueTypeValue = ValidatorExpressions_RemainingPathDistanceValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.remainingPathDistance.apply(type, path.slice(1), value);
          if (newValue === this.remainingPathDistance) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 9;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "unitAbilityCooldown": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 10;
              copy._oneofValueTypeValue = ValidatorExpressions_UnitAbilityCooldown.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 10) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 10) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 10;
            copy._oneofValueTypeValue = ValidatorExpressions_UnitAbilityCooldown.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.unitAbilityCooldown.apply(type, path.slice(1), value);
          if (newValue === this.unitAbilityCooldown) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 10;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "health": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 11;
              copy._oneofValueTypeValue = ValidatorExpressions_HealthValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 11) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 11) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 11;
            copy._oneofValueTypeValue = ValidatorExpressions_HealthValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.health.apply(type, path.slice(1), value);
          if (newValue === this.health) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 11;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "maxHealth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 12;
              copy._oneofValueTypeValue = ValidatorExpressions_MaxHealthValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 12) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 12) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 12;
            copy._oneofValueTypeValue = ValidatorExpressions_MaxHealthValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.maxHealth.apply(type, path.slice(1), value);
          if (newValue === this.maxHealth) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 12;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "healthFraction": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 13;
              copy._oneofValueTypeValue = ValidatorExpressions_HealthFraction.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 13) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 13) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 13;
            copy._oneofValueTypeValue = ValidatorExpressions_HealthFraction.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.healthFraction.apply(type, path.slice(1), value);
          if (newValue === this.healthFraction) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 13;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "mana": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 14;
              copy._oneofValueTypeValue = ValidatorExpressions_ManaValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 14) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 14) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 14;
            copy._oneofValueTypeValue = ValidatorExpressions_ManaValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.mana.apply(type, path.slice(1), value);
          if (newValue === this.mana) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 14;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "maxMana": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 15;
              copy._oneofValueTypeValue = ValidatorExpressions_MaxManaValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 15) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 15) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 15;
            copy._oneofValueTypeValue = ValidatorExpressions_MaxManaValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.maxMana.apply(type, path.slice(1), value);
          if (newValue === this.maxMana) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 15;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "manaFraction": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 16;
              copy._oneofValueTypeValue = ValidatorExpressions_ManaFraction.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 16) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 16) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 16;
            copy._oneofValueTypeValue = ValidatorExpressions_ManaFraction.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.manaFraction.apply(type, path.slice(1), value);
          if (newValue === this.manaFraction) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 16;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "shield": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 17;
              copy._oneofValueTypeValue = ValidatorExpressions_ShieldValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 17) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 17) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 17;
            copy._oneofValueTypeValue = ValidatorExpressions_ShieldValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.shield.apply(type, path.slice(1), value);
          if (newValue === this.shield) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 17;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "maxShield": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 18;
              copy._oneofValueTypeValue = ValidatorExpressions_MaxShieldValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 18) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 18) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 18;
            copy._oneofValueTypeValue = ValidatorExpressions_MaxShieldValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.maxShield.apply(type, path.slice(1), value);
          if (newValue === this.maxShield) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 18;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "shieldFraction": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 19;
              copy._oneofValueTypeValue = ValidatorExpressions_ShieldFraction.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 19) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 19) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 19;
            copy._oneofValueTypeValue = ValidatorExpressions_ShieldFraction.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.shieldFraction.apply(type, path.slice(1), value);
          if (newValue === this.shieldFraction) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 19;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "behaviorStackCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 21;
              copy._oneofValueTypeValue = ValidatorExpressions_BehaviorStackCountValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 21) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 21) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 21;
            copy._oneofValueTypeValue = ValidatorExpressions_BehaviorStackCountValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.behaviorStackCount.apply(type, path.slice(1), value);
          if (newValue === this.behaviorStackCount) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 21;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "behaviorElapsedTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 22;
              copy._oneofValueTypeValue = ValidatorExpressions_BehaviorElapsedTimeValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 22) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 22) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 22;
            copy._oneofValueTypeValue = ValidatorExpressions_BehaviorElapsedTimeValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.behaviorElapsedTime.apply(type, path.slice(1), value);
          if (newValue === this.behaviorElapsedTime) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 22;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "behaviorDuration": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 23;
              copy._oneofValueTypeValue = ValidatorExpressions_BehaviorDurationValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 23) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 23) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 23;
            copy._oneofValueTypeValue = ValidatorExpressions_BehaviorDurationValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.behaviorDuration.apply(type, path.slice(1), value);
          if (newValue === this.behaviorDuration) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 23;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "addExpressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 31;
              copy._oneofValueTypeValue = ValidatorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 31) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 31) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 31;
            copy._oneofValueTypeValue = ValidatorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.addExpressions.apply(type, path.slice(1), value);
          if (newValue === this.addExpressions) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 31;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      case "effectCriticalHit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 32;
              copy._oneofValueTypeValue = ValidatorExpressions_EffectCriticalHitValue.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofValueTypeCase !== 32) {
                return this;
              }
              const copy = new ValidatorExpressions_Value(this);
              copy._oneofValueTypeCase = 0;
              copy._oneofValueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofValueTypeCase !== 32) {
            const copy = new ValidatorExpressions_Value(this);
            copy._oneofValueTypeCase = 32;
            copy._oneofValueTypeValue = ValidatorExpressions_EffectCriticalHitValue.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.effectCriticalHit.apply(type, path.slice(1), value);
          if (newValue === this.effectCriticalHit) {
            return this;
          }
          const copy = new ValidatorExpressions_Value(this);
          copy._oneofValueTypeCase = 32;
          copy._oneofValueTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_Value} other
   * @returns {ValidatorExpressions_Value}
   */
  merge(other) {
    const copy = new ValidatorExpressions_Value(this);
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    if (other._oneofValueTypeCase === 1) {
      if (this._oneofValueTypeCase === 1) {
        copy._oneofValueTypeValue = copy._oneofValueTypeValue.merge(other._oneofValueTypeValue);
      } else {
        copy._oneofValueTypeValue = other._oneofValueTypeValue;
      }
      copy._oneofValueTypeCase = 1;
    }
    return copy;
  }
}
ValidatorExpressions_Value.default = new ValidatorExpressions_Value();
class ValidatorExpressions_Value_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_Value(value);
  }
  build() {
    return new ValidatorExpressions_Value(this._value);
  }
  clearoneofValueType() {
    this._value._oneofValueTypeCase = 0;
    this._value._oneofValueTypeValue = null;
    return this;
  }
  setConstant(value) {
    this._value._oneofValueTypeCase = 1;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setRandom(value) {
    this._value._oneofValueTypeCase = 2;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setDamageAmount(value) {
    this._value._oneofValueTypeCase = 3;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setHealAmount(value) {
    this._value._oneofValueTypeCase = 4;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setTagCount(value) {
    this._value._oneofValueTypeCase = 5;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setUnitLevel(value) {
    this._value._oneofValueTypeCase = 6;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setAbilityLevel(value) {
    this._value._oneofValueTypeCase = 7;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setUpgradeLevel(value) {
    this._value._oneofValueTypeCase = 8;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setRemainingPathDistance(value) {
    this._value._oneofValueTypeCase = 9;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setUnitAbilityCooldown(value) {
    this._value._oneofValueTypeCase = 10;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setHealth(value) {
    this._value._oneofValueTypeCase = 11;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setMaxHealth(value) {
    this._value._oneofValueTypeCase = 12;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setHealthFraction(value) {
    this._value._oneofValueTypeCase = 13;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setMana(value) {
    this._value._oneofValueTypeCase = 14;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setMaxMana(value) {
    this._value._oneofValueTypeCase = 15;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setManaFraction(value) {
    this._value._oneofValueTypeCase = 16;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setShield(value) {
    this._value._oneofValueTypeCase = 17;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setMaxShield(value) {
    this._value._oneofValueTypeCase = 18;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setShieldFraction(value) {
    this._value._oneofValueTypeCase = 19;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setBehaviorStackCount(value) {
    this._value._oneofValueTypeCase = 21;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setBehaviorElapsedTime(value) {
    this._value._oneofValueTypeCase = 22;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setBehaviorDuration(value) {
    this._value._oneofValueTypeCase = 23;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setAddExpressions(value) {
    this._value._oneofValueTypeCase = 31;
    this._value._oneofValueTypeValue = value;
    return this;
  }
  setEffectCriticalHit(value) {
    this._value._oneofValueTypeCase = 32;
    this._value._oneofValueTypeValue = value;
    return this;
  }
}
ValidatorExpressions_Value.Builder = ValidatorExpressions_Value_Builder;
class ValidatorExpressions_Value_WithParent {
  /**
   * @param {ValidatorExpressions_Value} value
   * @param {ValidatorExpressions_Value_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_Value.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofValueTypeCase() {
    if (this._cachedoneofValueTypeCase === undefined) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedoneofValueTypeCase = this._parent ? this._parent.oneofValueTypeCase : 0;
      } else {
        this._cachedoneofValueTypeCase = this._value._oneofValueTypeCase;
      }
    }
    return this._cachedoneofValueTypeCase;
  }
  get constant() {
    if (!this._cachedConstant) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedConstant = this._parent ? new ValidatorExpressions_ConstantValue.WithParent(ValidatorExpressions_ConstantValue.default, this._parent.constant) : this._value.constant;
      } else if (this._value._oneofValueTypeCase === 1) {
        this._cachedConstant = new ValidatorExpressions_ConstantValue.WithParent(this._value.constant, this._parent && this._parent.oneofValueTypeCase === 1 ? this._parent.constant : null);
      } else {
        this._cachedConstant = ValidatorExpressions_ConstantValue.WithParent.default;
      }
    }
    return this._cachedConstant;
  }
  get random() {
    if (!this._cachedRandom) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedRandom = this._parent ? new ValidatorExpressions_RandomValue.WithParent(ValidatorExpressions_RandomValue.default, this._parent.random) : this._value.random;
      } else if (this._value._oneofValueTypeCase === 2) {
        this._cachedRandom = new ValidatorExpressions_RandomValue.WithParent(this._value.random, this._parent && this._parent.oneofValueTypeCase === 2 ? this._parent.random : null);
      } else {
        this._cachedRandom = ValidatorExpressions_RandomValue.WithParent.default;
      }
    }
    return this._cachedRandom;
  }
  get damageAmount() {
    if (!this._cachedDamageAmount) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedDamageAmount = this._parent ? new ValidatorExpressions_DamageAmountValue.WithParent(ValidatorExpressions_DamageAmountValue.default, this._parent.damageAmount) : this._value.damageAmount;
      } else if (this._value._oneofValueTypeCase === 3) {
        this._cachedDamageAmount = new ValidatorExpressions_DamageAmountValue.WithParent(this._value.damageAmount, this._parent && this._parent.oneofValueTypeCase === 3 ? this._parent.damageAmount : null);
      } else {
        this._cachedDamageAmount = ValidatorExpressions_DamageAmountValue.WithParent.default;
      }
    }
    return this._cachedDamageAmount;
  }
  get healAmount() {
    if (!this._cachedHealAmount) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedHealAmount = this._parent ? new ValidatorExpressions_HealAmountValue.WithParent(ValidatorExpressions_HealAmountValue.default, this._parent.healAmount) : this._value.healAmount;
      } else if (this._value._oneofValueTypeCase === 4) {
        this._cachedHealAmount = new ValidatorExpressions_HealAmountValue.WithParent(this._value.healAmount, this._parent && this._parent.oneofValueTypeCase === 4 ? this._parent.healAmount : null);
      } else {
        this._cachedHealAmount = ValidatorExpressions_HealAmountValue.WithParent.default;
      }
    }
    return this._cachedHealAmount;
  }
  get tagCount() {
    if (!this._cachedTagCount) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedTagCount = this._parent ? new ValidatorExpressions_TagCount.WithParent(ValidatorExpressions_TagCount.default, this._parent.tagCount) : this._value.tagCount;
      } else if (this._value._oneofValueTypeCase === 5) {
        this._cachedTagCount = new ValidatorExpressions_TagCount.WithParent(this._value.tagCount, this._parent && this._parent.oneofValueTypeCase === 5 ? this._parent.tagCount : null);
      } else {
        this._cachedTagCount = ValidatorExpressions_TagCount.WithParent.default;
      }
    }
    return this._cachedTagCount;
  }
  get unitLevel() {
    if (!this._cachedUnitLevel) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedUnitLevel = this._parent ? new ValidatorExpressions_UnitLevel.WithParent(ValidatorExpressions_UnitLevel.default, this._parent.unitLevel) : this._value.unitLevel;
      } else if (this._value._oneofValueTypeCase === 6) {
        this._cachedUnitLevel = new ValidatorExpressions_UnitLevel.WithParent(this._value.unitLevel, this._parent && this._parent.oneofValueTypeCase === 6 ? this._parent.unitLevel : null);
      } else {
        this._cachedUnitLevel = ValidatorExpressions_UnitLevel.WithParent.default;
      }
    }
    return this._cachedUnitLevel;
  }
  get abilityLevel() {
    if (!this._cachedAbilityLevel) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedAbilityLevel = this._parent ? new ValidatorExpressions_AbilityLevel.WithParent(ValidatorExpressions_AbilityLevel.default, this._parent.abilityLevel) : this._value.abilityLevel;
      } else if (this._value._oneofValueTypeCase === 7) {
        this._cachedAbilityLevel = new ValidatorExpressions_AbilityLevel.WithParent(this._value.abilityLevel, this._parent && this._parent.oneofValueTypeCase === 7 ? this._parent.abilityLevel : null);
      } else {
        this._cachedAbilityLevel = ValidatorExpressions_AbilityLevel.WithParent.default;
      }
    }
    return this._cachedAbilityLevel;
  }
  get upgradeLevel() {
    if (!this._cachedUpgradeLevel) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedUpgradeLevel = this._parent ? new ValidatorExpressions_DataUpgradeLevel.WithParent(ValidatorExpressions_DataUpgradeLevel.default, this._parent.upgradeLevel) : this._value.upgradeLevel;
      } else if (this._value._oneofValueTypeCase === 8) {
        this._cachedUpgradeLevel = new ValidatorExpressions_DataUpgradeLevel.WithParent(this._value.upgradeLevel, this._parent && this._parent.oneofValueTypeCase === 8 ? this._parent.upgradeLevel : null);
      } else {
        this._cachedUpgradeLevel = ValidatorExpressions_DataUpgradeLevel.WithParent.default;
      }
    }
    return this._cachedUpgradeLevel;
  }
  get remainingPathDistance() {
    if (!this._cachedRemainingPathDistance) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedRemainingPathDistance = this._parent ? new ValidatorExpressions_RemainingPathDistanceValue.WithParent(ValidatorExpressions_RemainingPathDistanceValue.default, this._parent.remainingPathDistance) : this._value.remainingPathDistance;
      } else if (this._value._oneofValueTypeCase === 9) {
        this._cachedRemainingPathDistance = new ValidatorExpressions_RemainingPathDistanceValue.WithParent(this._value.remainingPathDistance, this._parent && this._parent.oneofValueTypeCase === 9 ? this._parent.remainingPathDistance : null);
      } else {
        this._cachedRemainingPathDistance = ValidatorExpressions_RemainingPathDistanceValue.WithParent.default;
      }
    }
    return this._cachedRemainingPathDistance;
  }
  get unitAbilityCooldown() {
    if (!this._cachedUnitAbilityCooldown) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedUnitAbilityCooldown = this._parent ? new ValidatorExpressions_UnitAbilityCooldown.WithParent(ValidatorExpressions_UnitAbilityCooldown.default, this._parent.unitAbilityCooldown) : this._value.unitAbilityCooldown;
      } else if (this._value._oneofValueTypeCase === 10) {
        this._cachedUnitAbilityCooldown = new ValidatorExpressions_UnitAbilityCooldown.WithParent(this._value.unitAbilityCooldown, this._parent && this._parent.oneofValueTypeCase === 10 ? this._parent.unitAbilityCooldown : null);
      } else {
        this._cachedUnitAbilityCooldown = ValidatorExpressions_UnitAbilityCooldown.WithParent.default;
      }
    }
    return this._cachedUnitAbilityCooldown;
  }
  get health() {
    if (!this._cachedHealth) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedHealth = this._parent ? new ValidatorExpressions_HealthValue.WithParent(ValidatorExpressions_HealthValue.default, this._parent.health) : this._value.health;
      } else if (this._value._oneofValueTypeCase === 11) {
        this._cachedHealth = new ValidatorExpressions_HealthValue.WithParent(this._value.health, this._parent && this._parent.oneofValueTypeCase === 11 ? this._parent.health : null);
      } else {
        this._cachedHealth = ValidatorExpressions_HealthValue.WithParent.default;
      }
    }
    return this._cachedHealth;
  }
  get maxHealth() {
    if (!this._cachedMaxHealth) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedMaxHealth = this._parent ? new ValidatorExpressions_MaxHealthValue.WithParent(ValidatorExpressions_MaxHealthValue.default, this._parent.maxHealth) : this._value.maxHealth;
      } else if (this._value._oneofValueTypeCase === 12) {
        this._cachedMaxHealth = new ValidatorExpressions_MaxHealthValue.WithParent(this._value.maxHealth, this._parent && this._parent.oneofValueTypeCase === 12 ? this._parent.maxHealth : null);
      } else {
        this._cachedMaxHealth = ValidatorExpressions_MaxHealthValue.WithParent.default;
      }
    }
    return this._cachedMaxHealth;
  }
  get healthFraction() {
    if (!this._cachedHealthFraction) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedHealthFraction = this._parent ? new ValidatorExpressions_HealthFraction.WithParent(ValidatorExpressions_HealthFraction.default, this._parent.healthFraction) : this._value.healthFraction;
      } else if (this._value._oneofValueTypeCase === 13) {
        this._cachedHealthFraction = new ValidatorExpressions_HealthFraction.WithParent(this._value.healthFraction, this._parent && this._parent.oneofValueTypeCase === 13 ? this._parent.healthFraction : null);
      } else {
        this._cachedHealthFraction = ValidatorExpressions_HealthFraction.WithParent.default;
      }
    }
    return this._cachedHealthFraction;
  }
  get mana() {
    if (!this._cachedMana) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedMana = this._parent ? new ValidatorExpressions_ManaValue.WithParent(ValidatorExpressions_ManaValue.default, this._parent.mana) : this._value.mana;
      } else if (this._value._oneofValueTypeCase === 14) {
        this._cachedMana = new ValidatorExpressions_ManaValue.WithParent(this._value.mana, this._parent && this._parent.oneofValueTypeCase === 14 ? this._parent.mana : null);
      } else {
        this._cachedMana = ValidatorExpressions_ManaValue.WithParent.default;
      }
    }
    return this._cachedMana;
  }
  get maxMana() {
    if (!this._cachedMaxMana) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedMaxMana = this._parent ? new ValidatorExpressions_MaxManaValue.WithParent(ValidatorExpressions_MaxManaValue.default, this._parent.maxMana) : this._value.maxMana;
      } else if (this._value._oneofValueTypeCase === 15) {
        this._cachedMaxMana = new ValidatorExpressions_MaxManaValue.WithParent(this._value.maxMana, this._parent && this._parent.oneofValueTypeCase === 15 ? this._parent.maxMana : null);
      } else {
        this._cachedMaxMana = ValidatorExpressions_MaxManaValue.WithParent.default;
      }
    }
    return this._cachedMaxMana;
  }
  get manaFraction() {
    if (!this._cachedManaFraction) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedManaFraction = this._parent ? new ValidatorExpressions_ManaFraction.WithParent(ValidatorExpressions_ManaFraction.default, this._parent.manaFraction) : this._value.manaFraction;
      } else if (this._value._oneofValueTypeCase === 16) {
        this._cachedManaFraction = new ValidatorExpressions_ManaFraction.WithParent(this._value.manaFraction, this._parent && this._parent.oneofValueTypeCase === 16 ? this._parent.manaFraction : null);
      } else {
        this._cachedManaFraction = ValidatorExpressions_ManaFraction.WithParent.default;
      }
    }
    return this._cachedManaFraction;
  }
  get shield() {
    if (!this._cachedShield) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedShield = this._parent ? new ValidatorExpressions_ShieldValue.WithParent(ValidatorExpressions_ShieldValue.default, this._parent.shield) : this._value.shield;
      } else if (this._value._oneofValueTypeCase === 17) {
        this._cachedShield = new ValidatorExpressions_ShieldValue.WithParent(this._value.shield, this._parent && this._parent.oneofValueTypeCase === 17 ? this._parent.shield : null);
      } else {
        this._cachedShield = ValidatorExpressions_ShieldValue.WithParent.default;
      }
    }
    return this._cachedShield;
  }
  get maxShield() {
    if (!this._cachedMaxShield) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedMaxShield = this._parent ? new ValidatorExpressions_MaxShieldValue.WithParent(ValidatorExpressions_MaxShieldValue.default, this._parent.maxShield) : this._value.maxShield;
      } else if (this._value._oneofValueTypeCase === 18) {
        this._cachedMaxShield = new ValidatorExpressions_MaxShieldValue.WithParent(this._value.maxShield, this._parent && this._parent.oneofValueTypeCase === 18 ? this._parent.maxShield : null);
      } else {
        this._cachedMaxShield = ValidatorExpressions_MaxShieldValue.WithParent.default;
      }
    }
    return this._cachedMaxShield;
  }
  get shieldFraction() {
    if (!this._cachedShieldFraction) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedShieldFraction = this._parent ? new ValidatorExpressions_ShieldFraction.WithParent(ValidatorExpressions_ShieldFraction.default, this._parent.shieldFraction) : this._value.shieldFraction;
      } else if (this._value._oneofValueTypeCase === 19) {
        this._cachedShieldFraction = new ValidatorExpressions_ShieldFraction.WithParent(this._value.shieldFraction, this._parent && this._parent.oneofValueTypeCase === 19 ? this._parent.shieldFraction : null);
      } else {
        this._cachedShieldFraction = ValidatorExpressions_ShieldFraction.WithParent.default;
      }
    }
    return this._cachedShieldFraction;
  }
  get behaviorStackCount() {
    if (!this._cachedBehaviorStackCount) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedBehaviorStackCount = this._parent ? new ValidatorExpressions_BehaviorStackCountValue.WithParent(ValidatorExpressions_BehaviorStackCountValue.default, this._parent.behaviorStackCount) : this._value.behaviorStackCount;
      } else if (this._value._oneofValueTypeCase === 21) {
        this._cachedBehaviorStackCount = new ValidatorExpressions_BehaviorStackCountValue.WithParent(this._value.behaviorStackCount, this._parent && this._parent.oneofValueTypeCase === 21 ? this._parent.behaviorStackCount : null);
      } else {
        this._cachedBehaviorStackCount = ValidatorExpressions_BehaviorStackCountValue.WithParent.default;
      }
    }
    return this._cachedBehaviorStackCount;
  }
  get behaviorElapsedTime() {
    if (!this._cachedBehaviorElapsedTime) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedBehaviorElapsedTime = this._parent ? new ValidatorExpressions_BehaviorElapsedTimeValue.WithParent(ValidatorExpressions_BehaviorElapsedTimeValue.default, this._parent.behaviorElapsedTime) : this._value.behaviorElapsedTime;
      } else if (this._value._oneofValueTypeCase === 22) {
        this._cachedBehaviorElapsedTime = new ValidatorExpressions_BehaviorElapsedTimeValue.WithParent(this._value.behaviorElapsedTime, this._parent && this._parent.oneofValueTypeCase === 22 ? this._parent.behaviorElapsedTime : null);
      } else {
        this._cachedBehaviorElapsedTime = ValidatorExpressions_BehaviorElapsedTimeValue.WithParent.default;
      }
    }
    return this._cachedBehaviorElapsedTime;
  }
  get behaviorDuration() {
    if (!this._cachedBehaviorDuration) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedBehaviorDuration = this._parent ? new ValidatorExpressions_BehaviorDurationValue.WithParent(ValidatorExpressions_BehaviorDurationValue.default, this._parent.behaviorDuration) : this._value.behaviorDuration;
      } else if (this._value._oneofValueTypeCase === 23) {
        this._cachedBehaviorDuration = new ValidatorExpressions_BehaviorDurationValue.WithParent(this._value.behaviorDuration, this._parent && this._parent.oneofValueTypeCase === 23 ? this._parent.behaviorDuration : null);
      } else {
        this._cachedBehaviorDuration = ValidatorExpressions_BehaviorDurationValue.WithParent.default;
      }
    }
    return this._cachedBehaviorDuration;
  }
  get addExpressions() {
    if (!this._cachedAddExpressions) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedAddExpressions = this._parent ? new ValidatorExpressions_AddExpression.WithParent(ValidatorExpressions_AddExpression.default, this._parent.addExpressions) : this._value.addExpressions;
      } else if (this._value._oneofValueTypeCase === 31) {
        this._cachedAddExpressions = new ValidatorExpressions_AddExpression.WithParent(this._value.addExpressions, this._parent && this._parent.oneofValueTypeCase === 31 ? this._parent.addExpressions : null);
      } else {
        this._cachedAddExpressions = ValidatorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedAddExpressions;
  }
  get effectCriticalHit() {
    if (!this._cachedEffectCriticalHit) {
      if (this._value._oneofValueTypeCase === 0) {
        this._cachedEffectCriticalHit = this._parent ? new ValidatorExpressions_EffectCriticalHitValue.WithParent(ValidatorExpressions_EffectCriticalHitValue.default, this._parent.effectCriticalHit) : this._value.effectCriticalHit;
      } else if (this._value._oneofValueTypeCase === 32) {
        this._cachedEffectCriticalHit = new ValidatorExpressions_EffectCriticalHitValue.WithParent(this._value.effectCriticalHit, this._parent && this._parent.oneofValueTypeCase === 32 ? this._parent.effectCriticalHit : null);
      } else {
        this._cachedEffectCriticalHit = ValidatorExpressions_EffectCriticalHitValue.WithParent.default;
      }
    }
    return this._cachedEffectCriticalHit;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_Value_WithParent(current, parent);
    if (this._cachedConstant && this._value._oneofValueTypeCase === 1 && current._oneofValueTypeCase === 1) {
      if (this._value.constant === current.constant && this._parent === parent) {
        result._cachedConstant = this._cachedConstant;
      } else {
        result._cachedConstant = this._cachedConstant.update(current.constant, parent && parent.oneofValueTypeCase === 1 ? parent.constant : null);
      }
    }
    if (this._cachedRandom && this._value._oneofValueTypeCase === 2 && current._oneofValueTypeCase === 2) {
      if (this._value.random === current.random && this._parent === parent) {
        result._cachedRandom = this._cachedRandom;
      } else {
        result._cachedRandom = this._cachedRandom.update(current.random, parent && parent.oneofValueTypeCase === 2 ? parent.random : null);
      }
    }
    if (this._cachedDamageAmount && this._value._oneofValueTypeCase === 3 && current._oneofValueTypeCase === 3) {
      if (this._value.damageAmount === current.damageAmount && this._parent === parent) {
        result._cachedDamageAmount = this._cachedDamageAmount;
      } else {
        result._cachedDamageAmount = this._cachedDamageAmount.update(current.damageAmount, parent && parent.oneofValueTypeCase === 3 ? parent.damageAmount : null);
      }
    }
    if (this._cachedHealAmount && this._value._oneofValueTypeCase === 4 && current._oneofValueTypeCase === 4) {
      if (this._value.healAmount === current.healAmount && this._parent === parent) {
        result._cachedHealAmount = this._cachedHealAmount;
      } else {
        result._cachedHealAmount = this._cachedHealAmount.update(current.healAmount, parent && parent.oneofValueTypeCase === 4 ? parent.healAmount : null);
      }
    }
    if (this._cachedTagCount && this._value._oneofValueTypeCase === 5 && current._oneofValueTypeCase === 5) {
      if (this._value.tagCount === current.tagCount && this._parent === parent) {
        result._cachedTagCount = this._cachedTagCount;
      } else {
        result._cachedTagCount = this._cachedTagCount.update(current.tagCount, parent && parent.oneofValueTypeCase === 5 ? parent.tagCount : null);
      }
    }
    if (this._cachedUnitLevel && this._value._oneofValueTypeCase === 6 && current._oneofValueTypeCase === 6) {
      if (this._value.unitLevel === current.unitLevel && this._parent === parent) {
        result._cachedUnitLevel = this._cachedUnitLevel;
      } else {
        result._cachedUnitLevel = this._cachedUnitLevel.update(current.unitLevel, parent && parent.oneofValueTypeCase === 6 ? parent.unitLevel : null);
      }
    }
    if (this._cachedAbilityLevel && this._value._oneofValueTypeCase === 7 && current._oneofValueTypeCase === 7) {
      if (this._value.abilityLevel === current.abilityLevel && this._parent === parent) {
        result._cachedAbilityLevel = this._cachedAbilityLevel;
      } else {
        result._cachedAbilityLevel = this._cachedAbilityLevel.update(current.abilityLevel, parent && parent.oneofValueTypeCase === 7 ? parent.abilityLevel : null);
      }
    }
    if (this._cachedUpgradeLevel && this._value._oneofValueTypeCase === 8 && current._oneofValueTypeCase === 8) {
      if (this._value.upgradeLevel === current.upgradeLevel && this._parent === parent) {
        result._cachedUpgradeLevel = this._cachedUpgradeLevel;
      } else {
        result._cachedUpgradeLevel = this._cachedUpgradeLevel.update(current.upgradeLevel, parent && parent.oneofValueTypeCase === 8 ? parent.upgradeLevel : null);
      }
    }
    if (this._cachedRemainingPathDistance && this._value._oneofValueTypeCase === 9 && current._oneofValueTypeCase === 9) {
      if (this._value.remainingPathDistance === current.remainingPathDistance && this._parent === parent) {
        result._cachedRemainingPathDistance = this._cachedRemainingPathDistance;
      } else {
        result._cachedRemainingPathDistance = this._cachedRemainingPathDistance.update(current.remainingPathDistance, parent && parent.oneofValueTypeCase === 9 ? parent.remainingPathDistance : null);
      }
    }
    if (this._cachedUnitAbilityCooldown && this._value._oneofValueTypeCase === 10 && current._oneofValueTypeCase === 10) {
      if (this._value.unitAbilityCooldown === current.unitAbilityCooldown && this._parent === parent) {
        result._cachedUnitAbilityCooldown = this._cachedUnitAbilityCooldown;
      } else {
        result._cachedUnitAbilityCooldown = this._cachedUnitAbilityCooldown.update(current.unitAbilityCooldown, parent && parent.oneofValueTypeCase === 10 ? parent.unitAbilityCooldown : null);
      }
    }
    if (this._cachedHealth && this._value._oneofValueTypeCase === 11 && current._oneofValueTypeCase === 11) {
      if (this._value.health === current.health && this._parent === parent) {
        result._cachedHealth = this._cachedHealth;
      } else {
        result._cachedHealth = this._cachedHealth.update(current.health, parent && parent.oneofValueTypeCase === 11 ? parent.health : null);
      }
    }
    if (this._cachedMaxHealth && this._value._oneofValueTypeCase === 12 && current._oneofValueTypeCase === 12) {
      if (this._value.maxHealth === current.maxHealth && this._parent === parent) {
        result._cachedMaxHealth = this._cachedMaxHealth;
      } else {
        result._cachedMaxHealth = this._cachedMaxHealth.update(current.maxHealth, parent && parent.oneofValueTypeCase === 12 ? parent.maxHealth : null);
      }
    }
    if (this._cachedHealthFraction && this._value._oneofValueTypeCase === 13 && current._oneofValueTypeCase === 13) {
      if (this._value.healthFraction === current.healthFraction && this._parent === parent) {
        result._cachedHealthFraction = this._cachedHealthFraction;
      } else {
        result._cachedHealthFraction = this._cachedHealthFraction.update(current.healthFraction, parent && parent.oneofValueTypeCase === 13 ? parent.healthFraction : null);
      }
    }
    if (this._cachedMana && this._value._oneofValueTypeCase === 14 && current._oneofValueTypeCase === 14) {
      if (this._value.mana === current.mana && this._parent === parent) {
        result._cachedMana = this._cachedMana;
      } else {
        result._cachedMana = this._cachedMana.update(current.mana, parent && parent.oneofValueTypeCase === 14 ? parent.mana : null);
      }
    }
    if (this._cachedMaxMana && this._value._oneofValueTypeCase === 15 && current._oneofValueTypeCase === 15) {
      if (this._value.maxMana === current.maxMana && this._parent === parent) {
        result._cachedMaxMana = this._cachedMaxMana;
      } else {
        result._cachedMaxMana = this._cachedMaxMana.update(current.maxMana, parent && parent.oneofValueTypeCase === 15 ? parent.maxMana : null);
      }
    }
    if (this._cachedManaFraction && this._value._oneofValueTypeCase === 16 && current._oneofValueTypeCase === 16) {
      if (this._value.manaFraction === current.manaFraction && this._parent === parent) {
        result._cachedManaFraction = this._cachedManaFraction;
      } else {
        result._cachedManaFraction = this._cachedManaFraction.update(current.manaFraction, parent && parent.oneofValueTypeCase === 16 ? parent.manaFraction : null);
      }
    }
    if (this._cachedShield && this._value._oneofValueTypeCase === 17 && current._oneofValueTypeCase === 17) {
      if (this._value.shield === current.shield && this._parent === parent) {
        result._cachedShield = this._cachedShield;
      } else {
        result._cachedShield = this._cachedShield.update(current.shield, parent && parent.oneofValueTypeCase === 17 ? parent.shield : null);
      }
    }
    if (this._cachedMaxShield && this._value._oneofValueTypeCase === 18 && current._oneofValueTypeCase === 18) {
      if (this._value.maxShield === current.maxShield && this._parent === parent) {
        result._cachedMaxShield = this._cachedMaxShield;
      } else {
        result._cachedMaxShield = this._cachedMaxShield.update(current.maxShield, parent && parent.oneofValueTypeCase === 18 ? parent.maxShield : null);
      }
    }
    if (this._cachedShieldFraction && this._value._oneofValueTypeCase === 19 && current._oneofValueTypeCase === 19) {
      if (this._value.shieldFraction === current.shieldFraction && this._parent === parent) {
        result._cachedShieldFraction = this._cachedShieldFraction;
      } else {
        result._cachedShieldFraction = this._cachedShieldFraction.update(current.shieldFraction, parent && parent.oneofValueTypeCase === 19 ? parent.shieldFraction : null);
      }
    }
    if (this._cachedBehaviorStackCount && this._value._oneofValueTypeCase === 21 && current._oneofValueTypeCase === 21) {
      if (this._value.behaviorStackCount === current.behaviorStackCount && this._parent === parent) {
        result._cachedBehaviorStackCount = this._cachedBehaviorStackCount;
      } else {
        result._cachedBehaviorStackCount = this._cachedBehaviorStackCount.update(current.behaviorStackCount, parent && parent.oneofValueTypeCase === 21 ? parent.behaviorStackCount : null);
      }
    }
    if (this._cachedBehaviorElapsedTime && this._value._oneofValueTypeCase === 22 && current._oneofValueTypeCase === 22) {
      if (this._value.behaviorElapsedTime === current.behaviorElapsedTime && this._parent === parent) {
        result._cachedBehaviorElapsedTime = this._cachedBehaviorElapsedTime;
      } else {
        result._cachedBehaviorElapsedTime = this._cachedBehaviorElapsedTime.update(current.behaviorElapsedTime, parent && parent.oneofValueTypeCase === 22 ? parent.behaviorElapsedTime : null);
      }
    }
    if (this._cachedBehaviorDuration && this._value._oneofValueTypeCase === 23 && current._oneofValueTypeCase === 23) {
      if (this._value.behaviorDuration === current.behaviorDuration && this._parent === parent) {
        result._cachedBehaviorDuration = this._cachedBehaviorDuration;
      } else {
        result._cachedBehaviorDuration = this._cachedBehaviorDuration.update(current.behaviorDuration, parent && parent.oneofValueTypeCase === 23 ? parent.behaviorDuration : null);
      }
    }
    if (this._cachedAddExpressions && this._value._oneofValueTypeCase === 31 && current._oneofValueTypeCase === 31) {
      if (this._value.addExpressions === current.addExpressions && this._parent === parent) {
        result._cachedAddExpressions = this._cachedAddExpressions;
      } else {
        result._cachedAddExpressions = this._cachedAddExpressions.update(current.addExpressions, parent && parent.oneofValueTypeCase === 31 ? parent.addExpressions : null);
      }
    }
    if (this._cachedEffectCriticalHit && this._value._oneofValueTypeCase === 32 && current._oneofValueTypeCase === 32) {
      if (this._value.effectCriticalHit === current.effectCriticalHit && this._parent === parent) {
        result._cachedEffectCriticalHit = this._cachedEffectCriticalHit;
      } else {
        result._cachedEffectCriticalHit = this._cachedEffectCriticalHit.update(current.effectCriticalHit, parent && parent.oneofValueTypeCase === 32 ? parent.effectCriticalHit : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_Value_WithParent.default = new ValidatorExpressions_Value_WithParent(ValidatorExpressions_Value.default, null);
ValidatorExpressions_Value.WithParent = ValidatorExpressions_Value_WithParent;
class ValidatorExpressions_Value_Descriptor {
  get constant() {
    if (!this._constant) {
      this._constant = {
        name: "constant",
        Name: "Constant",
        number: 1,
        protoType: 11,
        protoName: "constant",
        oneofIndex: 0,
        type: ValidatorExpressions_ConstantValue,
        options: {
          comments: "Returns a constant value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._constant;
  }
  get random() {
    if (!this._random) {
      this._random = {
        name: "random",
        Name: "Random",
        number: 2,
        protoType: 11,
        protoName: "random",
        oneofIndex: 0,
        type: ValidatorExpressions_RandomValue,
        options: {
          comments: "Returns a random number between the min and max value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._random;
  }
  get damageAmount() {
    if (!this._damageAmount) {
      this._damageAmount = {
        name: "damageAmount",
        Name: "DamageAmount",
        number: 3,
        protoType: 11,
        protoName: "damage_amount",
        oneofIndex: 0,
        type: ValidatorExpressions_DamageAmountValue,
        options: {
          comments: "The damage amount is multiplied by this value (default 0).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damageAmount;
  }
  get healAmount() {
    if (!this._healAmount) {
      this._healAmount = {
        name: "healAmount",
        Name: "HealAmount",
        number: 4,
        protoType: 11,
        protoName: "heal_amount",
        oneofIndex: 0,
        type: ValidatorExpressions_HealAmountValue,
        options: {
          comments: "The heal amount is multiplied by this value (default 0).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healAmount;
  }
  get tagCount() {
    if (!this._tagCount) {
      this._tagCount = {
        name: "tagCount",
        Name: "TagCount",
        number: 5,
        protoType: 11,
        protoName: "tag_count",
        oneofIndex: 0,
        type: ValidatorExpressions_TagCount,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagCount;
  }
  get unitLevel() {
    if (!this._unitLevel) {
      this._unitLevel = {
        name: "unitLevel",
        Name: "UnitLevel",
        number: 6,
        protoType: 11,
        protoName: "unit_level",
        oneofIndex: 0,
        type: ValidatorExpressions_UnitLevel,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitLevel;
  }
  get abilityLevel() {
    if (!this._abilityLevel) {
      this._abilityLevel = {
        name: "abilityLevel",
        Name: "AbilityLevel",
        number: 7,
        protoType: 11,
        protoName: "ability_level",
        oneofIndex: 0,
        type: ValidatorExpressions_AbilityLevel,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityLevel;
  }
  get upgradeLevel() {
    if (!this._upgradeLevel) {
      this._upgradeLevel = {
        name: "upgradeLevel",
        Name: "UpgradeLevel",
        number: 8,
        protoType: 11,
        protoName: "upgrade_level",
        oneofIndex: 0,
        type: ValidatorExpressions_DataUpgradeLevel,
        options: {
          comments: "Returns the level of an upgrade.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upgradeLevel;
  }
  get remainingPathDistance() {
    if (!this._remainingPathDistance) {
      this._remainingPathDistance = {
        name: "remainingPathDistance",
        Name: "RemainingPathDistance",
        number: 9,
        protoType: 11,
        protoName: "remaining_path_distance",
        oneofIndex: 0,
        type: ValidatorExpressions_RemainingPathDistanceValue,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._remainingPathDistance;
  }
  get unitAbilityCooldown() {
    if (!this._unitAbilityCooldown) {
      this._unitAbilityCooldown = {
        name: "unitAbilityCooldown",
        Name: "UnitAbilityCooldown",
        number: 10,
        protoType: 11,
        protoName: "unit_ability_cooldown",
        oneofIndex: 0,
        type: ValidatorExpressions_UnitAbilityCooldown,
        options: {
          comments: "Returns the current cooldown remaining for an ability.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitAbilityCooldown;
  }
  get health() {
    if (!this._health) {
      this._health = {
        name: "health",
        Name: "Health",
        number: 11,
        protoType: 11,
        protoName: "health",
        oneofIndex: 0,
        type: ValidatorExpressions_HealthValue,
        options: {
          comments: "Returns the current health of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._health;
  }
  get maxHealth() {
    if (!this._maxHealth) {
      this._maxHealth = {
        name: "maxHealth",
        Name: "MaxHealth",
        number: 12,
        protoType: 11,
        protoName: "max_health",
        oneofIndex: 0,
        type: ValidatorExpressions_MaxHealthValue,
        options: {
          comments: "Returns the max health of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxHealth;
  }
  get healthFraction() {
    if (!this._healthFraction) {
      this._healthFraction = {
        name: "healthFraction",
        Name: "HealthFraction",
        number: 13,
        protoType: 11,
        protoName: "health_fraction",
        oneofIndex: 0,
        type: ValidatorExpressions_HealthFraction,
        options: {
          comments: "Returns the current health fraction of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._healthFraction;
  }
  get mana() {
    if (!this._mana) {
      this._mana = {
        name: "mana",
        Name: "Mana",
        number: 14,
        protoType: 11,
        protoName: "mana",
        oneofIndex: 0,
        type: ValidatorExpressions_ManaValue,
        options: {
          comments: "Returns the current mana of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mana;
  }
  get maxMana() {
    if (!this._maxMana) {
      this._maxMana = {
        name: "maxMana",
        Name: "MaxMana",
        number: 15,
        protoType: 11,
        protoName: "max_mana",
        oneofIndex: 0,
        type: ValidatorExpressions_MaxManaValue,
        options: {
          comments: "Returns the max mana of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxMana;
  }
  get manaFraction() {
    if (!this._manaFraction) {
      this._manaFraction = {
        name: "manaFraction",
        Name: "ManaFraction",
        number: 16,
        protoType: 11,
        protoName: "mana_fraction",
        oneofIndex: 0,
        type: ValidatorExpressions_ManaFraction,
        options: {
          comments: "Returns the current mana fraction of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._manaFraction;
  }
  get shield() {
    if (!this._shield) {
      this._shield = {
        name: "shield",
        Name: "Shield",
        number: 17,
        protoType: 11,
        protoName: "shield",
        oneofIndex: 0,
        type: ValidatorExpressions_ShieldValue,
        options: {
          comments: "Returns the current shields of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shield;
  }
  get maxShield() {
    if (!this._maxShield) {
      this._maxShield = {
        name: "maxShield",
        Name: "MaxShield",
        number: 18,
        protoType: 11,
        protoName: "max_shield",
        oneofIndex: 0,
        type: ValidatorExpressions_MaxShieldValue,
        options: {
          comments: "Returns the max shields of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxShield;
  }
  get shieldFraction() {
    if (!this._shieldFraction) {
      this._shieldFraction = {
        name: "shieldFraction",
        Name: "ShieldFraction",
        number: 19,
        protoType: 11,
        protoName: "shield_fraction",
        oneofIndex: 0,
        type: ValidatorExpressions_ShieldFraction,
        options: {
          comments: "Returns the current shield fraction of a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shieldFraction;
  }
  get behaviorStackCount() {
    if (!this._behaviorStackCount) {
      this._behaviorStackCount = {
        name: "behaviorStackCount",
        Name: "BehaviorStackCount",
        number: 21,
        protoType: 11,
        protoName: "behavior_stack_count",
        oneofIndex: 0,
        type: ValidatorExpressions_BehaviorStackCountValue,
        options: {
          comments: "Returns the current stack count of a behavior on a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorStackCount;
  }
  get behaviorElapsedTime() {
    if (!this._behaviorElapsedTime) {
      this._behaviorElapsedTime = {
        name: "behaviorElapsedTime",
        Name: "BehaviorElapsedTime",
        number: 22,
        protoType: 11,
        protoName: "behavior_elapsed_time",
        oneofIndex: 0,
        type: ValidatorExpressions_BehaviorElapsedTimeValue,
        options: {
          comments: "Returns the elapsed time that a behavior has been on a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorElapsedTime;
  }
  get behaviorDuration() {
    if (!this._behaviorDuration) {
      this._behaviorDuration = {
        name: "behaviorDuration",
        Name: "BehaviorDuration",
        number: 23,
        protoType: 11,
        protoName: "behavior_duration",
        oneofIndex: 0,
        type: ValidatorExpressions_BehaviorDurationValue,
        options: {
          comments: "Returns the duration that a behavior has been on a unit.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._behaviorDuration;
  }
  get addExpressions() {
    if (!this._addExpressions) {
      this._addExpressions = {
        name: "addExpressions",
        Name: "AddExpressions",
        number: 31,
        protoType: 11,
        protoName: "add_expressions",
        oneofIndex: 0,
        type: ValidatorExpressions_AddExpression,
        options: {
          comments: "Returns the sum of the listed expressions.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._addExpressions;
  }
  get effectCriticalHit() {
    if (!this._effectCriticalHit) {
      this._effectCriticalHit = {
        name: "effectCriticalHit",
        Name: "EffectCriticalHit",
        number: 32,
        protoType: 11,
        protoName: "effect_critical_hit",
        oneofIndex: 0,
        type: ValidatorExpressions_EffectCriticalHitValue,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effectCriticalHit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.constant,
        this.random,
        this.damageAmount,
        this.healAmount,
        this.tagCount,
        this.unitLevel,
        this.abilityLevel,
        this.upgradeLevel,
        this.remainingPathDistance,
        this.unitAbilityCooldown,
        this.health,
        this.maxHealth,
        this.healthFraction,
        this.mana,
        this.maxMana,
        this.manaFraction,
        this.shield,
        this.maxShield,
        this.shieldFraction,
        this.behaviorStackCount,
        this.behaviorElapsedTime,
        this.behaviorDuration,
        this.addExpressions,
        this.effectCriticalHit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofValueType",
        Name: "OneofValueType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
          this.fields[10],
          this.fields[11],
          this.fields[12],
          this.fields[13],
          this.fields[14],
          this.fields[15],
          this.fields[16],
          this.fields[17],
          this.fields[18],
          this.fields[19],
          this.fields[20],
          this.fields[21],
          this.fields[22],
          this.fields[23],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_Value.descriptor = new ValidatorExpressions_Value_Descriptor();
class ValidatorExpressions_DivideExpression {
  get descriptor() {
    return ValidatorExpressions_DivideExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeft = false;
    this._left = null;
    this._hasRight = false;
    this._right = null;
  }
  isEmpty() {
    if (this._hasLeft && !this._left.isEmpty()) return false;
    if (this._hasRight && !this._right.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_DivideExpression) {
      return value;
    }
    return ValidatorExpressions_DivideExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_DivideExpression();
    if (json.left != null) {
      result._hasLeft = true;
      result._left = ValidatorExpressions_Value.fromJson(json.left);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = ValidatorExpressions_Value.fromJson(json.right);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeft && !this._left.isEmpty()) {
      result.left = ValidatorExpressions_Value.toJson(this._left);
    }
    if (this._hasRight && !this._right.isEmpty()) {
      result.right = ValidatorExpressions_Value.toJson(this._right);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get left() {
    return this._hasLeft ? this._left : ValidatorExpressions_Value.default;
  }
  get hasLeft() {
    return this._hasLeft;
  }
  setLeft(path, value) {
    return {type: 'SET', path: path.concat(['left']), value: value.toJson()};
  }
  deleteLeft(path) {
    return {type: 'DELETE', path: path.concat(['left'])};
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get right() {
    return this._hasRight ? this._right : ValidatorExpressions_Value.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value: value.toJson()};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "left": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_DivideExpression(this);
              copy._hasLeft = true;
              copy._left = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeft) {
                return this;
              }
              const copy = new ValidatorExpressions_DivideExpression(this);
              copy._hasLeft = false;
              copy._left = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeft) {
            const copy = new ValidatorExpressions_DivideExpression(this);
            copy._hasLeft = true;
            copy._left = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._left.apply(type, path.slice(1), value);
          if (newValue === this._left) {
            return this;
          }
          const copy = new ValidatorExpressions_DivideExpression(this);
          copy._left = copy._left.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_DivideExpression(this);
              copy._hasRight = true;
              copy._right = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new ValidatorExpressions_DivideExpression(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRight) {
            const copy = new ValidatorExpressions_DivideExpression(this);
            copy._hasRight = true;
            copy._right = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._right.apply(type, path.slice(1), value);
          if (newValue === this._right) {
            return this;
          }
          const copy = new ValidatorExpressions_DivideExpression(this);
          copy._right = copy._right.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_DivideExpression} other
   * @returns {ValidatorExpressions_DivideExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_DivideExpression(this);
    if (other._hasLeft) {
      if (copy._hasLeft) {
        copy._left = copy.left.merge(other.left);
      } else {
        copy._left = other._left;
      }
      copy._hasLeft = true;
    }
    if (other._hasRight) {
      if (copy._hasRight) {
        copy._right = copy.right.merge(other.right);
      } else {
        copy._right = other._right;
      }
      copy._hasRight = true;
    }
    return copy;
  }
}
ValidatorExpressions_DivideExpression.default = new ValidatorExpressions_DivideExpression();
class ValidatorExpressions_DivideExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_DivideExpression(value);
  }
  build() {
    return new ValidatorExpressions_DivideExpression(this._value);
  }
  setLeft(value) {
    this._value._hasLeft = true;
    this._value._left = value;
    return this;
  }
  deleteLeft() {
    this._value._hasLeft = false;
    this._value._left = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
}
ValidatorExpressions_DivideExpression.Builder = ValidatorExpressions_DivideExpression_Builder;
class ValidatorExpressions_DivideExpression_WithParent {
  /**
   * @param {ValidatorExpressions_DivideExpression} value
   * @param {ValidatorExpressions_DivideExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_DivideExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeft() {
    if (this._cachedHasLeft === undefined) {
      if (this._value.hasLeft) {
        this._cachedHasLeft = true;
      } else {
        this._cachedHasLeft = this._parent ? this._parent.hasLeft : false;
      }
    }
    return this._cachedHasLeft;
  }
  get left() {
    if (!this._cachedLeft) {
      if (this._value.hasLeft) {
        this._cachedLeft = new ValidatorExpressions_Value.WithParent(this._value.left, this._parent && this._parent.hasLeft ? this._parent.left : null);
      } else {
        this._cachedLeft = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.left) : ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedLeft;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (!this._cachedRight) {
      if (this._value.hasRight) {
        this._cachedRight = new ValidatorExpressions_Value.WithParent(this._value.right, this._parent && this._parent.hasRight ? this._parent.right : null);
      } else {
        this._cachedRight = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.right) : ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedRight;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_DivideExpression_WithParent(current, parent);
    if (this._cachedLeft && this._value.hasLeft && current.hasLeft) {
      if (this._value.left === current.left && this._parent === parent) {
        result._cachedLeft = this._cachedLeft;
      } else {
        result._cachedLeft = this._cachedLeft.update(current.left, parent && parent.hasLeft ? parent.left : null);
      }
    }
    if (this._cachedRight && this._value.hasRight && current.hasRight) {
      if (this._value.right === current.right && this._parent === parent) {
        result._cachedRight = this._cachedRight;
      } else {
        result._cachedRight = this._cachedRight.update(current.right, parent && parent.hasRight ? parent.right : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_DivideExpression_WithParent.default = new ValidatorExpressions_DivideExpression_WithParent(ValidatorExpressions_DivideExpression.default, null);
ValidatorExpressions_DivideExpression.WithParent = ValidatorExpressions_DivideExpression_WithParent;
class ValidatorExpressions_DivideExpression_Descriptor {
  get left() {
    if (!this._left) {
      this._left = {
        name: "left",
        Name: "Left",
        number: 1,
        protoType: 11,
        protoName: "left",
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._left;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 2,
        protoType: 11,
        protoName: "right",
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.left,
        this.right,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeft",
        Name: "DummyOneofForLeft",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_DivideExpression.descriptor = new ValidatorExpressions_DivideExpression_Descriptor();
class ValidatorExpressions_MultiplyExpression {
  get descriptor() {
    return ValidatorExpressions_MultiplyExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressions = [];
  }
  isEmpty() {
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_MultiplyExpression) {
      return value;
    }
    return ValidatorExpressions_MultiplyExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_MultiplyExpression();
    result._expressions = JsonToList(json.expressions, ValidatorExpressions_Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, ValidatorExpressions_Expression);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, ValidatorExpressions_Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_MultiplyExpression(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(ValidatorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ValidatorExpressions_MultiplyExpression(this);
              copy._expressions = copy._expressions.concat([ValidatorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new ValidatorExpressions_MultiplyExpression(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_MultiplyExpression(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = ValidatorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ValidatorExpressions_MultiplyExpression(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ValidatorExpressions_MultiplyExpression(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_MultiplyExpression} other
   * @returns {ValidatorExpressions_MultiplyExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_MultiplyExpression(this);
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
ValidatorExpressions_MultiplyExpression.default = new ValidatorExpressions_MultiplyExpression();
class ValidatorExpressions_MultiplyExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_MultiplyExpression(value);
  }
  build() {
    return new ValidatorExpressions_MultiplyExpression(this._value);
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
ValidatorExpressions_MultiplyExpression.Builder = ValidatorExpressions_MultiplyExpression_Builder;
class ValidatorExpressions_MultiplyExpression_WithParent {
  /**
   * @param {ValidatorExpressions_MultiplyExpression} value
   * @param {ValidatorExpressions_MultiplyExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_MultiplyExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new ValidatorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_MultiplyExpression_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new ValidatorExpressions_Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ValidatorExpressions_MultiplyExpression_WithParent.default = new ValidatorExpressions_MultiplyExpression_WithParent(ValidatorExpressions_MultiplyExpression.default, null);
ValidatorExpressions_MultiplyExpression.WithParent = ValidatorExpressions_MultiplyExpression_WithParent;
class ValidatorExpressions_MultiplyExpression_Descriptor {
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 1,
        protoType: 11,
        protoName: "expressions",
        type: ValidatorExpressions_Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ValidatorExpressions_MultiplyExpression.descriptor = new ValidatorExpressions_MultiplyExpression_Descriptor();
class ValidatorExpressions_SubtractExpression_ChildExpression {
  get descriptor() {
    return ValidatorExpressions_SubtractExpression_ChildExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofTypeCase = 0;
    this._oneofTypeValue = null;
  }
  isEmpty() {
    if (this._oneofTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_SubtractExpression_ChildExpression) {
      return value;
    }
    return ValidatorExpressions_SubtractExpression_ChildExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_SubtractExpression_ChildExpression();
    if (json.value != null) {
      result._oneofTypeCase = 1;
      result._oneofTypeValue = ValidatorExpressions_Value.fromJson(json.value);
    }
    if (json.divide != null) {
      result._oneofTypeCase = 2;
      result._oneofTypeValue = ValidatorExpressions_DivideExpression.fromJson(json.divide);
    }
    if (json.multiply != null) {
      result._oneofTypeCase = 3;
      result._oneofTypeValue = ValidatorExpressions_MultiplyExpression.fromJson(json.multiply);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofTypeCase) {
      case 1:
        result.value = ValidatorExpressions_Value.toJson(this._oneofTypeValue);
        break;
      case 2:
        result.divide = ValidatorExpressions_DivideExpression.toJson(this._oneofTypeValue);
        break;
      case 3:
        result.multiply = ValidatorExpressions_MultiplyExpression.toJson(this._oneofTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofTypeCase() {
    return this._oneofTypeCase;
  }
  deleteOneofType(path) {
    switch (this._oneofTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['divide'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['multiply'])};
      }
    }
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get value() {
    return this._oneofTypeCase === 1 ? this._oneofTypeValue : ValidatorExpressions_Value.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {ValidatorExpressions_DivideExpression}
   */
  get divide() {
    return this._oneofTypeCase === 2 ? this._oneofTypeValue : ValidatorExpressions_DivideExpression.default;
  }
  setDivide(path, value) {
    return {type: 'SET', path: path.concat(['divide']), value: value.toJson()};
  }
  deleteDivide(path) {
    return {type: 'DELETE', path: path.concat(['divide'])};
  }
  /**
   * @returns {ValidatorExpressions_MultiplyExpression}
   */
  get multiply() {
    return this._oneofTypeCase === 3 ? this._oneofTypeValue : ValidatorExpressions_MultiplyExpression.default;
  }
  setMultiply(path, value) {
    return {type: 'SET', path: path.concat(['multiply']), value: value.toJson()};
  }
  deleteMultiply(path) {
    return {type: 'DELETE', path: path.concat(['multiply'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 1;
              copy._oneofTypeValue = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 1) {
                return this;
              }
              const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 1) {
            const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
            copy._oneofTypeCase = 1;
            copy._oneofTypeValue = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.value.apply(type, path.slice(1), value);
          if (newValue === this.value) {
            return this;
          }
          const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
          copy._oneofTypeCase = 1;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "divide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 2;
              copy._oneofTypeValue = ValidatorExpressions_DivideExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 2) {
                return this;
              }
              const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 2) {
            const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
            copy._oneofTypeCase = 2;
            copy._oneofTypeValue = ValidatorExpressions_DivideExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.divide.apply(type, path.slice(1), value);
          if (newValue === this.divide) {
            return this;
          }
          const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
          copy._oneofTypeCase = 2;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "multiply": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 3;
              copy._oneofTypeValue = ValidatorExpressions_MultiplyExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 3) {
                return this;
              }
              const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 3) {
            const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
            copy._oneofTypeCase = 3;
            copy._oneofTypeValue = ValidatorExpressions_MultiplyExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.multiply.apply(type, path.slice(1), value);
          if (newValue === this.multiply) {
            return this;
          }
          const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
          copy._oneofTypeCase = 3;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_SubtractExpression_ChildExpression} other
   * @returns {ValidatorExpressions_SubtractExpression_ChildExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_SubtractExpression_ChildExpression(this);
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    return copy;
  }
}
ValidatorExpressions_SubtractExpression_ChildExpression.default = new ValidatorExpressions_SubtractExpression_ChildExpression();
class ValidatorExpressions_SubtractExpression_ChildExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_SubtractExpression_ChildExpression(value);
  }
  build() {
    return new ValidatorExpressions_SubtractExpression_ChildExpression(this._value);
  }
  clearoneofType() {
    this._value._oneofTypeCase = 0;
    this._value._oneofTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._oneofTypeCase = 1;
    this._value._oneofTypeValue = value;
    return this;
  }
  setDivide(value) {
    this._value._oneofTypeCase = 2;
    this._value._oneofTypeValue = value;
    return this;
  }
  setMultiply(value) {
    this._value._oneofTypeCase = 3;
    this._value._oneofTypeValue = value;
    return this;
  }
}
ValidatorExpressions_SubtractExpression_ChildExpression.Builder = ValidatorExpressions_SubtractExpression_ChildExpression_Builder;
class ValidatorExpressions_SubtractExpression_ChildExpression_WithParent {
  /**
   * @param {ValidatorExpressions_SubtractExpression_ChildExpression} value
   * @param {ValidatorExpressions_SubtractExpression_ChildExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_SubtractExpression_ChildExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofTypeCase() {
    if (this._cachedoneofTypeCase === undefined) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedoneofTypeCase = this._parent ? this._parent.oneofTypeCase : 0;
      } else {
        this._cachedoneofTypeCase = this._value._oneofTypeCase;
      }
    }
    return this._cachedoneofTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedValue = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.value) : this._value.value;
      } else if (this._value._oneofTypeCase === 1) {
        this._cachedValue = new ValidatorExpressions_Value.WithParent(this._value.value, this._parent && this._parent.oneofTypeCase === 1 ? this._parent.value : null);
      } else {
        this._cachedValue = ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  get divide() {
    if (!this._cachedDivide) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedDivide = this._parent ? new ValidatorExpressions_DivideExpression.WithParent(ValidatorExpressions_DivideExpression.default, this._parent.divide) : this._value.divide;
      } else if (this._value._oneofTypeCase === 2) {
        this._cachedDivide = new ValidatorExpressions_DivideExpression.WithParent(this._value.divide, this._parent && this._parent.oneofTypeCase === 2 ? this._parent.divide : null);
      } else {
        this._cachedDivide = ValidatorExpressions_DivideExpression.WithParent.default;
      }
    }
    return this._cachedDivide;
  }
  get multiply() {
    if (!this._cachedMultiply) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedMultiply = this._parent ? new ValidatorExpressions_MultiplyExpression.WithParent(ValidatorExpressions_MultiplyExpression.default, this._parent.multiply) : this._value.multiply;
      } else if (this._value._oneofTypeCase === 3) {
        this._cachedMultiply = new ValidatorExpressions_MultiplyExpression.WithParent(this._value.multiply, this._parent && this._parent.oneofTypeCase === 3 ? this._parent.multiply : null);
      } else {
        this._cachedMultiply = ValidatorExpressions_MultiplyExpression.WithParent.default;
      }
    }
    return this._cachedMultiply;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_SubtractExpression_ChildExpression_WithParent(current, parent);
    if (this._cachedValue && this._value._oneofTypeCase === 1 && current._oneofTypeCase === 1) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.oneofTypeCase === 1 ? parent.value : null);
      }
    }
    if (this._cachedDivide && this._value._oneofTypeCase === 2 && current._oneofTypeCase === 2) {
      if (this._value.divide === current.divide && this._parent === parent) {
        result._cachedDivide = this._cachedDivide;
      } else {
        result._cachedDivide = this._cachedDivide.update(current.divide, parent && parent.oneofTypeCase === 2 ? parent.divide : null);
      }
    }
    if (this._cachedMultiply && this._value._oneofTypeCase === 3 && current._oneofTypeCase === 3) {
      if (this._value.multiply === current.multiply && this._parent === parent) {
        result._cachedMultiply = this._cachedMultiply;
      } else {
        result._cachedMultiply = this._cachedMultiply.update(current.multiply, parent && parent.oneofTypeCase === 3 ? parent.multiply : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_SubtractExpression_ChildExpression_WithParent.default = new ValidatorExpressions_SubtractExpression_ChildExpression_WithParent(ValidatorExpressions_SubtractExpression_ChildExpression.default, null);
ValidatorExpressions_SubtractExpression_ChildExpression.WithParent = ValidatorExpressions_SubtractExpression_ChildExpression_WithParent;
class ValidatorExpressions_SubtractExpression_ChildExpression_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 11,
        protoName: "value",
        oneofIndex: 0,
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get divide() {
    if (!this._divide) {
      this._divide = {
        name: "divide",
        Name: "Divide",
        number: 2,
        protoType: 11,
        protoName: "divide",
        oneofIndex: 0,
        type: ValidatorExpressions_DivideExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._divide;
  }
  get multiply() {
    if (!this._multiply) {
      this._multiply = {
        name: "multiply",
        Name: "Multiply",
        number: 3,
        protoType: 11,
        protoName: "multiply",
        oneofIndex: 0,
        type: ValidatorExpressions_MultiplyExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiply;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.divide,
        this.multiply,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofType",
        Name: "OneofType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_SubtractExpression_ChildExpression.descriptor = new ValidatorExpressions_SubtractExpression_ChildExpression_Descriptor();
class ValidatorExpressions_SubtractExpression {
  get descriptor() {
    return ValidatorExpressions_SubtractExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeft = false;
    this._left = null;
    this._hasRight = false;
    this._right = null;
  }
  isEmpty() {
    if (this._hasLeft && !this._left.isEmpty()) return false;
    if (this._hasRight && !this._right.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_SubtractExpression) {
      return value;
    }
    return ValidatorExpressions_SubtractExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_SubtractExpression();
    if (json.left != null) {
      result._hasLeft = true;
      result._left = ValidatorExpressions_SubtractExpression_ChildExpression.fromJson(json.left);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = ValidatorExpressions_SubtractExpression_ChildExpression.fromJson(json.right);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeft && !this._left.isEmpty()) {
      result.left = ValidatorExpressions_SubtractExpression_ChildExpression.toJson(this._left);
    }
    if (this._hasRight && !this._right.isEmpty()) {
      result.right = ValidatorExpressions_SubtractExpression_ChildExpression.toJson(this._right);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_SubtractExpression_ChildExpression}
   */
  get left() {
    return this._hasLeft ? this._left : ValidatorExpressions_SubtractExpression_ChildExpression.default;
  }
  get hasLeft() {
    return this._hasLeft;
  }
  setLeft(path, value) {
    return {type: 'SET', path: path.concat(['left']), value: value.toJson()};
  }
  deleteLeft(path) {
    return {type: 'DELETE', path: path.concat(['left'])};
  }
  /**
   * @returns {ValidatorExpressions_SubtractExpression_ChildExpression}
   */
  get right() {
    return this._hasRight ? this._right : ValidatorExpressions_SubtractExpression_ChildExpression.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value: value.toJson()};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "left": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_SubtractExpression(this);
              copy._hasLeft = true;
              copy._left = ValidatorExpressions_SubtractExpression_ChildExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeft) {
                return this;
              }
              const copy = new ValidatorExpressions_SubtractExpression(this);
              copy._hasLeft = false;
              copy._left = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeft) {
            const copy = new ValidatorExpressions_SubtractExpression(this);
            copy._hasLeft = true;
            copy._left = ValidatorExpressions_SubtractExpression_ChildExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._left.apply(type, path.slice(1), value);
          if (newValue === this._left) {
            return this;
          }
          const copy = new ValidatorExpressions_SubtractExpression(this);
          copy._left = copy._left.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_SubtractExpression(this);
              copy._hasRight = true;
              copy._right = ValidatorExpressions_SubtractExpression_ChildExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new ValidatorExpressions_SubtractExpression(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRight) {
            const copy = new ValidatorExpressions_SubtractExpression(this);
            copy._hasRight = true;
            copy._right = ValidatorExpressions_SubtractExpression_ChildExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._right.apply(type, path.slice(1), value);
          if (newValue === this._right) {
            return this;
          }
          const copy = new ValidatorExpressions_SubtractExpression(this);
          copy._right = copy._right.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_SubtractExpression} other
   * @returns {ValidatorExpressions_SubtractExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_SubtractExpression(this);
    if (other._hasLeft) {
      if (copy._hasLeft) {
        copy._left = copy.left.merge(other.left);
      } else {
        copy._left = other._left;
      }
      copy._hasLeft = true;
    }
    if (other._hasRight) {
      if (copy._hasRight) {
        copy._right = copy.right.merge(other.right);
      } else {
        copy._right = other._right;
      }
      copy._hasRight = true;
    }
    return copy;
  }
}
ValidatorExpressions_SubtractExpression.default = new ValidatorExpressions_SubtractExpression();
ValidatorExpressions_SubtractExpression.ChildExpression = ValidatorExpressions_SubtractExpression_ChildExpression;
class ValidatorExpressions_SubtractExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_SubtractExpression(value);
  }
  build() {
    return new ValidatorExpressions_SubtractExpression(this._value);
  }
  setLeft(value) {
    this._value._hasLeft = true;
    this._value._left = value;
    return this;
  }
  deleteLeft() {
    this._value._hasLeft = false;
    this._value._left = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
}
ValidatorExpressions_SubtractExpression.Builder = ValidatorExpressions_SubtractExpression_Builder;
class ValidatorExpressions_SubtractExpression_WithParent {
  /**
   * @param {ValidatorExpressions_SubtractExpression} value
   * @param {ValidatorExpressions_SubtractExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_SubtractExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeft() {
    if (this._cachedHasLeft === undefined) {
      if (this._value.hasLeft) {
        this._cachedHasLeft = true;
      } else {
        this._cachedHasLeft = this._parent ? this._parent.hasLeft : false;
      }
    }
    return this._cachedHasLeft;
  }
  get left() {
    if (!this._cachedLeft) {
      if (this._value.hasLeft) {
        this._cachedLeft = new ValidatorExpressions_SubtractExpression_ChildExpression.WithParent(this._value.left, this._parent && this._parent.hasLeft ? this._parent.left : null);
      } else {
        this._cachedLeft = this._parent ? new ValidatorExpressions_SubtractExpression_ChildExpression.WithParent(ValidatorExpressions_SubtractExpression_ChildExpression.default, this._parent.left) : ValidatorExpressions_SubtractExpression_ChildExpression.WithParent.default;
      }
    }
    return this._cachedLeft;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (!this._cachedRight) {
      if (this._value.hasRight) {
        this._cachedRight = new ValidatorExpressions_SubtractExpression_ChildExpression.WithParent(this._value.right, this._parent && this._parent.hasRight ? this._parent.right : null);
      } else {
        this._cachedRight = this._parent ? new ValidatorExpressions_SubtractExpression_ChildExpression.WithParent(ValidatorExpressions_SubtractExpression_ChildExpression.default, this._parent.right) : ValidatorExpressions_SubtractExpression_ChildExpression.WithParent.default;
      }
    }
    return this._cachedRight;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_SubtractExpression_WithParent(current, parent);
    if (this._cachedLeft && this._value.hasLeft && current.hasLeft) {
      if (this._value.left === current.left && this._parent === parent) {
        result._cachedLeft = this._cachedLeft;
      } else {
        result._cachedLeft = this._cachedLeft.update(current.left, parent && parent.hasLeft ? parent.left : null);
      }
    }
    if (this._cachedRight && this._value.hasRight && current.hasRight) {
      if (this._value.right === current.right && this._parent === parent) {
        result._cachedRight = this._cachedRight;
      } else {
        result._cachedRight = this._cachedRight.update(current.right, parent && parent.hasRight ? parent.right : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_SubtractExpression_WithParent.default = new ValidatorExpressions_SubtractExpression_WithParent(ValidatorExpressions_SubtractExpression.default, null);
ValidatorExpressions_SubtractExpression.WithParent = ValidatorExpressions_SubtractExpression_WithParent;
class ValidatorExpressions_SubtractExpression_Descriptor {
  get left() {
    if (!this._left) {
      this._left = {
        name: "left",
        Name: "Left",
        number: 1,
        protoType: 11,
        protoName: "left",
        type: ValidatorExpressions_SubtractExpression_ChildExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._left;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 2,
        protoType: 11,
        protoName: "right",
        type: ValidatorExpressions_SubtractExpression_ChildExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.left,
        this.right,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeft",
        Name: "DummyOneofForLeft",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_SubtractExpression.descriptor = new ValidatorExpressions_SubtractExpression_Descriptor();
class ValidatorExpressions_AddExpression {
  get descriptor() {
    return ValidatorExpressions_AddExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressions = [];
  }
  isEmpty() {
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_AddExpression) {
      return value;
    }
    return ValidatorExpressions_AddExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_AddExpression();
    result._expressions = JsonToList(json.expressions, ValidatorExpressions_Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, ValidatorExpressions_Expression);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, ValidatorExpressions_Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_AddExpression(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(ValidatorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ValidatorExpressions_AddExpression(this);
              copy._expressions = copy._expressions.concat([ValidatorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new ValidatorExpressions_AddExpression(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_AddExpression(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = ValidatorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ValidatorExpressions_AddExpression(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ValidatorExpressions_AddExpression(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_AddExpression} other
   * @returns {ValidatorExpressions_AddExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_AddExpression(this);
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
ValidatorExpressions_AddExpression.default = new ValidatorExpressions_AddExpression();
class ValidatorExpressions_AddExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_AddExpression(value);
  }
  build() {
    return new ValidatorExpressions_AddExpression(this._value);
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
ValidatorExpressions_AddExpression.Builder = ValidatorExpressions_AddExpression_Builder;
class ValidatorExpressions_AddExpression_WithParent {
  /**
   * @param {ValidatorExpressions_AddExpression} value
   * @param {ValidatorExpressions_AddExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_AddExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new ValidatorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_AddExpression_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new ValidatorExpressions_Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ValidatorExpressions_AddExpression_WithParent.default = new ValidatorExpressions_AddExpression_WithParent(ValidatorExpressions_AddExpression.default, null);
ValidatorExpressions_AddExpression.WithParent = ValidatorExpressions_AddExpression_WithParent;
class ValidatorExpressions_AddExpression_Descriptor {
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 1,
        protoType: 11,
        protoName: "expressions",
        type: ValidatorExpressions_Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ValidatorExpressions_AddExpression.descriptor = new ValidatorExpressions_AddExpression_Descriptor();
class ValidatorExpressions_CompareExpression_ChildExpression {
  get descriptor() {
    return ValidatorExpressions_CompareExpression_ChildExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofTypeCase = 0;
    this._oneofTypeValue = null;
  }
  isEmpty() {
    if (this._oneofTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_CompareExpression_ChildExpression) {
      return value;
    }
    return ValidatorExpressions_CompareExpression_ChildExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_CompareExpression_ChildExpression();
    if (json.value != null) {
      result._oneofTypeCase = 1;
      result._oneofTypeValue = ValidatorExpressions_Value.fromJson(json.value);
    }
    if (json.divide != null) {
      result._oneofTypeCase = 2;
      result._oneofTypeValue = ValidatorExpressions_DivideExpression.fromJson(json.divide);
    }
    if (json.multiply != null) {
      result._oneofTypeCase = 3;
      result._oneofTypeValue = ValidatorExpressions_MultiplyExpression.fromJson(json.multiply);
    }
    if (json.subtract != null) {
      result._oneofTypeCase = 4;
      result._oneofTypeValue = ValidatorExpressions_SubtractExpression.fromJson(json.subtract);
    }
    if (json.add != null) {
      result._oneofTypeCase = 5;
      result._oneofTypeValue = ValidatorExpressions_AddExpression.fromJson(json.add);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofTypeCase) {
      case 1:
        result.value = ValidatorExpressions_Value.toJson(this._oneofTypeValue);
        break;
      case 2:
        result.divide = ValidatorExpressions_DivideExpression.toJson(this._oneofTypeValue);
        break;
      case 3:
        result.multiply = ValidatorExpressions_MultiplyExpression.toJson(this._oneofTypeValue);
        break;
      case 4:
        result.subtract = ValidatorExpressions_SubtractExpression.toJson(this._oneofTypeValue);
        break;
      case 5:
        result.add = ValidatorExpressions_AddExpression.toJson(this._oneofTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofTypeCase() {
    return this._oneofTypeCase;
  }
  deleteOneofType(path) {
    switch (this._oneofTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['divide'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['multiply'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['subtract'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['add'])};
      }
    }
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get value() {
    return this._oneofTypeCase === 1 ? this._oneofTypeValue : ValidatorExpressions_Value.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {ValidatorExpressions_DivideExpression}
   */
  get divide() {
    return this._oneofTypeCase === 2 ? this._oneofTypeValue : ValidatorExpressions_DivideExpression.default;
  }
  setDivide(path, value) {
    return {type: 'SET', path: path.concat(['divide']), value: value.toJson()};
  }
  deleteDivide(path) {
    return {type: 'DELETE', path: path.concat(['divide'])};
  }
  /**
   * @returns {ValidatorExpressions_MultiplyExpression}
   */
  get multiply() {
    return this._oneofTypeCase === 3 ? this._oneofTypeValue : ValidatorExpressions_MultiplyExpression.default;
  }
  setMultiply(path, value) {
    return {type: 'SET', path: path.concat(['multiply']), value: value.toJson()};
  }
  deleteMultiply(path) {
    return {type: 'DELETE', path: path.concat(['multiply'])};
  }
  /**
   * @returns {ValidatorExpressions_SubtractExpression}
   */
  get subtract() {
    return this._oneofTypeCase === 4 ? this._oneofTypeValue : ValidatorExpressions_SubtractExpression.default;
  }
  setSubtract(path, value) {
    return {type: 'SET', path: path.concat(['subtract']), value: value.toJson()};
  }
  deleteSubtract(path) {
    return {type: 'DELETE', path: path.concat(['subtract'])};
  }
  /**
   * @returns {ValidatorExpressions_AddExpression}
   */
  get add() {
    return this._oneofTypeCase === 5 ? this._oneofTypeValue : ValidatorExpressions_AddExpression.default;
  }
  setAdd(path, value) {
    return {type: 'SET', path: path.concat(['add']), value: value.toJson()};
  }
  deleteAdd(path) {
    return {type: 'DELETE', path: path.concat(['add'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 1;
              copy._oneofTypeValue = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 1) {
                return this;
              }
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 1) {
            const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
            copy._oneofTypeCase = 1;
            copy._oneofTypeValue = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.value.apply(type, path.slice(1), value);
          if (newValue === this.value) {
            return this;
          }
          const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
          copy._oneofTypeCase = 1;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "divide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 2;
              copy._oneofTypeValue = ValidatorExpressions_DivideExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 2) {
                return this;
              }
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 2) {
            const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
            copy._oneofTypeCase = 2;
            copy._oneofTypeValue = ValidatorExpressions_DivideExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.divide.apply(type, path.slice(1), value);
          if (newValue === this.divide) {
            return this;
          }
          const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
          copy._oneofTypeCase = 2;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "multiply": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 3;
              copy._oneofTypeValue = ValidatorExpressions_MultiplyExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 3) {
                return this;
              }
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 3) {
            const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
            copy._oneofTypeCase = 3;
            copy._oneofTypeValue = ValidatorExpressions_MultiplyExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.multiply.apply(type, path.slice(1), value);
          if (newValue === this.multiply) {
            return this;
          }
          const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
          copy._oneofTypeCase = 3;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "subtract": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 4;
              copy._oneofTypeValue = ValidatorExpressions_SubtractExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 4) {
                return this;
              }
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 4) {
            const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
            copy._oneofTypeCase = 4;
            copy._oneofTypeValue = ValidatorExpressions_SubtractExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.subtract.apply(type, path.slice(1), value);
          if (newValue === this.subtract) {
            return this;
          }
          const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
          copy._oneofTypeCase = 4;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "add": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 5;
              copy._oneofTypeValue = ValidatorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 5) {
                return this;
              }
              const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 5) {
            const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
            copy._oneofTypeCase = 5;
            copy._oneofTypeValue = ValidatorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.add.apply(type, path.slice(1), value);
          if (newValue === this.add) {
            return this;
          }
          const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
          copy._oneofTypeCase = 5;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_CompareExpression_ChildExpression} other
   * @returns {ValidatorExpressions_CompareExpression_ChildExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_CompareExpression_ChildExpression(this);
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    return copy;
  }
}
ValidatorExpressions_CompareExpression_ChildExpression.default = new ValidatorExpressions_CompareExpression_ChildExpression();
class ValidatorExpressions_CompareExpression_ChildExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_CompareExpression_ChildExpression(value);
  }
  build() {
    return new ValidatorExpressions_CompareExpression_ChildExpression(this._value);
  }
  clearoneofType() {
    this._value._oneofTypeCase = 0;
    this._value._oneofTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._oneofTypeCase = 1;
    this._value._oneofTypeValue = value;
    return this;
  }
  setDivide(value) {
    this._value._oneofTypeCase = 2;
    this._value._oneofTypeValue = value;
    return this;
  }
  setMultiply(value) {
    this._value._oneofTypeCase = 3;
    this._value._oneofTypeValue = value;
    return this;
  }
  setSubtract(value) {
    this._value._oneofTypeCase = 4;
    this._value._oneofTypeValue = value;
    return this;
  }
  setAdd(value) {
    this._value._oneofTypeCase = 5;
    this._value._oneofTypeValue = value;
    return this;
  }
}
ValidatorExpressions_CompareExpression_ChildExpression.Builder = ValidatorExpressions_CompareExpression_ChildExpression_Builder;
class ValidatorExpressions_CompareExpression_ChildExpression_WithParent {
  /**
   * @param {ValidatorExpressions_CompareExpression_ChildExpression} value
   * @param {ValidatorExpressions_CompareExpression_ChildExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_CompareExpression_ChildExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofTypeCase() {
    if (this._cachedoneofTypeCase === undefined) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedoneofTypeCase = this._parent ? this._parent.oneofTypeCase : 0;
      } else {
        this._cachedoneofTypeCase = this._value._oneofTypeCase;
      }
    }
    return this._cachedoneofTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedValue = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.value) : this._value.value;
      } else if (this._value._oneofTypeCase === 1) {
        this._cachedValue = new ValidatorExpressions_Value.WithParent(this._value.value, this._parent && this._parent.oneofTypeCase === 1 ? this._parent.value : null);
      } else {
        this._cachedValue = ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  get divide() {
    if (!this._cachedDivide) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedDivide = this._parent ? new ValidatorExpressions_DivideExpression.WithParent(ValidatorExpressions_DivideExpression.default, this._parent.divide) : this._value.divide;
      } else if (this._value._oneofTypeCase === 2) {
        this._cachedDivide = new ValidatorExpressions_DivideExpression.WithParent(this._value.divide, this._parent && this._parent.oneofTypeCase === 2 ? this._parent.divide : null);
      } else {
        this._cachedDivide = ValidatorExpressions_DivideExpression.WithParent.default;
      }
    }
    return this._cachedDivide;
  }
  get multiply() {
    if (!this._cachedMultiply) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedMultiply = this._parent ? new ValidatorExpressions_MultiplyExpression.WithParent(ValidatorExpressions_MultiplyExpression.default, this._parent.multiply) : this._value.multiply;
      } else if (this._value._oneofTypeCase === 3) {
        this._cachedMultiply = new ValidatorExpressions_MultiplyExpression.WithParent(this._value.multiply, this._parent && this._parent.oneofTypeCase === 3 ? this._parent.multiply : null);
      } else {
        this._cachedMultiply = ValidatorExpressions_MultiplyExpression.WithParent.default;
      }
    }
    return this._cachedMultiply;
  }
  get subtract() {
    if (!this._cachedSubtract) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedSubtract = this._parent ? new ValidatorExpressions_SubtractExpression.WithParent(ValidatorExpressions_SubtractExpression.default, this._parent.subtract) : this._value.subtract;
      } else if (this._value._oneofTypeCase === 4) {
        this._cachedSubtract = new ValidatorExpressions_SubtractExpression.WithParent(this._value.subtract, this._parent && this._parent.oneofTypeCase === 4 ? this._parent.subtract : null);
      } else {
        this._cachedSubtract = ValidatorExpressions_SubtractExpression.WithParent.default;
      }
    }
    return this._cachedSubtract;
  }
  get add() {
    if (!this._cachedAdd) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedAdd = this._parent ? new ValidatorExpressions_AddExpression.WithParent(ValidatorExpressions_AddExpression.default, this._parent.add) : this._value.add;
      } else if (this._value._oneofTypeCase === 5) {
        this._cachedAdd = new ValidatorExpressions_AddExpression.WithParent(this._value.add, this._parent && this._parent.oneofTypeCase === 5 ? this._parent.add : null);
      } else {
        this._cachedAdd = ValidatorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedAdd;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_CompareExpression_ChildExpression_WithParent(current, parent);
    if (this._cachedValue && this._value._oneofTypeCase === 1 && current._oneofTypeCase === 1) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.oneofTypeCase === 1 ? parent.value : null);
      }
    }
    if (this._cachedDivide && this._value._oneofTypeCase === 2 && current._oneofTypeCase === 2) {
      if (this._value.divide === current.divide && this._parent === parent) {
        result._cachedDivide = this._cachedDivide;
      } else {
        result._cachedDivide = this._cachedDivide.update(current.divide, parent && parent.oneofTypeCase === 2 ? parent.divide : null);
      }
    }
    if (this._cachedMultiply && this._value._oneofTypeCase === 3 && current._oneofTypeCase === 3) {
      if (this._value.multiply === current.multiply && this._parent === parent) {
        result._cachedMultiply = this._cachedMultiply;
      } else {
        result._cachedMultiply = this._cachedMultiply.update(current.multiply, parent && parent.oneofTypeCase === 3 ? parent.multiply : null);
      }
    }
    if (this._cachedSubtract && this._value._oneofTypeCase === 4 && current._oneofTypeCase === 4) {
      if (this._value.subtract === current.subtract && this._parent === parent) {
        result._cachedSubtract = this._cachedSubtract;
      } else {
        result._cachedSubtract = this._cachedSubtract.update(current.subtract, parent && parent.oneofTypeCase === 4 ? parent.subtract : null);
      }
    }
    if (this._cachedAdd && this._value._oneofTypeCase === 5 && current._oneofTypeCase === 5) {
      if (this._value.add === current.add && this._parent === parent) {
        result._cachedAdd = this._cachedAdd;
      } else {
        result._cachedAdd = this._cachedAdd.update(current.add, parent && parent.oneofTypeCase === 5 ? parent.add : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_CompareExpression_ChildExpression_WithParent.default = new ValidatorExpressions_CompareExpression_ChildExpression_WithParent(ValidatorExpressions_CompareExpression_ChildExpression.default, null);
ValidatorExpressions_CompareExpression_ChildExpression.WithParent = ValidatorExpressions_CompareExpression_ChildExpression_WithParent;
class ValidatorExpressions_CompareExpression_ChildExpression_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 11,
        protoName: "value",
        oneofIndex: 0,
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get divide() {
    if (!this._divide) {
      this._divide = {
        name: "divide",
        Name: "Divide",
        number: 2,
        protoType: 11,
        protoName: "divide",
        oneofIndex: 0,
        type: ValidatorExpressions_DivideExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._divide;
  }
  get multiply() {
    if (!this._multiply) {
      this._multiply = {
        name: "multiply",
        Name: "Multiply",
        number: 3,
        protoType: 11,
        protoName: "multiply",
        oneofIndex: 0,
        type: ValidatorExpressions_MultiplyExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiply;
  }
  get subtract() {
    if (!this._subtract) {
      this._subtract = {
        name: "subtract",
        Name: "Subtract",
        number: 4,
        protoType: 11,
        protoName: "subtract",
        oneofIndex: 0,
        type: ValidatorExpressions_SubtractExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subtract;
  }
  get add() {
    if (!this._add) {
      this._add = {
        name: "add",
        Name: "Add",
        number: 5,
        protoType: 11,
        protoName: "add",
        oneofIndex: 0,
        type: ValidatorExpressions_AddExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._add;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.divide,
        this.multiply,
        this.subtract,
        this.add,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofType",
        Name: "OneofType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_CompareExpression_ChildExpression.descriptor = new ValidatorExpressions_CompareExpression_ChildExpression_Descriptor();
class ValidatorExpressions_CompareExpression_Operator {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "EQUAL": return 0;
        case "NOT_EQUAL": return 1;
        case "GREATER_THAN": return 2;
        case "LESS_THAN": return 3;
        case "GREATER_OR_EQUAL": return 4;
        case "LESS_OR_EQUAL": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ValidatorExpressions_CompareExpression_Operator.fromJson(value);
  }
  static fromReact(e) {
    return ValidatorExpressions_CompareExpression_Operator.fromJson(e);
  }
}
ValidatorExpressions_CompareExpression_Operator.EQUAL = 0;
ValidatorExpressions_CompareExpression_Operator.NOT_EQUAL = 1;
ValidatorExpressions_CompareExpression_Operator.GREATER_THAN = 2;
ValidatorExpressions_CompareExpression_Operator.LESS_THAN = 3;
ValidatorExpressions_CompareExpression_Operator.GREATER_OR_EQUAL = 4;
ValidatorExpressions_CompareExpression_Operator.LESS_OR_EQUAL = 5;
ValidatorExpressions_CompareExpression_Operator.default = 0;
ValidatorExpressions_CompareExpression_Operator.values = {
  EQUAL: 0,
  NOT_EQUAL: 1,
  GREATER_THAN: 2,
  LESS_THAN: 3,
  GREATER_OR_EQUAL: 4,
  LESS_OR_EQUAL: 5,
};
ValidatorExpressions_CompareExpression_Operator.names = {
  0: "EQUAL",
  1: "NOT_EQUAL",
  2: "GREATER_THAN",
  3: "LESS_THAN",
  4: "GREATER_OR_EQUAL",
  5: "LESS_OR_EQUAL",
};
class ValidatorExpressions_CompareExpression {
  get descriptor() {
    return ValidatorExpressions_CompareExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeft = false;
    this._left = null;
    this._hasOp = false;
    this._op = null;
    this._hasRight = false;
    this._right = null;
  }
  isEmpty() {
    if (this._hasLeft && !this._left.isEmpty()) return false;
    if (this._hasOp) return false;
    if (this._hasRight && !this._right.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_CompareExpression) {
      return value;
    }
    return ValidatorExpressions_CompareExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_CompareExpression();
    if (json.left != null) {
      result._hasLeft = true;
      result._left = ValidatorExpressions_CompareExpression_ChildExpression.fromJson(json.left);
    }
    if (json.op != null) {
      result._hasOp = true;
      result._op = ValidatorExpressions_CompareExpression_Operator.fromJson(json.op);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = ValidatorExpressions_CompareExpression_ChildExpression.fromJson(json.right);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeft && !this._left.isEmpty()) {
      result.left = ValidatorExpressions_CompareExpression_ChildExpression.toJson(this._left);
    }
    if (this._hasOp) {
      result.op = ValidatorExpressions_CompareExpression_Operator.toJson(this._op);
    }
    if (this._hasRight && !this._right.isEmpty()) {
      result.right = ValidatorExpressions_CompareExpression_ChildExpression.toJson(this._right);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_CompareExpression_ChildExpression}
   */
  get left() {
    return this._hasLeft ? this._left : ValidatorExpressions_CompareExpression_ChildExpression.default;
  }
  get hasLeft() {
    return this._hasLeft;
  }
  setLeft(path, value) {
    return {type: 'SET', path: path.concat(['left']), value: value.toJson()};
  }
  deleteLeft(path) {
    return {type: 'DELETE', path: path.concat(['left'])};
  }
  /**
   * @returns {number}
   */
  get op() {
    return this._hasOp ? this._op : ValidatorExpressions_CompareExpression_Operator.default;
  }
  get hasOp() {
    return this._hasOp;
  }
  setOp(path, value) {
    return {type: 'SET', path: path.concat(['op']), value};
  }
  deleteOp(path) {
    return {type: 'DELETE', path: path.concat(['op'])};
  }
  /**
   * @returns {ValidatorExpressions_CompareExpression_ChildExpression}
   */
  get right() {
    return this._hasRight ? this._right : ValidatorExpressions_CompareExpression_ChildExpression.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value: value.toJson()};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "left": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_CompareExpression(this);
              copy._hasLeft = true;
              copy._left = ValidatorExpressions_CompareExpression_ChildExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeft) {
                return this;
              }
              const copy = new ValidatorExpressions_CompareExpression(this);
              copy._hasLeft = false;
              copy._left = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeft) {
            const copy = new ValidatorExpressions_CompareExpression(this);
            copy._hasLeft = true;
            copy._left = ValidatorExpressions_CompareExpression_ChildExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._left.apply(type, path.slice(1), value);
          if (newValue === this._left) {
            return this;
          }
          const copy = new ValidatorExpressions_CompareExpression(this);
          copy._left = copy._left.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "op": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_CompareExpression(this);
              copy._hasOp = true;
              copy._op = ValidatorExpressions_CompareExpression_Operator.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOp) {
                return this;
              }
              const copy = new ValidatorExpressions_CompareExpression(this);
              copy._hasOp = false;
              copy._op = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_CompareExpression(this);
              copy._hasRight = true;
              copy._right = ValidatorExpressions_CompareExpression_ChildExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new ValidatorExpressions_CompareExpression(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRight) {
            const copy = new ValidatorExpressions_CompareExpression(this);
            copy._hasRight = true;
            copy._right = ValidatorExpressions_CompareExpression_ChildExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._right.apply(type, path.slice(1), value);
          if (newValue === this._right) {
            return this;
          }
          const copy = new ValidatorExpressions_CompareExpression(this);
          copy._right = copy._right.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_CompareExpression} other
   * @returns {ValidatorExpressions_CompareExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_CompareExpression(this);
    if (other._hasLeft) {
      if (copy._hasLeft) {
        copy._left = copy.left.merge(other.left);
      } else {
        copy._left = other._left;
      }
      copy._hasLeft = true;
    }
    if (other._hasOp) {
      copy._hasOp = true;
      copy._op = other._op;
    }
    if (other._hasRight) {
      if (copy._hasRight) {
        copy._right = copy.right.merge(other.right);
      } else {
        copy._right = other._right;
      }
      copy._hasRight = true;
    }
    return copy;
  }
}
ValidatorExpressions_CompareExpression.default = new ValidatorExpressions_CompareExpression();
ValidatorExpressions_CompareExpression.ChildExpression = ValidatorExpressions_CompareExpression_ChildExpression;
ValidatorExpressions_CompareExpression.Operator = ValidatorExpressions_CompareExpression_Operator;
class ValidatorExpressions_CompareExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_CompareExpression(value);
  }
  build() {
    return new ValidatorExpressions_CompareExpression(this._value);
  }
  setLeft(value) {
    this._value._hasLeft = true;
    this._value._left = value;
    return this;
  }
  deleteLeft() {
    this._value._hasLeft = false;
    this._value._left = null;
    return this;
  }
  setOp(value) {
    this._value._hasOp = true;
    this._value._op = value;
    return this;
  }
  deleteOp() {
    this._value._hasOp = false;
    this._value._op = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
}
ValidatorExpressions_CompareExpression.Builder = ValidatorExpressions_CompareExpression_Builder;
class ValidatorExpressions_CompareExpression_WithParent {
  /**
   * @param {ValidatorExpressions_CompareExpression} value
   * @param {ValidatorExpressions_CompareExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_CompareExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeft() {
    if (this._cachedHasLeft === undefined) {
      if (this._value.hasLeft) {
        this._cachedHasLeft = true;
      } else {
        this._cachedHasLeft = this._parent ? this._parent.hasLeft : false;
      }
    }
    return this._cachedHasLeft;
  }
  get left() {
    if (!this._cachedLeft) {
      if (this._value.hasLeft) {
        this._cachedLeft = new ValidatorExpressions_CompareExpression_ChildExpression.WithParent(this._value.left, this._parent && this._parent.hasLeft ? this._parent.left : null);
      } else {
        this._cachedLeft = this._parent ? new ValidatorExpressions_CompareExpression_ChildExpression.WithParent(ValidatorExpressions_CompareExpression_ChildExpression.default, this._parent.left) : ValidatorExpressions_CompareExpression_ChildExpression.WithParent.default;
      }
    }
    return this._cachedLeft;
  }
  get hasOp() {
    if (this._cachedHasOp === undefined) {
      if (this._value.hasOp) {
        this._cachedHasOp = true;
      } else {
        this._cachedHasOp = this._parent ? this._parent.hasOp : false;
      }
    }
    return this._cachedHasOp;
  }
  get op() {
    if (this._cachedOp === undefined) {
      if (this._value.hasOp) {
        this._cachedOp = this._value.op;
      } else {
        this._cachedOp = this._parent ? this._parent.op : this._value.op;
      }
    }
    return this._cachedOp;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (!this._cachedRight) {
      if (this._value.hasRight) {
        this._cachedRight = new ValidatorExpressions_CompareExpression_ChildExpression.WithParent(this._value.right, this._parent && this._parent.hasRight ? this._parent.right : null);
      } else {
        this._cachedRight = this._parent ? new ValidatorExpressions_CompareExpression_ChildExpression.WithParent(ValidatorExpressions_CompareExpression_ChildExpression.default, this._parent.right) : ValidatorExpressions_CompareExpression_ChildExpression.WithParent.default;
      }
    }
    return this._cachedRight;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_CompareExpression_WithParent(current, parent);
    if (this._cachedLeft && this._value.hasLeft && current.hasLeft) {
      if (this._value.left === current.left && this._parent === parent) {
        result._cachedLeft = this._cachedLeft;
      } else {
        result._cachedLeft = this._cachedLeft.update(current.left, parent && parent.hasLeft ? parent.left : null);
      }
    }
    if (this._cachedRight && this._value.hasRight && current.hasRight) {
      if (this._value.right === current.right && this._parent === parent) {
        result._cachedRight = this._cachedRight;
      } else {
        result._cachedRight = this._cachedRight.update(current.right, parent && parent.hasRight ? parent.right : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_CompareExpression_WithParent.default = new ValidatorExpressions_CompareExpression_WithParent(ValidatorExpressions_CompareExpression.default, null);
ValidatorExpressions_CompareExpression.WithParent = ValidatorExpressions_CompareExpression_WithParent;
class ValidatorExpressions_CompareExpression_Descriptor {
  get left() {
    if (!this._left) {
      this._left = {
        name: "left",
        Name: "Left",
        number: 1,
        protoType: 11,
        protoName: "left",
        type: ValidatorExpressions_CompareExpression_ChildExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._left;
  }
  get op() {
    if (!this._op) {
      this._op = {
        name: "op",
        Name: "Op",
        number: 2,
        protoType: 14,
        protoName: "op",
        type: ValidatorExpressions_CompareExpression_Operator,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._op;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 3,
        protoType: 11,
        protoName: "right",
        type: ValidatorExpressions_CompareExpression_ChildExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.left,
        this.op,
        this.right,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeft",
        Name: "DummyOneofForLeft",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOp",
        Name: "DummyOneofForOp",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_CompareExpression.descriptor = new ValidatorExpressions_CompareExpression_Descriptor();
class ValidatorExpressions_LogicNotExpression_ChildExpression {
  get descriptor() {
    return ValidatorExpressions_LogicNotExpression_ChildExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofTypeCase = 0;
    this._oneofTypeValue = null;
  }
  isEmpty() {
    if (this._oneofTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_LogicNotExpression_ChildExpression) {
      return value;
    }
    return ValidatorExpressions_LogicNotExpression_ChildExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_LogicNotExpression_ChildExpression();
    if (json.value != null) {
      result._oneofTypeCase = 1;
      result._oneofTypeValue = ValidatorExpressions_Value.fromJson(json.value);
    }
    if (json.divide != null) {
      result._oneofTypeCase = 2;
      result._oneofTypeValue = ValidatorExpressions_DivideExpression.fromJson(json.divide);
    }
    if (json.multiply != null) {
      result._oneofTypeCase = 3;
      result._oneofTypeValue = ValidatorExpressions_MultiplyExpression.fromJson(json.multiply);
    }
    if (json.subtract != null) {
      result._oneofTypeCase = 4;
      result._oneofTypeValue = ValidatorExpressions_SubtractExpression.fromJson(json.subtract);
    }
    if (json.add != null) {
      result._oneofTypeCase = 5;
      result._oneofTypeValue = ValidatorExpressions_AddExpression.fromJson(json.add);
    }
    if (json.compare != null) {
      result._oneofTypeCase = 6;
      result._oneofTypeValue = ValidatorExpressions_CompareExpression.fromJson(json.compare);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofTypeCase) {
      case 1:
        result.value = ValidatorExpressions_Value.toJson(this._oneofTypeValue);
        break;
      case 2:
        result.divide = ValidatorExpressions_DivideExpression.toJson(this._oneofTypeValue);
        break;
      case 3:
        result.multiply = ValidatorExpressions_MultiplyExpression.toJson(this._oneofTypeValue);
        break;
      case 4:
        result.subtract = ValidatorExpressions_SubtractExpression.toJson(this._oneofTypeValue);
        break;
      case 5:
        result.add = ValidatorExpressions_AddExpression.toJson(this._oneofTypeValue);
        break;
      case 6:
        result.compare = ValidatorExpressions_CompareExpression.toJson(this._oneofTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get oneofTypeCase() {
    return this._oneofTypeCase;
  }
  deleteOneofType(path) {
    switch (this._oneofTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['divide'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['multiply'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['subtract'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['add'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['compare'])};
      }
    }
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get value() {
    return this._oneofTypeCase === 1 ? this._oneofTypeValue : ValidatorExpressions_Value.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {ValidatorExpressions_DivideExpression}
   */
  get divide() {
    return this._oneofTypeCase === 2 ? this._oneofTypeValue : ValidatorExpressions_DivideExpression.default;
  }
  setDivide(path, value) {
    return {type: 'SET', path: path.concat(['divide']), value: value.toJson()};
  }
  deleteDivide(path) {
    return {type: 'DELETE', path: path.concat(['divide'])};
  }
  /**
   * @returns {ValidatorExpressions_MultiplyExpression}
   */
  get multiply() {
    return this._oneofTypeCase === 3 ? this._oneofTypeValue : ValidatorExpressions_MultiplyExpression.default;
  }
  setMultiply(path, value) {
    return {type: 'SET', path: path.concat(['multiply']), value: value.toJson()};
  }
  deleteMultiply(path) {
    return {type: 'DELETE', path: path.concat(['multiply'])};
  }
  /**
   * @returns {ValidatorExpressions_SubtractExpression}
   */
  get subtract() {
    return this._oneofTypeCase === 4 ? this._oneofTypeValue : ValidatorExpressions_SubtractExpression.default;
  }
  setSubtract(path, value) {
    return {type: 'SET', path: path.concat(['subtract']), value: value.toJson()};
  }
  deleteSubtract(path) {
    return {type: 'DELETE', path: path.concat(['subtract'])};
  }
  /**
   * @returns {ValidatorExpressions_AddExpression}
   */
  get add() {
    return this._oneofTypeCase === 5 ? this._oneofTypeValue : ValidatorExpressions_AddExpression.default;
  }
  setAdd(path, value) {
    return {type: 'SET', path: path.concat(['add']), value: value.toJson()};
  }
  deleteAdd(path) {
    return {type: 'DELETE', path: path.concat(['add'])};
  }
  /**
   * @returns {ValidatorExpressions_CompareExpression}
   */
  get compare() {
    return this._oneofTypeCase === 6 ? this._oneofTypeValue : ValidatorExpressions_CompareExpression.default;
  }
  setCompare(path, value) {
    return {type: 'SET', path: path.concat(['compare']), value: value.toJson()};
  }
  deleteCompare(path) {
    return {type: 'DELETE', path: path.concat(['compare'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 1;
              copy._oneofTypeValue = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 1) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 1) {
            const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 1;
            copy._oneofTypeValue = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.value.apply(type, path.slice(1), value);
          if (newValue === this.value) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 1;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "divide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 2;
              copy._oneofTypeValue = ValidatorExpressions_DivideExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 2) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 2) {
            const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 2;
            copy._oneofTypeValue = ValidatorExpressions_DivideExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.divide.apply(type, path.slice(1), value);
          if (newValue === this.divide) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 2;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "multiply": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 3;
              copy._oneofTypeValue = ValidatorExpressions_MultiplyExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 3) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 3) {
            const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 3;
            copy._oneofTypeValue = ValidatorExpressions_MultiplyExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.multiply.apply(type, path.slice(1), value);
          if (newValue === this.multiply) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 3;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "subtract": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 4;
              copy._oneofTypeValue = ValidatorExpressions_SubtractExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 4) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 4) {
            const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 4;
            copy._oneofTypeValue = ValidatorExpressions_SubtractExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.subtract.apply(type, path.slice(1), value);
          if (newValue === this.subtract) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 4;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "add": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 5;
              copy._oneofTypeValue = ValidatorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 5) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 5) {
            const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 5;
            copy._oneofTypeValue = ValidatorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.add.apply(type, path.slice(1), value);
          if (newValue === this.add) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 5;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "compare": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 6;
              copy._oneofTypeValue = ValidatorExpressions_CompareExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 6) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 6) {
            const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
            copy._oneofTypeCase = 6;
            copy._oneofTypeValue = ValidatorExpressions_CompareExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.compare.apply(type, path.slice(1), value);
          if (newValue === this.compare) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
          copy._oneofTypeCase = 6;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_LogicNotExpression_ChildExpression} other
   * @returns {ValidatorExpressions_LogicNotExpression_ChildExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_LogicNotExpression_ChildExpression(this);
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    return copy;
  }
}
ValidatorExpressions_LogicNotExpression_ChildExpression.default = new ValidatorExpressions_LogicNotExpression_ChildExpression();
class ValidatorExpressions_LogicNotExpression_ChildExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_LogicNotExpression_ChildExpression(value);
  }
  build() {
    return new ValidatorExpressions_LogicNotExpression_ChildExpression(this._value);
  }
  clearoneofType() {
    this._value._oneofTypeCase = 0;
    this._value._oneofTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._oneofTypeCase = 1;
    this._value._oneofTypeValue = value;
    return this;
  }
  setDivide(value) {
    this._value._oneofTypeCase = 2;
    this._value._oneofTypeValue = value;
    return this;
  }
  setMultiply(value) {
    this._value._oneofTypeCase = 3;
    this._value._oneofTypeValue = value;
    return this;
  }
  setSubtract(value) {
    this._value._oneofTypeCase = 4;
    this._value._oneofTypeValue = value;
    return this;
  }
  setAdd(value) {
    this._value._oneofTypeCase = 5;
    this._value._oneofTypeValue = value;
    return this;
  }
  setCompare(value) {
    this._value._oneofTypeCase = 6;
    this._value._oneofTypeValue = value;
    return this;
  }
}
ValidatorExpressions_LogicNotExpression_ChildExpression.Builder = ValidatorExpressions_LogicNotExpression_ChildExpression_Builder;
class ValidatorExpressions_LogicNotExpression_ChildExpression_WithParent {
  /**
   * @param {ValidatorExpressions_LogicNotExpression_ChildExpression} value
   * @param {ValidatorExpressions_LogicNotExpression_ChildExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_LogicNotExpression_ChildExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofTypeCase() {
    if (this._cachedoneofTypeCase === undefined) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedoneofTypeCase = this._parent ? this._parent.oneofTypeCase : 0;
      } else {
        this._cachedoneofTypeCase = this._value._oneofTypeCase;
      }
    }
    return this._cachedoneofTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedValue = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.value) : this._value.value;
      } else if (this._value._oneofTypeCase === 1) {
        this._cachedValue = new ValidatorExpressions_Value.WithParent(this._value.value, this._parent && this._parent.oneofTypeCase === 1 ? this._parent.value : null);
      } else {
        this._cachedValue = ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  get divide() {
    if (!this._cachedDivide) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedDivide = this._parent ? new ValidatorExpressions_DivideExpression.WithParent(ValidatorExpressions_DivideExpression.default, this._parent.divide) : this._value.divide;
      } else if (this._value._oneofTypeCase === 2) {
        this._cachedDivide = new ValidatorExpressions_DivideExpression.WithParent(this._value.divide, this._parent && this._parent.oneofTypeCase === 2 ? this._parent.divide : null);
      } else {
        this._cachedDivide = ValidatorExpressions_DivideExpression.WithParent.default;
      }
    }
    return this._cachedDivide;
  }
  get multiply() {
    if (!this._cachedMultiply) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedMultiply = this._parent ? new ValidatorExpressions_MultiplyExpression.WithParent(ValidatorExpressions_MultiplyExpression.default, this._parent.multiply) : this._value.multiply;
      } else if (this._value._oneofTypeCase === 3) {
        this._cachedMultiply = new ValidatorExpressions_MultiplyExpression.WithParent(this._value.multiply, this._parent && this._parent.oneofTypeCase === 3 ? this._parent.multiply : null);
      } else {
        this._cachedMultiply = ValidatorExpressions_MultiplyExpression.WithParent.default;
      }
    }
    return this._cachedMultiply;
  }
  get subtract() {
    if (!this._cachedSubtract) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedSubtract = this._parent ? new ValidatorExpressions_SubtractExpression.WithParent(ValidatorExpressions_SubtractExpression.default, this._parent.subtract) : this._value.subtract;
      } else if (this._value._oneofTypeCase === 4) {
        this._cachedSubtract = new ValidatorExpressions_SubtractExpression.WithParent(this._value.subtract, this._parent && this._parent.oneofTypeCase === 4 ? this._parent.subtract : null);
      } else {
        this._cachedSubtract = ValidatorExpressions_SubtractExpression.WithParent.default;
      }
    }
    return this._cachedSubtract;
  }
  get add() {
    if (!this._cachedAdd) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedAdd = this._parent ? new ValidatorExpressions_AddExpression.WithParent(ValidatorExpressions_AddExpression.default, this._parent.add) : this._value.add;
      } else if (this._value._oneofTypeCase === 5) {
        this._cachedAdd = new ValidatorExpressions_AddExpression.WithParent(this._value.add, this._parent && this._parent.oneofTypeCase === 5 ? this._parent.add : null);
      } else {
        this._cachedAdd = ValidatorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedAdd;
  }
  get compare() {
    if (!this._cachedCompare) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedCompare = this._parent ? new ValidatorExpressions_CompareExpression.WithParent(ValidatorExpressions_CompareExpression.default, this._parent.compare) : this._value.compare;
      } else if (this._value._oneofTypeCase === 6) {
        this._cachedCompare = new ValidatorExpressions_CompareExpression.WithParent(this._value.compare, this._parent && this._parent.oneofTypeCase === 6 ? this._parent.compare : null);
      } else {
        this._cachedCompare = ValidatorExpressions_CompareExpression.WithParent.default;
      }
    }
    return this._cachedCompare;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_LogicNotExpression_ChildExpression_WithParent(current, parent);
    if (this._cachedValue && this._value._oneofTypeCase === 1 && current._oneofTypeCase === 1) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.oneofTypeCase === 1 ? parent.value : null);
      }
    }
    if (this._cachedDivide && this._value._oneofTypeCase === 2 && current._oneofTypeCase === 2) {
      if (this._value.divide === current.divide && this._parent === parent) {
        result._cachedDivide = this._cachedDivide;
      } else {
        result._cachedDivide = this._cachedDivide.update(current.divide, parent && parent.oneofTypeCase === 2 ? parent.divide : null);
      }
    }
    if (this._cachedMultiply && this._value._oneofTypeCase === 3 && current._oneofTypeCase === 3) {
      if (this._value.multiply === current.multiply && this._parent === parent) {
        result._cachedMultiply = this._cachedMultiply;
      } else {
        result._cachedMultiply = this._cachedMultiply.update(current.multiply, parent && parent.oneofTypeCase === 3 ? parent.multiply : null);
      }
    }
    if (this._cachedSubtract && this._value._oneofTypeCase === 4 && current._oneofTypeCase === 4) {
      if (this._value.subtract === current.subtract && this._parent === parent) {
        result._cachedSubtract = this._cachedSubtract;
      } else {
        result._cachedSubtract = this._cachedSubtract.update(current.subtract, parent && parent.oneofTypeCase === 4 ? parent.subtract : null);
      }
    }
    if (this._cachedAdd && this._value._oneofTypeCase === 5 && current._oneofTypeCase === 5) {
      if (this._value.add === current.add && this._parent === parent) {
        result._cachedAdd = this._cachedAdd;
      } else {
        result._cachedAdd = this._cachedAdd.update(current.add, parent && parent.oneofTypeCase === 5 ? parent.add : null);
      }
    }
    if (this._cachedCompare && this._value._oneofTypeCase === 6 && current._oneofTypeCase === 6) {
      if (this._value.compare === current.compare && this._parent === parent) {
        result._cachedCompare = this._cachedCompare;
      } else {
        result._cachedCompare = this._cachedCompare.update(current.compare, parent && parent.oneofTypeCase === 6 ? parent.compare : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_LogicNotExpression_ChildExpression_WithParent.default = new ValidatorExpressions_LogicNotExpression_ChildExpression_WithParent(ValidatorExpressions_LogicNotExpression_ChildExpression.default, null);
ValidatorExpressions_LogicNotExpression_ChildExpression.WithParent = ValidatorExpressions_LogicNotExpression_ChildExpression_WithParent;
class ValidatorExpressions_LogicNotExpression_ChildExpression_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 11,
        protoName: "value",
        oneofIndex: 0,
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get divide() {
    if (!this._divide) {
      this._divide = {
        name: "divide",
        Name: "Divide",
        number: 2,
        protoType: 11,
        protoName: "divide",
        oneofIndex: 0,
        type: ValidatorExpressions_DivideExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._divide;
  }
  get multiply() {
    if (!this._multiply) {
      this._multiply = {
        name: "multiply",
        Name: "Multiply",
        number: 3,
        protoType: 11,
        protoName: "multiply",
        oneofIndex: 0,
        type: ValidatorExpressions_MultiplyExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiply;
  }
  get subtract() {
    if (!this._subtract) {
      this._subtract = {
        name: "subtract",
        Name: "Subtract",
        number: 4,
        protoType: 11,
        protoName: "subtract",
        oneofIndex: 0,
        type: ValidatorExpressions_SubtractExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subtract;
  }
  get add() {
    if (!this._add) {
      this._add = {
        name: "add",
        Name: "Add",
        number: 5,
        protoType: 11,
        protoName: "add",
        oneofIndex: 0,
        type: ValidatorExpressions_AddExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._add;
  }
  get compare() {
    if (!this._compare) {
      this._compare = {
        name: "compare",
        Name: "Compare",
        number: 6,
        protoType: 11,
        protoName: "compare",
        oneofIndex: 0,
        type: ValidatorExpressions_CompareExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._compare;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.divide,
        this.multiply,
        this.subtract,
        this.add,
        this.compare,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofType",
        Name: "OneofType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_LogicNotExpression_ChildExpression.descriptor = new ValidatorExpressions_LogicNotExpression_ChildExpression_Descriptor();
class ValidatorExpressions_LogicNotExpression {
  get descriptor() {
    return ValidatorExpressions_LogicNotExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasExpression = false;
    this._expression = null;
  }
  isEmpty() {
    if (this._hasExpression && !this._expression.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_LogicNotExpression) {
      return value;
    }
    return ValidatorExpressions_LogicNotExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_LogicNotExpression();
    if (json.expression != null) {
      result._hasExpression = true;
      result._expression = ValidatorExpressions_LogicNotExpression_ChildExpression.fromJson(json.expression);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasExpression && !this._expression.isEmpty()) {
      result.expression = ValidatorExpressions_LogicNotExpression_ChildExpression.toJson(this._expression);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_LogicNotExpression_ChildExpression}
   */
  get expression() {
    return this._hasExpression ? this._expression : ValidatorExpressions_LogicNotExpression_ChildExpression.default;
  }
  get hasExpression() {
    return this._hasExpression;
  }
  setExpression(path, value) {
    return {type: 'SET', path: path.concat(['expression']), value: value.toJson()};
  }
  deleteExpression(path) {
    return {type: 'DELETE', path: path.concat(['expression'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicNotExpression(this);
              copy._hasExpression = true;
              copy._expression = ValidatorExpressions_LogicNotExpression_ChildExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExpression) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicNotExpression(this);
              copy._hasExpression = false;
              copy._expression = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasExpression) {
            const copy = new ValidatorExpressions_LogicNotExpression(this);
            copy._hasExpression = true;
            copy._expression = ValidatorExpressions_LogicNotExpression_ChildExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._expression.apply(type, path.slice(1), value);
          if (newValue === this._expression) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicNotExpression(this);
          copy._expression = copy._expression.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_LogicNotExpression} other
   * @returns {ValidatorExpressions_LogicNotExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_LogicNotExpression(this);
    if (other._hasExpression) {
      if (copy._hasExpression) {
        copy._expression = copy.expression.merge(other.expression);
      } else {
        copy._expression = other._expression;
      }
      copy._hasExpression = true;
    }
    return copy;
  }
}
ValidatorExpressions_LogicNotExpression.default = new ValidatorExpressions_LogicNotExpression();
ValidatorExpressions_LogicNotExpression.ChildExpression = ValidatorExpressions_LogicNotExpression_ChildExpression;
class ValidatorExpressions_LogicNotExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_LogicNotExpression(value);
  }
  build() {
    return new ValidatorExpressions_LogicNotExpression(this._value);
  }
  setExpression(value) {
    this._value._hasExpression = true;
    this._value._expression = value;
    return this;
  }
  deleteExpression() {
    this._value._hasExpression = false;
    this._value._expression = null;
    return this;
  }
}
ValidatorExpressions_LogicNotExpression.Builder = ValidatorExpressions_LogicNotExpression_Builder;
class ValidatorExpressions_LogicNotExpression_WithParent {
  /**
   * @param {ValidatorExpressions_LogicNotExpression} value
   * @param {ValidatorExpressions_LogicNotExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_LogicNotExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasExpression() {
    if (this._cachedHasExpression === undefined) {
      if (this._value.hasExpression) {
        this._cachedHasExpression = true;
      } else {
        this._cachedHasExpression = this._parent ? this._parent.hasExpression : false;
      }
    }
    return this._cachedHasExpression;
  }
  get expression() {
    if (!this._cachedExpression) {
      if (this._value.hasExpression) {
        this._cachedExpression = new ValidatorExpressions_LogicNotExpression_ChildExpression.WithParent(this._value.expression, this._parent && this._parent.hasExpression ? this._parent.expression : null);
      } else {
        this._cachedExpression = this._parent ? new ValidatorExpressions_LogicNotExpression_ChildExpression.WithParent(ValidatorExpressions_LogicNotExpression_ChildExpression.default, this._parent.expression) : ValidatorExpressions_LogicNotExpression_ChildExpression.WithParent.default;
      }
    }
    return this._cachedExpression;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_LogicNotExpression_WithParent(current, parent);
    if (this._cachedExpression && this._value.hasExpression && current.hasExpression) {
      if (this._value.expression === current.expression && this._parent === parent) {
        result._cachedExpression = this._cachedExpression;
      } else {
        result._cachedExpression = this._cachedExpression.update(current.expression, parent && parent.hasExpression ? parent.expression : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_LogicNotExpression_WithParent.default = new ValidatorExpressions_LogicNotExpression_WithParent(ValidatorExpressions_LogicNotExpression.default, null);
ValidatorExpressions_LogicNotExpression.WithParent = ValidatorExpressions_LogicNotExpression_WithParent;
class ValidatorExpressions_LogicNotExpression_Descriptor {
  get expression() {
    if (!this._expression) {
      this._expression = {
        name: "expression",
        Name: "Expression",
        number: 1,
        protoType: 11,
        protoName: "expression",
        type: ValidatorExpressions_LogicNotExpression_ChildExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expression;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expression,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForExpression",
        Name: "DummyOneofForExpression",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_LogicNotExpression.descriptor = new ValidatorExpressions_LogicNotExpression_Descriptor();
class ValidatorExpressions_LogicAndExpression {
  get descriptor() {
    return ValidatorExpressions_LogicAndExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressions = [];
  }
  isEmpty() {
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_LogicAndExpression) {
      return value;
    }
    return ValidatorExpressions_LogicAndExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_LogicAndExpression();
    result._expressions = JsonToList(json.expressions, ValidatorExpressions_Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, ValidatorExpressions_Expression);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, ValidatorExpressions_Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicAndExpression(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(ValidatorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ValidatorExpressions_LogicAndExpression(this);
              copy._expressions = copy._expressions.concat([ValidatorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicAndExpression(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicAndExpression(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = ValidatorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ValidatorExpressions_LogicAndExpression(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicAndExpression(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_LogicAndExpression} other
   * @returns {ValidatorExpressions_LogicAndExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_LogicAndExpression(this);
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
ValidatorExpressions_LogicAndExpression.default = new ValidatorExpressions_LogicAndExpression();
class ValidatorExpressions_LogicAndExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_LogicAndExpression(value);
  }
  build() {
    return new ValidatorExpressions_LogicAndExpression(this._value);
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
ValidatorExpressions_LogicAndExpression.Builder = ValidatorExpressions_LogicAndExpression_Builder;
class ValidatorExpressions_LogicAndExpression_WithParent {
  /**
   * @param {ValidatorExpressions_LogicAndExpression} value
   * @param {ValidatorExpressions_LogicAndExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_LogicAndExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new ValidatorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_LogicAndExpression_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new ValidatorExpressions_Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ValidatorExpressions_LogicAndExpression_WithParent.default = new ValidatorExpressions_LogicAndExpression_WithParent(ValidatorExpressions_LogicAndExpression.default, null);
ValidatorExpressions_LogicAndExpression.WithParent = ValidatorExpressions_LogicAndExpression_WithParent;
class ValidatorExpressions_LogicAndExpression_Descriptor {
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 1,
        protoType: 11,
        protoName: "expressions",
        type: ValidatorExpressions_Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ValidatorExpressions_LogicAndExpression.descriptor = new ValidatorExpressions_LogicAndExpression_Descriptor();
class ValidatorExpressions_LogicOrExpression {
  get descriptor() {
    return ValidatorExpressions_LogicOrExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._expressions = [];
  }
  isEmpty() {
    if (this._expressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_LogicOrExpression) {
      return value;
    }
    return ValidatorExpressions_LogicOrExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_LogicOrExpression();
    result._expressions = JsonToList(json.expressions, ValidatorExpressions_Expression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._expressions.length > 0) {
      result.expressions = ArrayToJson(this._expressions, ValidatorExpressions_Expression);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_Expression[]}
   */
  get expressions() {
    return this._expressions;
  }
  addExpressions(path, value) {
    return {type: 'ADD', path: path.concat(['expressions']), value: value.toJson()};
  }
  setExpressions(path, value) {
    return {type: 'SET', path: path.concat(['expressions']), value: ArrayToJson(value, ValidatorExpressions_Expression)};
  }
  setExpressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['expressions', key]), value: value.toJson()};
  }
  deleteExpressions(path) {
    return {type: 'DELETE', path: path.concat(['expressions'])};
  }
  deleteExpressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['expressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "expressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicOrExpression(this);
              copy._expressions = [];        for (let i of value) {
                copy._expressions.push(ValidatorExpressions_Expression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ValidatorExpressions_LogicOrExpression(this);
              copy._expressions = copy._expressions.concat([ValidatorExpressions_Expression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._expressions.length === 0) {
                return this;
              }
              const copy = new ValidatorExpressions_LogicOrExpression(this);
              copy._expressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_LogicOrExpression(this);
              copy._expressions = copy._expressions.slice();
              copy._expressions[path[1]] = ValidatorExpressions_Expression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ValidatorExpressions_LogicOrExpression(this);
              copy._expressions = copy._expressions.slice(0, path[1]).concat(copy._expressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._expressions.length) {
            return this;
          }
          const oldValue = this._expressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ValidatorExpressions_LogicOrExpression(this);
          copy._expressions = copy._expressions.slice();
          copy._expressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_LogicOrExpression} other
   * @returns {ValidatorExpressions_LogicOrExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_LogicOrExpression(this);
    copy._expressions = this._expressions.concat(other._expressions);
    return copy;
  }
}
ValidatorExpressions_LogicOrExpression.default = new ValidatorExpressions_LogicOrExpression();
class ValidatorExpressions_LogicOrExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_LogicOrExpression(value);
  }
  build() {
    return new ValidatorExpressions_LogicOrExpression(this._value);
  }
  addAllExpressions(values) {
    this._value._expressions = this._value._expressions.concat(values);
    return this;
  }
  addExpressions(value) {
    this._value._expressions = this._value._expressions.concat([value]);
    return this;
  }
  setExpressions(index, value) {
    this._value._expressions = this._value._expressions.concat();
    this._value._expressions[index] = value;
    return this;
  }
  clearExpressions() {
    this._value._expressions = [];
    return this;
  }
}
ValidatorExpressions_LogicOrExpression.Builder = ValidatorExpressions_LogicOrExpression_Builder;
class ValidatorExpressions_LogicOrExpression_WithParent {
  /**
   * @param {ValidatorExpressions_LogicOrExpression} value
   * @param {ValidatorExpressions_LogicOrExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_LogicOrExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExpressions() {
    if (!this._selfExpressions) {
      this._selfExpressions = [];
      for (let i of this._value.expressions) {
        this._selfExpressions.push(new ValidatorExpressions_Expression.WithParent(i, null));
      }
    }
    return this._selfExpressions;
  }
  get inherentExpressions() {
    if (!this._inherentExpressions) {
      this._inherentExpressions = this._parent ? this._parent.expressions : [];
    }
    return this._inherentExpressions;
  }
  get expressions() {
    if (!this._allExpressions) {
      this._allExpressions = this._parent ? this._parent.expressions.concat(this.selfExpressions) : this.selfExpressions;
    }
    return this._allExpressions;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_LogicOrExpression_WithParent(current, parent);
    if (this._selfExpressions) {
      if (this._value.expressions === current.expressions) {
        result._selfExpressions = this._selfExpressions;
      } else {
        result._selfExpressions = [];
        for (let i = 0; i < current.expressions.length; i++) {
          const oldValue = this._value.expressions[i];
          if (oldValue) {
            const oldCache = this._selfExpressions[i];
            if (oldValue === current.expressions[i]) {
              result._selfExpressions[i] = oldCache;
            } else {
              result._selfExpressions[i] = oldCache.update(current.expressions[i], null);
            }
          } else {
            result._selfExpressions[i] = new ValidatorExpressions_Expression.WithParent(current.expressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
ValidatorExpressions_LogicOrExpression_WithParent.default = new ValidatorExpressions_LogicOrExpression_WithParent(ValidatorExpressions_LogicOrExpression.default, null);
ValidatorExpressions_LogicOrExpression.WithParent = ValidatorExpressions_LogicOrExpression_WithParent;
class ValidatorExpressions_LogicOrExpression_Descriptor {
  get expressions() {
    if (!this._expressions) {
      this._expressions = {
        name: "expressions",
        Name: "Expressions",
        number: 1,
        protoType: 11,
        protoName: "expressions",
        type: ValidatorExpressions_Expression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.expressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ValidatorExpressions_LogicOrExpression.descriptor = new ValidatorExpressions_LogicOrExpression_Descriptor();
class ValidatorExpressions_NamedExpression {
  get descriptor() {
    return ValidatorExpressions_NamedExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_NamedExpression) {
      return value;
    }
    return ValidatorExpressions_NamedExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_NamedExpression();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_NamedExpression(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ValidatorExpressions_NamedExpression(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_NamedExpression} other
   * @returns {ValidatorExpressions_NamedExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_NamedExpression(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    return copy;
  }
}
ValidatorExpressions_NamedExpression.default = new ValidatorExpressions_NamedExpression();
class ValidatorExpressions_NamedExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_NamedExpression(value);
  }
  build() {
    return new ValidatorExpressions_NamedExpression(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
}
ValidatorExpressions_NamedExpression.Builder = ValidatorExpressions_NamedExpression_Builder;
class ValidatorExpressions_NamedExpression_WithParent {
  /**
   * @param {ValidatorExpressions_NamedExpression} value
   * @param {ValidatorExpressions_NamedExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_NamedExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_NamedExpression_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_NamedExpression_WithParent.default = new ValidatorExpressions_NamedExpression_WithParent(ValidatorExpressions_NamedExpression.default, null);
ValidatorExpressions_NamedExpression.WithParent = ValidatorExpressions_NamedExpression_WithParent;
class ValidatorExpressions_NamedExpression_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          comments: "The named expression to use.",
          valueDropdown: "SupportedExpressionNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_NamedExpression.descriptor = new ValidatorExpressions_NamedExpression_Descriptor();
class ValidatorExpressions_ExponentExpression {
  get descriptor() {
    return ValidatorExpressions_ExponentExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBase = false;
    this._base = null;
    this._hasPower = false;
    this._power = null;
  }
  isEmpty() {
    if (this._hasBase && !this._base.isEmpty()) return false;
    if (this._hasPower && !this._power.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_ExponentExpression) {
      return value;
    }
    return ValidatorExpressions_ExponentExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_ExponentExpression();
    if (json.base != null) {
      result._hasBase = true;
      result._base = ValidatorExpressions_Value.fromJson(json.base);
    }
    if (json.power != null) {
      result._hasPower = true;
      result._power = ValidatorExpressions_Value.fromJson(json.power);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBase && !this._base.isEmpty()) {
      result.base = ValidatorExpressions_Value.toJson(this._base);
    }
    if (this._hasPower && !this._power.isEmpty()) {
      result.power = ValidatorExpressions_Value.toJson(this._power);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get base() {
    return this._hasBase ? this._base : ValidatorExpressions_Value.default;
  }
  get hasBase() {
    return this._hasBase;
  }
  setBase(path, value) {
    return {type: 'SET', path: path.concat(['base']), value: value.toJson()};
  }
  deleteBase(path) {
    return {type: 'DELETE', path: path.concat(['base'])};
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get power() {
    return this._hasPower ? this._power : ValidatorExpressions_Value.default;
  }
  get hasPower() {
    return this._hasPower;
  }
  setPower(path, value) {
    return {type: 'SET', path: path.concat(['power']), value: value.toJson()};
  }
  deletePower(path) {
    return {type: 'DELETE', path: path.concat(['power'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "base": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ExponentExpression(this);
              copy._hasBase = true;
              copy._base = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBase) {
                return this;
              }
              const copy = new ValidatorExpressions_ExponentExpression(this);
              copy._hasBase = false;
              copy._base = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasBase) {
            const copy = new ValidatorExpressions_ExponentExpression(this);
            copy._hasBase = true;
            copy._base = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._base.apply(type, path.slice(1), value);
          if (newValue === this._base) {
            return this;
          }
          const copy = new ValidatorExpressions_ExponentExpression(this);
          copy._base = copy._base.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "power": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ExponentExpression(this);
              copy._hasPower = true;
              copy._power = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPower) {
                return this;
              }
              const copy = new ValidatorExpressions_ExponentExpression(this);
              copy._hasPower = false;
              copy._power = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPower) {
            const copy = new ValidatorExpressions_ExponentExpression(this);
            copy._hasPower = true;
            copy._power = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._power.apply(type, path.slice(1), value);
          if (newValue === this._power) {
            return this;
          }
          const copy = new ValidatorExpressions_ExponentExpression(this);
          copy._power = copy._power.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_ExponentExpression} other
   * @returns {ValidatorExpressions_ExponentExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_ExponentExpression(this);
    if (other._hasBase) {
      if (copy._hasBase) {
        copy._base = copy.base.merge(other.base);
      } else {
        copy._base = other._base;
      }
      copy._hasBase = true;
    }
    if (other._hasPower) {
      if (copy._hasPower) {
        copy._power = copy.power.merge(other.power);
      } else {
        copy._power = other._power;
      }
      copy._hasPower = true;
    }
    return copy;
  }
}
ValidatorExpressions_ExponentExpression.default = new ValidatorExpressions_ExponentExpression();
class ValidatorExpressions_ExponentExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_ExponentExpression(value);
  }
  build() {
    return new ValidatorExpressions_ExponentExpression(this._value);
  }
  setBase(value) {
    this._value._hasBase = true;
    this._value._base = value;
    return this;
  }
  deleteBase() {
    this._value._hasBase = false;
    this._value._base = null;
    return this;
  }
  setPower(value) {
    this._value._hasPower = true;
    this._value._power = value;
    return this;
  }
  deletePower() {
    this._value._hasPower = false;
    this._value._power = null;
    return this;
  }
}
ValidatorExpressions_ExponentExpression.Builder = ValidatorExpressions_ExponentExpression_Builder;
class ValidatorExpressions_ExponentExpression_WithParent {
  /**
   * @param {ValidatorExpressions_ExponentExpression} value
   * @param {ValidatorExpressions_ExponentExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_ExponentExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBase() {
    if (this._cachedHasBase === undefined) {
      if (this._value.hasBase) {
        this._cachedHasBase = true;
      } else {
        this._cachedHasBase = this._parent ? this._parent.hasBase : false;
      }
    }
    return this._cachedHasBase;
  }
  get base() {
    if (!this._cachedBase) {
      if (this._value.hasBase) {
        this._cachedBase = new ValidatorExpressions_Value.WithParent(this._value.base, this._parent && this._parent.hasBase ? this._parent.base : null);
      } else {
        this._cachedBase = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.base) : ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedBase;
  }
  get hasPower() {
    if (this._cachedHasPower === undefined) {
      if (this._value.hasPower) {
        this._cachedHasPower = true;
      } else {
        this._cachedHasPower = this._parent ? this._parent.hasPower : false;
      }
    }
    return this._cachedHasPower;
  }
  get power() {
    if (!this._cachedPower) {
      if (this._value.hasPower) {
        this._cachedPower = new ValidatorExpressions_Value.WithParent(this._value.power, this._parent && this._parent.hasPower ? this._parent.power : null);
      } else {
        this._cachedPower = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.power) : ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedPower;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_ExponentExpression_WithParent(current, parent);
    if (this._cachedBase && this._value.hasBase && current.hasBase) {
      if (this._value.base === current.base && this._parent === parent) {
        result._cachedBase = this._cachedBase;
      } else {
        result._cachedBase = this._cachedBase.update(current.base, parent && parent.hasBase ? parent.base : null);
      }
    }
    if (this._cachedPower && this._value.hasPower && current.hasPower) {
      if (this._value.power === current.power && this._parent === parent) {
        result._cachedPower = this._cachedPower;
      } else {
        result._cachedPower = this._cachedPower.update(current.power, parent && parent.hasPower ? parent.power : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_ExponentExpression_WithParent.default = new ValidatorExpressions_ExponentExpression_WithParent(ValidatorExpressions_ExponentExpression.default, null);
ValidatorExpressions_ExponentExpression.WithParent = ValidatorExpressions_ExponentExpression_WithParent;
class ValidatorExpressions_ExponentExpression_Descriptor {
  get base() {
    if (!this._base) {
      this._base = {
        name: "base",
        Name: "Base",
        number: 1,
        protoType: 11,
        protoName: "base",
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._base;
  }
  get power() {
    if (!this._power) {
      this._power = {
        name: "power",
        Name: "Power",
        number: 2,
        protoType: 11,
        protoName: "power",
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._power;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.base,
        this.power,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBase",
        Name: "DummyOneofForBase",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPower",
        Name: "DummyOneofForPower",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_ExponentExpression.descriptor = new ValidatorExpressions_ExponentExpression_Descriptor();
class ValidatorExpressions_ModuloExpression {
  get descriptor() {
    return ValidatorExpressions_ModuloExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLeft = false;
    this._left = null;
    this._hasRight = false;
    this._right = null;
  }
  isEmpty() {
    if (this._hasLeft && !this._left.isEmpty()) return false;
    if (this._hasRight && !this._right.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_ModuloExpression) {
      return value;
    }
    return ValidatorExpressions_ModuloExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_ModuloExpression();
    if (json.left != null) {
      result._hasLeft = true;
      result._left = ValidatorExpressions_Value.fromJson(json.left);
    }
    if (json.right != null) {
      result._hasRight = true;
      result._right = ValidatorExpressions_Value.fromJson(json.right);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLeft && !this._left.isEmpty()) {
      result.left = ValidatorExpressions_Value.toJson(this._left);
    }
    if (this._hasRight && !this._right.isEmpty()) {
      result.right = ValidatorExpressions_Value.toJson(this._right);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get left() {
    return this._hasLeft ? this._left : ValidatorExpressions_Value.default;
  }
  get hasLeft() {
    return this._hasLeft;
  }
  setLeft(path, value) {
    return {type: 'SET', path: path.concat(['left']), value: value.toJson()};
  }
  deleteLeft(path) {
    return {type: 'DELETE', path: path.concat(['left'])};
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get right() {
    return this._hasRight ? this._right : ValidatorExpressions_Value.default;
  }
  get hasRight() {
    return this._hasRight;
  }
  setRight(path, value) {
    return {type: 'SET', path: path.concat(['right']), value: value.toJson()};
  }
  deleteRight(path) {
    return {type: 'DELETE', path: path.concat(['right'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "left": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ModuloExpression(this);
              copy._hasLeft = true;
              copy._left = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeft) {
                return this;
              }
              const copy = new ValidatorExpressions_ModuloExpression(this);
              copy._hasLeft = false;
              copy._left = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLeft) {
            const copy = new ValidatorExpressions_ModuloExpression(this);
            copy._hasLeft = true;
            copy._left = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._left.apply(type, path.slice(1), value);
          if (newValue === this._left) {
            return this;
          }
          const copy = new ValidatorExpressions_ModuloExpression(this);
          copy._left = copy._left.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "right": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_ModuloExpression(this);
              copy._hasRight = true;
              copy._right = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRight) {
                return this;
              }
              const copy = new ValidatorExpressions_ModuloExpression(this);
              copy._hasRight = false;
              copy._right = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasRight) {
            const copy = new ValidatorExpressions_ModuloExpression(this);
            copy._hasRight = true;
            copy._right = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._right.apply(type, path.slice(1), value);
          if (newValue === this._right) {
            return this;
          }
          const copy = new ValidatorExpressions_ModuloExpression(this);
          copy._right = copy._right.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_ModuloExpression} other
   * @returns {ValidatorExpressions_ModuloExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_ModuloExpression(this);
    if (other._hasLeft) {
      if (copy._hasLeft) {
        copy._left = copy.left.merge(other.left);
      } else {
        copy._left = other._left;
      }
      copy._hasLeft = true;
    }
    if (other._hasRight) {
      if (copy._hasRight) {
        copy._right = copy.right.merge(other.right);
      } else {
        copy._right = other._right;
      }
      copy._hasRight = true;
    }
    return copy;
  }
}
ValidatorExpressions_ModuloExpression.default = new ValidatorExpressions_ModuloExpression();
class ValidatorExpressions_ModuloExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_ModuloExpression(value);
  }
  build() {
    return new ValidatorExpressions_ModuloExpression(this._value);
  }
  setLeft(value) {
    this._value._hasLeft = true;
    this._value._left = value;
    return this;
  }
  deleteLeft() {
    this._value._hasLeft = false;
    this._value._left = null;
    return this;
  }
  setRight(value) {
    this._value._hasRight = true;
    this._value._right = value;
    return this;
  }
  deleteRight() {
    this._value._hasRight = false;
    this._value._right = null;
    return this;
  }
}
ValidatorExpressions_ModuloExpression.Builder = ValidatorExpressions_ModuloExpression_Builder;
class ValidatorExpressions_ModuloExpression_WithParent {
  /**
   * @param {ValidatorExpressions_ModuloExpression} value
   * @param {ValidatorExpressions_ModuloExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_ModuloExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLeft() {
    if (this._cachedHasLeft === undefined) {
      if (this._value.hasLeft) {
        this._cachedHasLeft = true;
      } else {
        this._cachedHasLeft = this._parent ? this._parent.hasLeft : false;
      }
    }
    return this._cachedHasLeft;
  }
  get left() {
    if (!this._cachedLeft) {
      if (this._value.hasLeft) {
        this._cachedLeft = new ValidatorExpressions_Value.WithParent(this._value.left, this._parent && this._parent.hasLeft ? this._parent.left : null);
      } else {
        this._cachedLeft = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.left) : ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedLeft;
  }
  get hasRight() {
    if (this._cachedHasRight === undefined) {
      if (this._value.hasRight) {
        this._cachedHasRight = true;
      } else {
        this._cachedHasRight = this._parent ? this._parent.hasRight : false;
      }
    }
    return this._cachedHasRight;
  }
  get right() {
    if (!this._cachedRight) {
      if (this._value.hasRight) {
        this._cachedRight = new ValidatorExpressions_Value.WithParent(this._value.right, this._parent && this._parent.hasRight ? this._parent.right : null);
      } else {
        this._cachedRight = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.right) : ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedRight;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_ModuloExpression_WithParent(current, parent);
    if (this._cachedLeft && this._value.hasLeft && current.hasLeft) {
      if (this._value.left === current.left && this._parent === parent) {
        result._cachedLeft = this._cachedLeft;
      } else {
        result._cachedLeft = this._cachedLeft.update(current.left, parent && parent.hasLeft ? parent.left : null);
      }
    }
    if (this._cachedRight && this._value.hasRight && current.hasRight) {
      if (this._value.right === current.right && this._parent === parent) {
        result._cachedRight = this._cachedRight;
      } else {
        result._cachedRight = this._cachedRight.update(current.right, parent && parent.hasRight ? parent.right : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_ModuloExpression_WithParent.default = new ValidatorExpressions_ModuloExpression_WithParent(ValidatorExpressions_ModuloExpression.default, null);
ValidatorExpressions_ModuloExpression.WithParent = ValidatorExpressions_ModuloExpression_WithParent;
class ValidatorExpressions_ModuloExpression_Descriptor {
  get left() {
    if (!this._left) {
      this._left = {
        name: "left",
        Name: "Left",
        number: 1,
        protoType: 11,
        protoName: "left",
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._left;
  }
  get right() {
    if (!this._right) {
      this._right = {
        name: "right",
        Name: "Right",
        number: 2,
        protoType: 11,
        protoName: "right",
        type: ValidatorExpressions_Value,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._right;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.left,
        this.right,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLeft",
        Name: "DummyOneofForLeft",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRight",
        Name: "DummyOneofForRight",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_ModuloExpression.descriptor = new ValidatorExpressions_ModuloExpression_Descriptor();
class ValidatorExpressions_IfExpression_Condition {
  get descriptor() {
    return ValidatorExpressions_IfExpression_Condition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCompare = false;
    this._compare = null;
  }
  isEmpty() {
    if (this._hasCompare && !this._compare.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_IfExpression_Condition) {
      return value;
    }
    return ValidatorExpressions_IfExpression_Condition.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_IfExpression_Condition();
    if (json.compare != null) {
      result._hasCompare = true;
      result._compare = ValidatorExpressions_CompareExpression.fromJson(json.compare);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCompare && !this._compare.isEmpty()) {
      result.compare = ValidatorExpressions_CompareExpression.toJson(this._compare);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_CompareExpression}
   */
  get compare() {
    return this._hasCompare ? this._compare : ValidatorExpressions_CompareExpression.default;
  }
  get hasCompare() {
    return this._hasCompare;
  }
  setCompare(path, value) {
    return {type: 'SET', path: path.concat(['compare']), value: value.toJson()};
  }
  deleteCompare(path) {
    return {type: 'DELETE', path: path.concat(['compare'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "compare": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_IfExpression_Condition(this);
              copy._hasCompare = true;
              copy._compare = ValidatorExpressions_CompareExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCompare) {
                return this;
              }
              const copy = new ValidatorExpressions_IfExpression_Condition(this);
              copy._hasCompare = false;
              copy._compare = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCompare) {
            const copy = new ValidatorExpressions_IfExpression_Condition(this);
            copy._hasCompare = true;
            copy._compare = ValidatorExpressions_CompareExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._compare.apply(type, path.slice(1), value);
          if (newValue === this._compare) {
            return this;
          }
          const copy = new ValidatorExpressions_IfExpression_Condition(this);
          copy._compare = copy._compare.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_IfExpression_Condition} other
   * @returns {ValidatorExpressions_IfExpression_Condition}
   */
  merge(other) {
    const copy = new ValidatorExpressions_IfExpression_Condition(this);
    if (other._hasCompare) {
      if (copy._hasCompare) {
        copy._compare = copy.compare.merge(other.compare);
      } else {
        copy._compare = other._compare;
      }
      copy._hasCompare = true;
    }
    return copy;
  }
}
ValidatorExpressions_IfExpression_Condition.default = new ValidatorExpressions_IfExpression_Condition();
class ValidatorExpressions_IfExpression_Condition_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_IfExpression_Condition(value);
  }
  build() {
    return new ValidatorExpressions_IfExpression_Condition(this._value);
  }
  setCompare(value) {
    this._value._hasCompare = true;
    this._value._compare = value;
    return this;
  }
  deleteCompare() {
    this._value._hasCompare = false;
    this._value._compare = null;
    return this;
  }
}
ValidatorExpressions_IfExpression_Condition.Builder = ValidatorExpressions_IfExpression_Condition_Builder;
class ValidatorExpressions_IfExpression_Condition_WithParent {
  /**
   * @param {ValidatorExpressions_IfExpression_Condition} value
   * @param {ValidatorExpressions_IfExpression_Condition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_IfExpression_Condition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCompare() {
    if (this._cachedHasCompare === undefined) {
      if (this._value.hasCompare) {
        this._cachedHasCompare = true;
      } else {
        this._cachedHasCompare = this._parent ? this._parent.hasCompare : false;
      }
    }
    return this._cachedHasCompare;
  }
  get compare() {
    if (!this._cachedCompare) {
      if (this._value.hasCompare) {
        this._cachedCompare = new ValidatorExpressions_CompareExpression.WithParent(this._value.compare, this._parent && this._parent.hasCompare ? this._parent.compare : null);
      } else {
        this._cachedCompare = this._parent ? new ValidatorExpressions_CompareExpression.WithParent(ValidatorExpressions_CompareExpression.default, this._parent.compare) : ValidatorExpressions_CompareExpression.WithParent.default;
      }
    }
    return this._cachedCompare;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_IfExpression_Condition_WithParent(current, parent);
    if (this._cachedCompare && this._value.hasCompare && current.hasCompare) {
      if (this._value.compare === current.compare && this._parent === parent) {
        result._cachedCompare = this._cachedCompare;
      } else {
        result._cachedCompare = this._cachedCompare.update(current.compare, parent && parent.hasCompare ? parent.compare : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_IfExpression_Condition_WithParent.default = new ValidatorExpressions_IfExpression_Condition_WithParent(ValidatorExpressions_IfExpression_Condition.default, null);
ValidatorExpressions_IfExpression_Condition.WithParent = ValidatorExpressions_IfExpression_Condition_WithParent;
class ValidatorExpressions_IfExpression_Condition_Descriptor {
  get compare() {
    if (!this._compare) {
      this._compare = {
        name: "compare",
        Name: "Compare",
        number: 1,
        protoType: 11,
        protoName: "compare",
        type: ValidatorExpressions_CompareExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._compare;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.compare,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofCondition",
        Name: "OneofCondition",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_IfExpression_Condition.descriptor = new ValidatorExpressions_IfExpression_Condition_Descriptor();
class ValidatorExpressions_IfExpression {
  get descriptor() {
    return ValidatorExpressions_IfExpression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCondition = false;
    this._condition = null;
    this._hasValues = false;
    this._values = null;
    this._hasElseValues = false;
    this._elseValues = null;
  }
  isEmpty() {
    if (this._hasCondition && !this._condition.isEmpty()) return false;
    if (this._hasValues && !this._values.isEmpty()) return false;
    if (this._hasElseValues && !this._elseValues.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_IfExpression) {
      return value;
    }
    return ValidatorExpressions_IfExpression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_IfExpression();
    if (json.condition != null) {
      result._hasCondition = true;
      result._condition = ValidatorExpressions_IfExpression_Condition.fromJson(json.condition);
    }
    if (json.values != null) {
      result._hasValues = true;
      result._values = ValidatorExpressions_AddExpression.fromJson(json.values);
    }
    if (json.elseValues != null) {
      result._hasElseValues = true;
      result._elseValues = ValidatorExpressions_AddExpression.fromJson(json.elseValues);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCondition && !this._condition.isEmpty()) {
      result.condition = ValidatorExpressions_IfExpression_Condition.toJson(this._condition);
    }
    if (this._hasValues && !this._values.isEmpty()) {
      result.values = ValidatorExpressions_AddExpression.toJson(this._values);
    }
    if (this._hasElseValues && !this._elseValues.isEmpty()) {
      result.elseValues = ValidatorExpressions_AddExpression.toJson(this._elseValues);
    }
    return result;
  }
  /**
   * @returns {ValidatorExpressions_IfExpression_Condition}
   */
  get condition() {
    return this._hasCondition ? this._condition : ValidatorExpressions_IfExpression_Condition.default;
  }
  get hasCondition() {
    return this._hasCondition;
  }
  setCondition(path, value) {
    return {type: 'SET', path: path.concat(['condition']), value: value.toJson()};
  }
  deleteCondition(path) {
    return {type: 'DELETE', path: path.concat(['condition'])};
  }
  /**
   * @returns {ValidatorExpressions_AddExpression}
   */
  get values() {
    return this._hasValues ? this._values : ValidatorExpressions_AddExpression.default;
  }
  get hasValues() {
    return this._hasValues;
  }
  setValues(path, value) {
    return {type: 'SET', path: path.concat(['values']), value: value.toJson()};
  }
  deleteValues(path) {
    return {type: 'DELETE', path: path.concat(['values'])};
  }
  /**
   * @returns {ValidatorExpressions_AddExpression}
   */
  get elseValues() {
    return this._hasElseValues ? this._elseValues : ValidatorExpressions_AddExpression.default;
  }
  get hasElseValues() {
    return this._hasElseValues;
  }
  setElseValues(path, value) {
    return {type: 'SET', path: path.concat(['elseValues']), value: value.toJson()};
  }
  deleteElseValues(path) {
    return {type: 'DELETE', path: path.concat(['elseValues'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "condition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_IfExpression(this);
              copy._hasCondition = true;
              copy._condition = ValidatorExpressions_IfExpression_Condition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCondition) {
                return this;
              }
              const copy = new ValidatorExpressions_IfExpression(this);
              copy._hasCondition = false;
              copy._condition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCondition) {
            const copy = new ValidatorExpressions_IfExpression(this);
            copy._hasCondition = true;
            copy._condition = ValidatorExpressions_IfExpression_Condition.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._condition.apply(type, path.slice(1), value);
          if (newValue === this._condition) {
            return this;
          }
          const copy = new ValidatorExpressions_IfExpression(this);
          copy._condition = copy._condition.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "values": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_IfExpression(this);
              copy._hasValues = true;
              copy._values = ValidatorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValues) {
                return this;
              }
              const copy = new ValidatorExpressions_IfExpression(this);
              copy._hasValues = false;
              copy._values = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValues) {
            const copy = new ValidatorExpressions_IfExpression(this);
            copy._hasValues = true;
            copy._values = ValidatorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._values.apply(type, path.slice(1), value);
          if (newValue === this._values) {
            return this;
          }
          const copy = new ValidatorExpressions_IfExpression(this);
          copy._values = copy._values.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "elseValues": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_IfExpression(this);
              copy._hasElseValues = true;
              copy._elseValues = ValidatorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasElseValues) {
                return this;
              }
              const copy = new ValidatorExpressions_IfExpression(this);
              copy._hasElseValues = false;
              copy._elseValues = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasElseValues) {
            const copy = new ValidatorExpressions_IfExpression(this);
            copy._hasElseValues = true;
            copy._elseValues = ValidatorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._elseValues.apply(type, path.slice(1), value);
          if (newValue === this._elseValues) {
            return this;
          }
          const copy = new ValidatorExpressions_IfExpression(this);
          copy._elseValues = copy._elseValues.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_IfExpression} other
   * @returns {ValidatorExpressions_IfExpression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_IfExpression(this);
    if (other._hasCondition) {
      if (copy._hasCondition) {
        copy._condition = copy.condition.merge(other.condition);
      } else {
        copy._condition = other._condition;
      }
      copy._hasCondition = true;
    }
    if (other._hasValues) {
      if (copy._hasValues) {
        copy._values = copy.values.merge(other.values);
      } else {
        copy._values = other._values;
      }
      copy._hasValues = true;
    }
    if (other._hasElseValues) {
      if (copy._hasElseValues) {
        copy._elseValues = copy.elseValues.merge(other.elseValues);
      } else {
        copy._elseValues = other._elseValues;
      }
      copy._hasElseValues = true;
    }
    return copy;
  }
}
ValidatorExpressions_IfExpression.default = new ValidatorExpressions_IfExpression();
ValidatorExpressions_IfExpression.Condition = ValidatorExpressions_IfExpression_Condition;
class ValidatorExpressions_IfExpression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_IfExpression(value);
  }
  build() {
    return new ValidatorExpressions_IfExpression(this._value);
  }
  setCondition(value) {
    this._value._hasCondition = true;
    this._value._condition = value;
    return this;
  }
  deleteCondition() {
    this._value._hasCondition = false;
    this._value._condition = null;
    return this;
  }
  setValues(value) {
    this._value._hasValues = true;
    this._value._values = value;
    return this;
  }
  deleteValues() {
    this._value._hasValues = false;
    this._value._values = null;
    return this;
  }
  setElseValues(value) {
    this._value._hasElseValues = true;
    this._value._elseValues = value;
    return this;
  }
  deleteElseValues() {
    this._value._hasElseValues = false;
    this._value._elseValues = null;
    return this;
  }
}
ValidatorExpressions_IfExpression.Builder = ValidatorExpressions_IfExpression_Builder;
class ValidatorExpressions_IfExpression_WithParent {
  /**
   * @param {ValidatorExpressions_IfExpression} value
   * @param {ValidatorExpressions_IfExpression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_IfExpression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCondition() {
    if (this._cachedHasCondition === undefined) {
      if (this._value.hasCondition) {
        this._cachedHasCondition = true;
      } else {
        this._cachedHasCondition = this._parent ? this._parent.hasCondition : false;
      }
    }
    return this._cachedHasCondition;
  }
  get condition() {
    if (!this._cachedCondition) {
      if (this._value.hasCondition) {
        this._cachedCondition = new ValidatorExpressions_IfExpression_Condition.WithParent(this._value.condition, this._parent && this._parent.hasCondition ? this._parent.condition : null);
      } else {
        this._cachedCondition = this._parent ? new ValidatorExpressions_IfExpression_Condition.WithParent(ValidatorExpressions_IfExpression_Condition.default, this._parent.condition) : ValidatorExpressions_IfExpression_Condition.WithParent.default;
      }
    }
    return this._cachedCondition;
  }
  get hasValues() {
    if (this._cachedHasValues === undefined) {
      if (this._value.hasValues) {
        this._cachedHasValues = true;
      } else {
        this._cachedHasValues = this._parent ? this._parent.hasValues : false;
      }
    }
    return this._cachedHasValues;
  }
  get values() {
    if (!this._cachedValues) {
      if (this._value.hasValues) {
        this._cachedValues = new ValidatorExpressions_AddExpression.WithParent(this._value.values, this._parent && this._parent.hasValues ? this._parent.values : null);
      } else {
        this._cachedValues = this._parent ? new ValidatorExpressions_AddExpression.WithParent(ValidatorExpressions_AddExpression.default, this._parent.values) : ValidatorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedValues;
  }
  get hasElseValues() {
    if (this._cachedHasElseValues === undefined) {
      if (this._value.hasElseValues) {
        this._cachedHasElseValues = true;
      } else {
        this._cachedHasElseValues = this._parent ? this._parent.hasElseValues : false;
      }
    }
    return this._cachedHasElseValues;
  }
  get elseValues() {
    if (!this._cachedElseValues) {
      if (this._value.hasElseValues) {
        this._cachedElseValues = new ValidatorExpressions_AddExpression.WithParent(this._value.elseValues, this._parent && this._parent.hasElseValues ? this._parent.elseValues : null);
      } else {
        this._cachedElseValues = this._parent ? new ValidatorExpressions_AddExpression.WithParent(ValidatorExpressions_AddExpression.default, this._parent.elseValues) : ValidatorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedElseValues;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_IfExpression_WithParent(current, parent);
    if (this._cachedCondition && this._value.hasCondition && current.hasCondition) {
      if (this._value.condition === current.condition && this._parent === parent) {
        result._cachedCondition = this._cachedCondition;
      } else {
        result._cachedCondition = this._cachedCondition.update(current.condition, parent && parent.hasCondition ? parent.condition : null);
      }
    }
    if (this._cachedValues && this._value.hasValues && current.hasValues) {
      if (this._value.values === current.values && this._parent === parent) {
        result._cachedValues = this._cachedValues;
      } else {
        result._cachedValues = this._cachedValues.update(current.values, parent && parent.hasValues ? parent.values : null);
      }
    }
    if (this._cachedElseValues && this._value.hasElseValues && current.hasElseValues) {
      if (this._value.elseValues === current.elseValues && this._parent === parent) {
        result._cachedElseValues = this._cachedElseValues;
      } else {
        result._cachedElseValues = this._cachedElseValues.update(current.elseValues, parent && parent.hasElseValues ? parent.elseValues : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_IfExpression_WithParent.default = new ValidatorExpressions_IfExpression_WithParent(ValidatorExpressions_IfExpression.default, null);
ValidatorExpressions_IfExpression.WithParent = ValidatorExpressions_IfExpression_WithParent;
class ValidatorExpressions_IfExpression_Descriptor {
  get condition() {
    if (!this._condition) {
      this._condition = {
        name: "condition",
        Name: "Condition",
        number: 1,
        protoType: 11,
        protoName: "condition",
        type: ValidatorExpressions_IfExpression_Condition,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._condition;
  }
  get values() {
    if (!this._values) {
      this._values = {
        name: "values",
        Name: "Values",
        number: 2,
        protoType: 11,
        protoName: "values",
        type: ValidatorExpressions_AddExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._values;
  }
  get elseValues() {
    if (!this._elseValues) {
      this._elseValues = {
        name: "elseValues",
        Name: "ElseValues",
        number: 3,
        protoType: 11,
        protoName: "else_values",
        type: ValidatorExpressions_AddExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._elseValues;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.condition,
        this.values,
        this.elseValues,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCondition",
        Name: "DummyOneofForCondition",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValues",
        Name: "DummyOneofForValues",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForElseValues",
        Name: "DummyOneofForElseValues",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_IfExpression.descriptor = new ValidatorExpressions_IfExpression_Descriptor();
class ValidatorExpressions_Expression {
  get descriptor() {
    return ValidatorExpressions_Expression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._oneofTypeCase = 0;
    this._oneofTypeValue = null;
    this._hasComment = false;
    this._comment = null;
  }
  isEmpty() {
    if (this._oneofTypeCase !== 0) return false;
    if (this._hasComment) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions_Expression) {
      return value;
    }
    return ValidatorExpressions_Expression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions_Expression();
    if (json.value != null) {
      result._oneofTypeCase = 1;
      result._oneofTypeValue = ValidatorExpressions_Value.fromJson(json.value);
    }
    if (json.divide != null) {
      result._oneofTypeCase = 2;
      result._oneofTypeValue = ValidatorExpressions_DivideExpression.fromJson(json.divide);
    }
    if (json.multiply != null) {
      result._oneofTypeCase = 3;
      result._oneofTypeValue = ValidatorExpressions_MultiplyExpression.fromJson(json.multiply);
    }
    if (json.subtract != null) {
      result._oneofTypeCase = 4;
      result._oneofTypeValue = ValidatorExpressions_SubtractExpression.fromJson(json.subtract);
    }
    if (json.add != null) {
      result._oneofTypeCase = 5;
      result._oneofTypeValue = ValidatorExpressions_AddExpression.fromJson(json.add);
    }
    if (json.compare != null) {
      result._oneofTypeCase = 6;
      result._oneofTypeValue = ValidatorExpressions_CompareExpression.fromJson(json.compare);
    }
    if (json.logicNot != null) {
      result._oneofTypeCase = 7;
      result._oneofTypeValue = ValidatorExpressions_LogicNotExpression.fromJson(json.logicNot);
    }
    if (json.logicAnd != null) {
      result._oneofTypeCase = 8;
      result._oneofTypeValue = ValidatorExpressions_LogicAndExpression.fromJson(json.logicAnd);
    }
    if (json.logicOr != null) {
      result._oneofTypeCase = 9;
      result._oneofTypeValue = ValidatorExpressions_LogicOrExpression.fromJson(json.logicOr);
    }
    if (json.namedExpression != null) {
      result._oneofTypeCase = 11;
      result._oneofTypeValue = ValidatorExpressions_NamedExpression.fromJson(json.namedExpression);
    }
    if (json.exponent != null) {
      result._oneofTypeCase = 12;
      result._oneofTypeValue = ValidatorExpressions_ExponentExpression.fromJson(json.exponent);
    }
    if (json.modulo != null) {
      result._oneofTypeCase = 13;
      result._oneofTypeValue = ValidatorExpressions_ModuloExpression.fromJson(json.modulo);
    }
    if (json.if != null) {
      result._oneofTypeCase = 14;
      result._oneofTypeValue = ValidatorExpressions_IfExpression.fromJson(json.if);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._oneofTypeCase) {
      case 1:
        result.value = ValidatorExpressions_Value.toJson(this._oneofTypeValue);
        break;
      case 2:
        result.divide = ValidatorExpressions_DivideExpression.toJson(this._oneofTypeValue);
        break;
      case 3:
        result.multiply = ValidatorExpressions_MultiplyExpression.toJson(this._oneofTypeValue);
        break;
      case 4:
        result.subtract = ValidatorExpressions_SubtractExpression.toJson(this._oneofTypeValue);
        break;
      case 5:
        result.add = ValidatorExpressions_AddExpression.toJson(this._oneofTypeValue);
        break;
      case 6:
        result.compare = ValidatorExpressions_CompareExpression.toJson(this._oneofTypeValue);
        break;
      case 7:
        result.logicNot = ValidatorExpressions_LogicNotExpression.toJson(this._oneofTypeValue);
        break;
      case 8:
        result.logicAnd = ValidatorExpressions_LogicAndExpression.toJson(this._oneofTypeValue);
        break;
      case 9:
        result.logicOr = ValidatorExpressions_LogicOrExpression.toJson(this._oneofTypeValue);
        break;
      case 11:
        result.namedExpression = ValidatorExpressions_NamedExpression.toJson(this._oneofTypeValue);
        break;
      case 12:
        result.exponent = ValidatorExpressions_ExponentExpression.toJson(this._oneofTypeValue);
        break;
      case 13:
        result.modulo = ValidatorExpressions_ModuloExpression.toJson(this._oneofTypeValue);
        break;
      case 14:
        result.if = ValidatorExpressions_IfExpression.toJson(this._oneofTypeValue);
        break;
      default:
        break;
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    return result;
  }
  get oneofTypeCase() {
    return this._oneofTypeCase;
  }
  deleteOneofType(path) {
    switch (this._oneofTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['divide'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['multiply'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['subtract'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['add'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['compare'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['logicNot'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['logicAnd'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['logicOr'])};
      }
      case 11: {
        return {type: 'DELETE', path: path.concat(['namedExpression'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['exponent'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['modulo'])};
      }
      case 14: {
        return {type: 'DELETE', path: path.concat(['if'])};
      }
    }
  }
  /**
   * @returns {ValidatorExpressions_Value}
   */
  get value() {
    return this._oneofTypeCase === 1 ? this._oneofTypeValue : ValidatorExpressions_Value.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {ValidatorExpressions_DivideExpression}
   */
  get divide() {
    return this._oneofTypeCase === 2 ? this._oneofTypeValue : ValidatorExpressions_DivideExpression.default;
  }
  setDivide(path, value) {
    return {type: 'SET', path: path.concat(['divide']), value: value.toJson()};
  }
  deleteDivide(path) {
    return {type: 'DELETE', path: path.concat(['divide'])};
  }
  /**
   * @returns {ValidatorExpressions_MultiplyExpression}
   */
  get multiply() {
    return this._oneofTypeCase === 3 ? this._oneofTypeValue : ValidatorExpressions_MultiplyExpression.default;
  }
  setMultiply(path, value) {
    return {type: 'SET', path: path.concat(['multiply']), value: value.toJson()};
  }
  deleteMultiply(path) {
    return {type: 'DELETE', path: path.concat(['multiply'])};
  }
  /**
   * @returns {ValidatorExpressions_SubtractExpression}
   */
  get subtract() {
    return this._oneofTypeCase === 4 ? this._oneofTypeValue : ValidatorExpressions_SubtractExpression.default;
  }
  setSubtract(path, value) {
    return {type: 'SET', path: path.concat(['subtract']), value: value.toJson()};
  }
  deleteSubtract(path) {
    return {type: 'DELETE', path: path.concat(['subtract'])};
  }
  /**
   * @returns {ValidatorExpressions_AddExpression}
   */
  get add() {
    return this._oneofTypeCase === 5 ? this._oneofTypeValue : ValidatorExpressions_AddExpression.default;
  }
  setAdd(path, value) {
    return {type: 'SET', path: path.concat(['add']), value: value.toJson()};
  }
  deleteAdd(path) {
    return {type: 'DELETE', path: path.concat(['add'])};
  }
  /**
   * @returns {ValidatorExpressions_CompareExpression}
   */
  get compare() {
    return this._oneofTypeCase === 6 ? this._oneofTypeValue : ValidatorExpressions_CompareExpression.default;
  }
  setCompare(path, value) {
    return {type: 'SET', path: path.concat(['compare']), value: value.toJson()};
  }
  deleteCompare(path) {
    return {type: 'DELETE', path: path.concat(['compare'])};
  }
  /**
   * @returns {ValidatorExpressions_LogicNotExpression}
   */
  get logicNot() {
    return this._oneofTypeCase === 7 ? this._oneofTypeValue : ValidatorExpressions_LogicNotExpression.default;
  }
  setLogicNot(path, value) {
    return {type: 'SET', path: path.concat(['logicNot']), value: value.toJson()};
  }
  deleteLogicNot(path) {
    return {type: 'DELETE', path: path.concat(['logicNot'])};
  }
  /**
   * @returns {ValidatorExpressions_LogicAndExpression}
   */
  get logicAnd() {
    return this._oneofTypeCase === 8 ? this._oneofTypeValue : ValidatorExpressions_LogicAndExpression.default;
  }
  setLogicAnd(path, value) {
    return {type: 'SET', path: path.concat(['logicAnd']), value: value.toJson()};
  }
  deleteLogicAnd(path) {
    return {type: 'DELETE', path: path.concat(['logicAnd'])};
  }
  /**
   * @returns {ValidatorExpressions_LogicOrExpression}
   */
  get logicOr() {
    return this._oneofTypeCase === 9 ? this._oneofTypeValue : ValidatorExpressions_LogicOrExpression.default;
  }
  setLogicOr(path, value) {
    return {type: 'SET', path: path.concat(['logicOr']), value: value.toJson()};
  }
  deleteLogicOr(path) {
    return {type: 'DELETE', path: path.concat(['logicOr'])};
  }
  /**
   * @returns {ValidatorExpressions_NamedExpression}
   */
  get namedExpression() {
    return this._oneofTypeCase === 11 ? this._oneofTypeValue : ValidatorExpressions_NamedExpression.default;
  }
  setNamedExpression(path, value) {
    return {type: 'SET', path: path.concat(['namedExpression']), value: value.toJson()};
  }
  deleteNamedExpression(path) {
    return {type: 'DELETE', path: path.concat(['namedExpression'])};
  }
  /**
   * @returns {ValidatorExpressions_ExponentExpression}
   */
  get exponent() {
    return this._oneofTypeCase === 12 ? this._oneofTypeValue : ValidatorExpressions_ExponentExpression.default;
  }
  setExponent(path, value) {
    return {type: 'SET', path: path.concat(['exponent']), value: value.toJson()};
  }
  deleteExponent(path) {
    return {type: 'DELETE', path: path.concat(['exponent'])};
  }
  /**
   * @returns {ValidatorExpressions_ModuloExpression}
   */
  get modulo() {
    return this._oneofTypeCase === 13 ? this._oneofTypeValue : ValidatorExpressions_ModuloExpression.default;
  }
  setModulo(path, value) {
    return {type: 'SET', path: path.concat(['modulo']), value: value.toJson()};
  }
  deleteModulo(path) {
    return {type: 'DELETE', path: path.concat(['modulo'])};
  }
  /**
   * @returns {ValidatorExpressions_IfExpression}
   */
  get if() {
    return this._oneofTypeCase === 14 ? this._oneofTypeValue : ValidatorExpressions_IfExpression.default;
  }
  setIf(path, value) {
    return {type: 'SET', path: path.concat(['if']), value: value.toJson()};
  }
  deleteIf(path) {
    return {type: 'DELETE', path: path.concat(['if'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 1;
              copy._oneofTypeValue = ValidatorExpressions_Value.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 1) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 1) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 1;
            copy._oneofTypeValue = ValidatorExpressions_Value.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.value.apply(type, path.slice(1), value);
          if (newValue === this.value) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 1;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "divide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 2;
              copy._oneofTypeValue = ValidatorExpressions_DivideExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 2) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 2) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 2;
            copy._oneofTypeValue = ValidatorExpressions_DivideExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.divide.apply(type, path.slice(1), value);
          if (newValue === this.divide) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 2;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "multiply": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 3;
              copy._oneofTypeValue = ValidatorExpressions_MultiplyExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 3) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 3) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 3;
            copy._oneofTypeValue = ValidatorExpressions_MultiplyExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.multiply.apply(type, path.slice(1), value);
          if (newValue === this.multiply) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 3;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "subtract": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 4;
              copy._oneofTypeValue = ValidatorExpressions_SubtractExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 4) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 4) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 4;
            copy._oneofTypeValue = ValidatorExpressions_SubtractExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.subtract.apply(type, path.slice(1), value);
          if (newValue === this.subtract) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 4;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "add": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 5;
              copy._oneofTypeValue = ValidatorExpressions_AddExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 5) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 5) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 5;
            copy._oneofTypeValue = ValidatorExpressions_AddExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.add.apply(type, path.slice(1), value);
          if (newValue === this.add) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 5;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "compare": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 6;
              copy._oneofTypeValue = ValidatorExpressions_CompareExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 6) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 6) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 6;
            copy._oneofTypeValue = ValidatorExpressions_CompareExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.compare.apply(type, path.slice(1), value);
          if (newValue === this.compare) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 6;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "logicNot": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 7;
              copy._oneofTypeValue = ValidatorExpressions_LogicNotExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 7) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 7) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 7;
            copy._oneofTypeValue = ValidatorExpressions_LogicNotExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.logicNot.apply(type, path.slice(1), value);
          if (newValue === this.logicNot) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 7;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "logicAnd": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 8;
              copy._oneofTypeValue = ValidatorExpressions_LogicAndExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 8) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 8) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 8;
            copy._oneofTypeValue = ValidatorExpressions_LogicAndExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.logicAnd.apply(type, path.slice(1), value);
          if (newValue === this.logicAnd) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 8;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "logicOr": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 9;
              copy._oneofTypeValue = ValidatorExpressions_LogicOrExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 9) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 9) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 9;
            copy._oneofTypeValue = ValidatorExpressions_LogicOrExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.logicOr.apply(type, path.slice(1), value);
          if (newValue === this.logicOr) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 9;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "namedExpression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 11;
              copy._oneofTypeValue = ValidatorExpressions_NamedExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 11) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 11) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 11;
            copy._oneofTypeValue = ValidatorExpressions_NamedExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.namedExpression.apply(type, path.slice(1), value);
          if (newValue === this.namedExpression) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 11;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "exponent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 12;
              copy._oneofTypeValue = ValidatorExpressions_ExponentExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 12) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 12) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 12;
            copy._oneofTypeValue = ValidatorExpressions_ExponentExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.exponent.apply(type, path.slice(1), value);
          if (newValue === this.exponent) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 12;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "modulo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 13;
              copy._oneofTypeValue = ValidatorExpressions_ModuloExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 13) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 13) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 13;
            copy._oneofTypeValue = ValidatorExpressions_ModuloExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.modulo.apply(type, path.slice(1), value);
          if (newValue === this.modulo) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 13;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "if": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 14;
              copy._oneofTypeValue = ValidatorExpressions_IfExpression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._oneofTypeCase !== 14) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._oneofTypeCase = 0;
              copy._oneofTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._oneofTypeCase !== 14) {
            const copy = new ValidatorExpressions_Expression(this);
            copy._oneofTypeCase = 14;
            copy._oneofTypeValue = ValidatorExpressions_IfExpression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.if.apply(type, path.slice(1), value);
          if (newValue === this.if) {
            return this;
          }
          const copy = new ValidatorExpressions_Expression(this);
          copy._oneofTypeCase = 14;
          copy._oneofTypeValue = newValue;
          return copy;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ValidatorExpressions_Expression(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new ValidatorExpressions_Expression(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions_Expression} other
   * @returns {ValidatorExpressions_Expression}
   */
  merge(other) {
    const copy = new ValidatorExpressions_Expression(this);
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._oneofTypeCase === 1) {
      if (this._oneofTypeCase === 1) {
        copy._oneofTypeValue = copy._oneofTypeValue.merge(other._oneofTypeValue);
      } else {
        copy._oneofTypeValue = other._oneofTypeValue;
      }
      copy._oneofTypeCase = 1;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    return copy;
  }
}
ValidatorExpressions_Expression.default = new ValidatorExpressions_Expression();
class ValidatorExpressions_Expression_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions_Expression(value);
  }
  build() {
    return new ValidatorExpressions_Expression(this._value);
  }
  clearoneofType() {
    this._value._oneofTypeCase = 0;
    this._value._oneofTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._oneofTypeCase = 1;
    this._value._oneofTypeValue = value;
    return this;
  }
  setDivide(value) {
    this._value._oneofTypeCase = 2;
    this._value._oneofTypeValue = value;
    return this;
  }
  setMultiply(value) {
    this._value._oneofTypeCase = 3;
    this._value._oneofTypeValue = value;
    return this;
  }
  setSubtract(value) {
    this._value._oneofTypeCase = 4;
    this._value._oneofTypeValue = value;
    return this;
  }
  setAdd(value) {
    this._value._oneofTypeCase = 5;
    this._value._oneofTypeValue = value;
    return this;
  }
  setCompare(value) {
    this._value._oneofTypeCase = 6;
    this._value._oneofTypeValue = value;
    return this;
  }
  setLogicNot(value) {
    this._value._oneofTypeCase = 7;
    this._value._oneofTypeValue = value;
    return this;
  }
  setLogicAnd(value) {
    this._value._oneofTypeCase = 8;
    this._value._oneofTypeValue = value;
    return this;
  }
  setLogicOr(value) {
    this._value._oneofTypeCase = 9;
    this._value._oneofTypeValue = value;
    return this;
  }
  setNamedExpression(value) {
    this._value._oneofTypeCase = 11;
    this._value._oneofTypeValue = value;
    return this;
  }
  setExponent(value) {
    this._value._oneofTypeCase = 12;
    this._value._oneofTypeValue = value;
    return this;
  }
  setModulo(value) {
    this._value._oneofTypeCase = 13;
    this._value._oneofTypeValue = value;
    return this;
  }
  setIf(value) {
    this._value._oneofTypeCase = 14;
    this._value._oneofTypeValue = value;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
}
ValidatorExpressions_Expression.Builder = ValidatorExpressions_Expression_Builder;
class ValidatorExpressions_Expression_WithParent {
  /**
   * @param {ValidatorExpressions_Expression} value
   * @param {ValidatorExpressions_Expression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions_Expression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get oneofTypeCase() {
    if (this._cachedoneofTypeCase === undefined) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedoneofTypeCase = this._parent ? this._parent.oneofTypeCase : 0;
      } else {
        this._cachedoneofTypeCase = this._value._oneofTypeCase;
      }
    }
    return this._cachedoneofTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedValue = this._parent ? new ValidatorExpressions_Value.WithParent(ValidatorExpressions_Value.default, this._parent.value) : this._value.value;
      } else if (this._value._oneofTypeCase === 1) {
        this._cachedValue = new ValidatorExpressions_Value.WithParent(this._value.value, this._parent && this._parent.oneofTypeCase === 1 ? this._parent.value : null);
      } else {
        this._cachedValue = ValidatorExpressions_Value.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  get divide() {
    if (!this._cachedDivide) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedDivide = this._parent ? new ValidatorExpressions_DivideExpression.WithParent(ValidatorExpressions_DivideExpression.default, this._parent.divide) : this._value.divide;
      } else if (this._value._oneofTypeCase === 2) {
        this._cachedDivide = new ValidatorExpressions_DivideExpression.WithParent(this._value.divide, this._parent && this._parent.oneofTypeCase === 2 ? this._parent.divide : null);
      } else {
        this._cachedDivide = ValidatorExpressions_DivideExpression.WithParent.default;
      }
    }
    return this._cachedDivide;
  }
  get multiply() {
    if (!this._cachedMultiply) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedMultiply = this._parent ? new ValidatorExpressions_MultiplyExpression.WithParent(ValidatorExpressions_MultiplyExpression.default, this._parent.multiply) : this._value.multiply;
      } else if (this._value._oneofTypeCase === 3) {
        this._cachedMultiply = new ValidatorExpressions_MultiplyExpression.WithParent(this._value.multiply, this._parent && this._parent.oneofTypeCase === 3 ? this._parent.multiply : null);
      } else {
        this._cachedMultiply = ValidatorExpressions_MultiplyExpression.WithParent.default;
      }
    }
    return this._cachedMultiply;
  }
  get subtract() {
    if (!this._cachedSubtract) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedSubtract = this._parent ? new ValidatorExpressions_SubtractExpression.WithParent(ValidatorExpressions_SubtractExpression.default, this._parent.subtract) : this._value.subtract;
      } else if (this._value._oneofTypeCase === 4) {
        this._cachedSubtract = new ValidatorExpressions_SubtractExpression.WithParent(this._value.subtract, this._parent && this._parent.oneofTypeCase === 4 ? this._parent.subtract : null);
      } else {
        this._cachedSubtract = ValidatorExpressions_SubtractExpression.WithParent.default;
      }
    }
    return this._cachedSubtract;
  }
  get add() {
    if (!this._cachedAdd) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedAdd = this._parent ? new ValidatorExpressions_AddExpression.WithParent(ValidatorExpressions_AddExpression.default, this._parent.add) : this._value.add;
      } else if (this._value._oneofTypeCase === 5) {
        this._cachedAdd = new ValidatorExpressions_AddExpression.WithParent(this._value.add, this._parent && this._parent.oneofTypeCase === 5 ? this._parent.add : null);
      } else {
        this._cachedAdd = ValidatorExpressions_AddExpression.WithParent.default;
      }
    }
    return this._cachedAdd;
  }
  get compare() {
    if (!this._cachedCompare) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedCompare = this._parent ? new ValidatorExpressions_CompareExpression.WithParent(ValidatorExpressions_CompareExpression.default, this._parent.compare) : this._value.compare;
      } else if (this._value._oneofTypeCase === 6) {
        this._cachedCompare = new ValidatorExpressions_CompareExpression.WithParent(this._value.compare, this._parent && this._parent.oneofTypeCase === 6 ? this._parent.compare : null);
      } else {
        this._cachedCompare = ValidatorExpressions_CompareExpression.WithParent.default;
      }
    }
    return this._cachedCompare;
  }
  get logicNot() {
    if (!this._cachedLogicNot) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedLogicNot = this._parent ? new ValidatorExpressions_LogicNotExpression.WithParent(ValidatorExpressions_LogicNotExpression.default, this._parent.logicNot) : this._value.logicNot;
      } else if (this._value._oneofTypeCase === 7) {
        this._cachedLogicNot = new ValidatorExpressions_LogicNotExpression.WithParent(this._value.logicNot, this._parent && this._parent.oneofTypeCase === 7 ? this._parent.logicNot : null);
      } else {
        this._cachedLogicNot = ValidatorExpressions_LogicNotExpression.WithParent.default;
      }
    }
    return this._cachedLogicNot;
  }
  get logicAnd() {
    if (!this._cachedLogicAnd) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedLogicAnd = this._parent ? new ValidatorExpressions_LogicAndExpression.WithParent(ValidatorExpressions_LogicAndExpression.default, this._parent.logicAnd) : this._value.logicAnd;
      } else if (this._value._oneofTypeCase === 8) {
        this._cachedLogicAnd = new ValidatorExpressions_LogicAndExpression.WithParent(this._value.logicAnd, this._parent && this._parent.oneofTypeCase === 8 ? this._parent.logicAnd : null);
      } else {
        this._cachedLogicAnd = ValidatorExpressions_LogicAndExpression.WithParent.default;
      }
    }
    return this._cachedLogicAnd;
  }
  get logicOr() {
    if (!this._cachedLogicOr) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedLogicOr = this._parent ? new ValidatorExpressions_LogicOrExpression.WithParent(ValidatorExpressions_LogicOrExpression.default, this._parent.logicOr) : this._value.logicOr;
      } else if (this._value._oneofTypeCase === 9) {
        this._cachedLogicOr = new ValidatorExpressions_LogicOrExpression.WithParent(this._value.logicOr, this._parent && this._parent.oneofTypeCase === 9 ? this._parent.logicOr : null);
      } else {
        this._cachedLogicOr = ValidatorExpressions_LogicOrExpression.WithParent.default;
      }
    }
    return this._cachedLogicOr;
  }
  get namedExpression() {
    if (!this._cachedNamedExpression) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedNamedExpression = this._parent ? new ValidatorExpressions_NamedExpression.WithParent(ValidatorExpressions_NamedExpression.default, this._parent.namedExpression) : this._value.namedExpression;
      } else if (this._value._oneofTypeCase === 11) {
        this._cachedNamedExpression = new ValidatorExpressions_NamedExpression.WithParent(this._value.namedExpression, this._parent && this._parent.oneofTypeCase === 11 ? this._parent.namedExpression : null);
      } else {
        this._cachedNamedExpression = ValidatorExpressions_NamedExpression.WithParent.default;
      }
    }
    return this._cachedNamedExpression;
  }
  get exponent() {
    if (!this._cachedExponent) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedExponent = this._parent ? new ValidatorExpressions_ExponentExpression.WithParent(ValidatorExpressions_ExponentExpression.default, this._parent.exponent) : this._value.exponent;
      } else if (this._value._oneofTypeCase === 12) {
        this._cachedExponent = new ValidatorExpressions_ExponentExpression.WithParent(this._value.exponent, this._parent && this._parent.oneofTypeCase === 12 ? this._parent.exponent : null);
      } else {
        this._cachedExponent = ValidatorExpressions_ExponentExpression.WithParent.default;
      }
    }
    return this._cachedExponent;
  }
  get modulo() {
    if (!this._cachedModulo) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedModulo = this._parent ? new ValidatorExpressions_ModuloExpression.WithParent(ValidatorExpressions_ModuloExpression.default, this._parent.modulo) : this._value.modulo;
      } else if (this._value._oneofTypeCase === 13) {
        this._cachedModulo = new ValidatorExpressions_ModuloExpression.WithParent(this._value.modulo, this._parent && this._parent.oneofTypeCase === 13 ? this._parent.modulo : null);
      } else {
        this._cachedModulo = ValidatorExpressions_ModuloExpression.WithParent.default;
      }
    }
    return this._cachedModulo;
  }
  get if() {
    if (!this._cachedIf) {
      if (this._value._oneofTypeCase === 0) {
        this._cachedIf = this._parent ? new ValidatorExpressions_IfExpression.WithParent(ValidatorExpressions_IfExpression.default, this._parent.if) : this._value.if;
      } else if (this._value._oneofTypeCase === 14) {
        this._cachedIf = new ValidatorExpressions_IfExpression.WithParent(this._value.if, this._parent && this._parent.oneofTypeCase === 14 ? this._parent.if : null);
      } else {
        this._cachedIf = ValidatorExpressions_IfExpression.WithParent.default;
      }
    }
    return this._cachedIf;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_Expression_WithParent(current, parent);
    if (this._cachedValue && this._value._oneofTypeCase === 1 && current._oneofTypeCase === 1) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.oneofTypeCase === 1 ? parent.value : null);
      }
    }
    if (this._cachedDivide && this._value._oneofTypeCase === 2 && current._oneofTypeCase === 2) {
      if (this._value.divide === current.divide && this._parent === parent) {
        result._cachedDivide = this._cachedDivide;
      } else {
        result._cachedDivide = this._cachedDivide.update(current.divide, parent && parent.oneofTypeCase === 2 ? parent.divide : null);
      }
    }
    if (this._cachedMultiply && this._value._oneofTypeCase === 3 && current._oneofTypeCase === 3) {
      if (this._value.multiply === current.multiply && this._parent === parent) {
        result._cachedMultiply = this._cachedMultiply;
      } else {
        result._cachedMultiply = this._cachedMultiply.update(current.multiply, parent && parent.oneofTypeCase === 3 ? parent.multiply : null);
      }
    }
    if (this._cachedSubtract && this._value._oneofTypeCase === 4 && current._oneofTypeCase === 4) {
      if (this._value.subtract === current.subtract && this._parent === parent) {
        result._cachedSubtract = this._cachedSubtract;
      } else {
        result._cachedSubtract = this._cachedSubtract.update(current.subtract, parent && parent.oneofTypeCase === 4 ? parent.subtract : null);
      }
    }
    if (this._cachedAdd && this._value._oneofTypeCase === 5 && current._oneofTypeCase === 5) {
      if (this._value.add === current.add && this._parent === parent) {
        result._cachedAdd = this._cachedAdd;
      } else {
        result._cachedAdd = this._cachedAdd.update(current.add, parent && parent.oneofTypeCase === 5 ? parent.add : null);
      }
    }
    if (this._cachedCompare && this._value._oneofTypeCase === 6 && current._oneofTypeCase === 6) {
      if (this._value.compare === current.compare && this._parent === parent) {
        result._cachedCompare = this._cachedCompare;
      } else {
        result._cachedCompare = this._cachedCompare.update(current.compare, parent && parent.oneofTypeCase === 6 ? parent.compare : null);
      }
    }
    if (this._cachedLogicNot && this._value._oneofTypeCase === 7 && current._oneofTypeCase === 7) {
      if (this._value.logicNot === current.logicNot && this._parent === parent) {
        result._cachedLogicNot = this._cachedLogicNot;
      } else {
        result._cachedLogicNot = this._cachedLogicNot.update(current.logicNot, parent && parent.oneofTypeCase === 7 ? parent.logicNot : null);
      }
    }
    if (this._cachedLogicAnd && this._value._oneofTypeCase === 8 && current._oneofTypeCase === 8) {
      if (this._value.logicAnd === current.logicAnd && this._parent === parent) {
        result._cachedLogicAnd = this._cachedLogicAnd;
      } else {
        result._cachedLogicAnd = this._cachedLogicAnd.update(current.logicAnd, parent && parent.oneofTypeCase === 8 ? parent.logicAnd : null);
      }
    }
    if (this._cachedLogicOr && this._value._oneofTypeCase === 9 && current._oneofTypeCase === 9) {
      if (this._value.logicOr === current.logicOr && this._parent === parent) {
        result._cachedLogicOr = this._cachedLogicOr;
      } else {
        result._cachedLogicOr = this._cachedLogicOr.update(current.logicOr, parent && parent.oneofTypeCase === 9 ? parent.logicOr : null);
      }
    }
    if (this._cachedNamedExpression && this._value._oneofTypeCase === 11 && current._oneofTypeCase === 11) {
      if (this._value.namedExpression === current.namedExpression && this._parent === parent) {
        result._cachedNamedExpression = this._cachedNamedExpression;
      } else {
        result._cachedNamedExpression = this._cachedNamedExpression.update(current.namedExpression, parent && parent.oneofTypeCase === 11 ? parent.namedExpression : null);
      }
    }
    if (this._cachedExponent && this._value._oneofTypeCase === 12 && current._oneofTypeCase === 12) {
      if (this._value.exponent === current.exponent && this._parent === parent) {
        result._cachedExponent = this._cachedExponent;
      } else {
        result._cachedExponent = this._cachedExponent.update(current.exponent, parent && parent.oneofTypeCase === 12 ? parent.exponent : null);
      }
    }
    if (this._cachedModulo && this._value._oneofTypeCase === 13 && current._oneofTypeCase === 13) {
      if (this._value.modulo === current.modulo && this._parent === parent) {
        result._cachedModulo = this._cachedModulo;
      } else {
        result._cachedModulo = this._cachedModulo.update(current.modulo, parent && parent.oneofTypeCase === 13 ? parent.modulo : null);
      }
    }
    if (this._cachedIf && this._value._oneofTypeCase === 14 && current._oneofTypeCase === 14) {
      if (this._value.if === current.if && this._parent === parent) {
        result._cachedIf = this._cachedIf;
      } else {
        result._cachedIf = this._cachedIf.update(current.if, parent && parent.oneofTypeCase === 14 ? parent.if : null);
      }
    }
    return result;
  }
}
ValidatorExpressions_Expression_WithParent.default = new ValidatorExpressions_Expression_WithParent(ValidatorExpressions_Expression.default, null);
ValidatorExpressions_Expression.WithParent = ValidatorExpressions_Expression_WithParent;
class ValidatorExpressions_Expression_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 11,
        protoName: "value",
        oneofIndex: 0,
        type: ValidatorExpressions_Value,
        options: {
          comments: "These are the types of values you can include or reference in expression formulas.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get divide() {
    if (!this._divide) {
      this._divide = {
        name: "divide",
        Name: "Divide",
        number: 2,
        protoType: 11,
        protoName: "divide",
        oneofIndex: 0,
        type: ValidatorExpressions_DivideExpression,
        options: {
          comments: "Divide a value by another.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._divide;
  }
  get multiply() {
    if (!this._multiply) {
      this._multiply = {
        name: "multiply",
        Name: "Multiply",
        number: 3,
        protoType: 11,
        protoName: "multiply",
        oneofIndex: 0,
        type: ValidatorExpressions_MultiplyExpression,
        options: {
          comments: "Multiply multiple values together. Supports nested expressions.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._multiply;
  }
  get subtract() {
    if (!this._subtract) {
      this._subtract = {
        name: "subtract",
        Name: "Subtract",
        number: 4,
        protoType: 11,
        protoName: "subtract",
        oneofIndex: 0,
        type: ValidatorExpressions_SubtractExpression,
        options: {
          comments: "Subtract a value from another.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subtract;
  }
  get add() {
    if (!this._add) {
      this._add = {
        name: "add",
        Name: "Add",
        number: 5,
        protoType: 11,
        protoName: "add",
        oneofIndex: 0,
        type: ValidatorExpressions_AddExpression,
        options: {
          comments: "Add multiple values together. Supports nested expressions.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._add;
  }
  get compare() {
    if (!this._compare) {
      this._compare = {
        name: "compare",
        Name: "Compare",
        number: 6,
        protoType: 11,
        protoName: "compare",
        oneofIndex: 0,
        type: ValidatorExpressions_CompareExpression,
        options: {
          comments: "Compares two values/expressions and returns true or false based on the result.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._compare;
  }
  get logicNot() {
    if (!this._logicNot) {
      this._logicNot = {
        name: "logicNot",
        Name: "LogicNot",
        number: 7,
        protoType: 11,
        protoName: "logic_not",
        oneofIndex: 0,
        type: ValidatorExpressions_LogicNotExpression,
        options: {
          comments: "Returns the flipped value or expression (true becomes false, false becomes true).",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._logicNot;
  }
  get logicAnd() {
    if (!this._logicAnd) {
      this._logicAnd = {
        name: "logicAnd",
        Name: "LogicAnd",
        number: 8,
        protoType: 11,
        protoName: "logic_and",
        oneofIndex: 0,
        type: ValidatorExpressions_LogicAndExpression,
        options: {
          comments: "Returns true if all listed values/expressions are true.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._logicAnd;
  }
  get logicOr() {
    if (!this._logicOr) {
      this._logicOr = {
        name: "logicOr",
        Name: "LogicOr",
        number: 9,
        protoType: 11,
        protoName: "logic_or",
        oneofIndex: 0,
        type: ValidatorExpressions_LogicOrExpression,
        options: {
          comments: "Returns true if any listed values/expressions are true.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._logicOr;
  }
  get namedExpression() {
    if (!this._namedExpression) {
      this._namedExpression = {
        name: "namedExpression",
        Name: "NamedExpression",
        number: 11,
        protoType: 11,
        protoName: "named_expression",
        oneofIndex: 0,
        type: ValidatorExpressions_NamedExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._namedExpression;
  }
  get exponent() {
    if (!this._exponent) {
      this._exponent = {
        name: "exponent",
        Name: "Exponent",
        number: 12,
        protoType: 11,
        protoName: "exponent",
        oneofIndex: 0,
        type: ValidatorExpressions_ExponentExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._exponent;
  }
  get modulo() {
    if (!this._modulo) {
      this._modulo = {
        name: "modulo",
        Name: "Modulo",
        number: 13,
        protoType: 11,
        protoName: "modulo",
        oneofIndex: 0,
        type: ValidatorExpressions_ModuloExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modulo;
  }
  get if() {
    if (!this._if) {
      this._if = {
        name: "if",
        Name: "If",
        number: 14,
        protoType: 11,
        protoName: "if",
        oneofIndex: 0,
        type: ValidatorExpressions_IfExpression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._if;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.divide,
        this.multiply,
        this.subtract,
        this.add,
        this.compare,
        this.logicNot,
        this.logicAnd,
        this.logicOr,
        this.namedExpression,
        this.exponent,
        this.modulo,
        this.if,
        this.comment,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "oneofType",
        Name: "OneofType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
          this.fields[9],
          this.fields[10],
          this.fields[11],
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[13],
        ],
      });
    }
    return this._oneofs;
  }
}
ValidatorExpressions_Expression.descriptor = new ValidatorExpressions_Expression_Descriptor();
class ValidatorExpressions_UnitLocation {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "CASTER_UNIT": return 0;
        case "SOURCE_UNIT": return 1;
        case "TARGET_UNIT": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return ValidatorExpressions_UnitLocation.fromJson(value);
  }
  static fromReact(e) {
    return ValidatorExpressions_UnitLocation.fromJson(e);
  }
}
ValidatorExpressions_UnitLocation.CASTER_UNIT = 0;
ValidatorExpressions_UnitLocation.SOURCE_UNIT = 1;
ValidatorExpressions_UnitLocation.TARGET_UNIT = 2;
ValidatorExpressions_UnitLocation.default = 0;
ValidatorExpressions_UnitLocation.values = {
  CASTER_UNIT: 0,
  SOURCE_UNIT: 1,
  TARGET_UNIT: 2,
};
ValidatorExpressions_UnitLocation.names = {
  0: "CASTER_UNIT",
  1: "SOURCE_UNIT",
  2: "TARGET_UNIT",
};
export class ValidatorExpressions {
  get descriptor() {
    return ValidatorExpressions.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
  }
  isEmpty() {
    return true;
  }
  static fromAny(value) {
    if (value instanceof ValidatorExpressions) {
      return value;
    }
    return ValidatorExpressions.fromJson(value);
  }
  static fromJson(json) {
    const result = new ValidatorExpressions();
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    return result;
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      default:
        return this;
    }
  }
  /**
   * @param {ValidatorExpressions} other
   * @returns {ValidatorExpressions}
   */
  merge(other) {
    const copy = new ValidatorExpressions(this);
    return copy;
  }
}
ValidatorExpressions.default = new ValidatorExpressions();
ValidatorExpressions.RangeInt = ValidatorExpressions_RangeInt;
ValidatorExpressions.RangeDouble = ValidatorExpressions_RangeDouble;
ValidatorExpressions.BehaviorStackCountValue = ValidatorExpressions_BehaviorStackCountValue;
ValidatorExpressions.BehaviorElapsedTimeValue = ValidatorExpressions_BehaviorElapsedTimeValue;
ValidatorExpressions.BehaviorDurationValue = ValidatorExpressions_BehaviorDurationValue;
ValidatorExpressions.TagCount = ValidatorExpressions_TagCount;
ValidatorExpressions.HealthValue = ValidatorExpressions_HealthValue;
ValidatorExpressions.MaxHealthValue = ValidatorExpressions_MaxHealthValue;
ValidatorExpressions.HealthFraction = ValidatorExpressions_HealthFraction;
ValidatorExpressions.ManaValue = ValidatorExpressions_ManaValue;
ValidatorExpressions.MaxManaValue = ValidatorExpressions_MaxManaValue;
ValidatorExpressions.ManaFraction = ValidatorExpressions_ManaFraction;
ValidatorExpressions.ShieldValue = ValidatorExpressions_ShieldValue;
ValidatorExpressions.MaxShieldValue = ValidatorExpressions_MaxShieldValue;
ValidatorExpressions.ShieldFraction = ValidatorExpressions_ShieldFraction;
ValidatorExpressions.UnitLevel = ValidatorExpressions_UnitLevel;
ValidatorExpressions.UnitAbilityCooldown = ValidatorExpressions_UnitAbilityCooldown;
ValidatorExpressions.AbilityLevel = ValidatorExpressions_AbilityLevel;
ValidatorExpressions.DataUpgradeLevel = ValidatorExpressions_DataUpgradeLevel;
ValidatorExpressions.ConstantValue = ValidatorExpressions_ConstantValue;
ValidatorExpressions.DamageAmountValue = ValidatorExpressions_DamageAmountValue;
ValidatorExpressions.HealAmountValue = ValidatorExpressions_HealAmountValue;
ValidatorExpressions.RemainingPathDistanceValue = ValidatorExpressions_RemainingPathDistanceValue;
ValidatorExpressions.RandomValue = ValidatorExpressions_RandomValue;
ValidatorExpressions.EffectCriticalHitValue = ValidatorExpressions_EffectCriticalHitValue;
ValidatorExpressions.Value = ValidatorExpressions_Value;
ValidatorExpressions.DivideExpression = ValidatorExpressions_DivideExpression;
ValidatorExpressions.MultiplyExpression = ValidatorExpressions_MultiplyExpression;
ValidatorExpressions.SubtractExpression = ValidatorExpressions_SubtractExpression;
ValidatorExpressions.AddExpression = ValidatorExpressions_AddExpression;
ValidatorExpressions.CompareExpression = ValidatorExpressions_CompareExpression;
ValidatorExpressions.LogicNotExpression = ValidatorExpressions_LogicNotExpression;
ValidatorExpressions.LogicAndExpression = ValidatorExpressions_LogicAndExpression;
ValidatorExpressions.LogicOrExpression = ValidatorExpressions_LogicOrExpression;
ValidatorExpressions.NamedExpression = ValidatorExpressions_NamedExpression;
ValidatorExpressions.ExponentExpression = ValidatorExpressions_ExponentExpression;
ValidatorExpressions.ModuloExpression = ValidatorExpressions_ModuloExpression;
ValidatorExpressions.IfExpression = ValidatorExpressions_IfExpression;
ValidatorExpressions.Expression = ValidatorExpressions_Expression;
ValidatorExpressions.UnitLocation = ValidatorExpressions_UnitLocation;
class ValidatorExpressions_Builder {
  constructor(value) {
    this._value = new ValidatorExpressions(value);
  }
  build() {
    return new ValidatorExpressions(this._value);
  }
}
ValidatorExpressions.Builder = ValidatorExpressions_Builder;
class ValidatorExpressions_WithParent {
  /**
   * @param {ValidatorExpressions} value
   * @param {ValidatorExpressions_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ValidatorExpressions.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  update(current, parent) {
    const result = new ValidatorExpressions_WithParent(current, parent);
    return result;
  }
}
ValidatorExpressions_WithParent.default = new ValidatorExpressions_WithParent(ValidatorExpressions.default, null);
ValidatorExpressions.WithParent = ValidatorExpressions_WithParent;
class ValidatorExpressions_Descriptor {
  get fields() {
    if (!this._fields) {
      this._fields = [
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ValidatorExpressions.descriptor = new ValidatorExpressions_Descriptor();
